import { Component, createRef } from "react";
import axios from "axios";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import CreateIcon from "@material-ui/icons/Create";
import { connect } from "react-redux";
import localization from "../../../localization/enUS";

import { addSettings } from "../../../actions";
import {
  listSharelinks,
  getSharelinkTheme,
  getSharelinkServices,
  getSharelinkLogos,
  getSharelinkSettings,
  saveSharelinkDetail,
  saveSharelinkTheme,
  saveSharelinkServices,
  getSharelinkBundles,
  saveSharelinkBundles,
  saveSharelinkLogos,
  saveSharelinkContact,
  saveSharelinkSocial,
  saveSharelinkSEO,
  saveSharelinkAbout,
  regenerateSharelink,
  sendEmailSharelink,
  getSharelinkStats,
  getDomains,
  connectSharelinkSubmit,
  getAssignedDomain,
  getContactLogs,
  getLeadLogs,
  saveSharelinkOtherSettings,
  saveSharelinkTestimonials,
  getSharelinkTestimonials,
  saveNewTestimonial,
  updateTestimonial,
  deleteTestimonial,
  listServiceTypes,
  saveLeadForm,
  getSharelinkComment,
  deleteSharelinkComment,
  deleteSharelink,
} from "./../../../config/shortlink_api_calls";

import $ from "jquery";
import DataTable from "../../../components/Tables/DataTable";
import DataTableSmall from "../../../components/Tables/DataTableSmall";
import { tableLoaderListing } from "../../../components/ContentLoaders/table_loader_listing";
import { tableLoaderBlockImage } from "../../../components/ContentLoaders/table_loader_imageblock";
import { tableLoaderSimple } from "../../../components/ContentLoaders/table_loader_simple";
import { tableLoaderLine } from "../../../components/ContentLoaders/table_loader_line";
import { FormLoader } from "../../../components/ContentLoaders/newLoaders/FormLoader";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import { ValidateEmail } from "../../../config/utility";
import {
  THEME_TEXT_COLOR,
  THEME_COLOR,
  APP_LIVE_URL,
  API_URL,
} from "./../../../config/config";
import { CopyToClipboard } from "react-copy-to-clipboard";
import MutextField from "@material-ui/core/TextField";
//import { Editor } from "@tinymce/tinymce-react";
//import { CKEditor } from "@ckeditor/ckeditor5-react";
//import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import RichTextEditorComponent from "../../../components/Reseller/RichTextEditorComponent";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Switch from "@material-ui/core/Switch";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControl from "@material-ui/core/FormControl";
import SelectTab from "@material-ui/core/Select";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import dateFormat, { masks } from "dateformat";
import QRCode from "qrcode.react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/build/index.css";
import Select from "react-select";
import "./sharelink-tabs-mobile.css";

import Autocomplete from "@material-ui/lab/Autocomplete";
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import NotificationToast from "../../../components/Notification/NotificationToast";

const auth = new HelperClass();

const LEAD_FORM_FIELD_KEYS = [
  "company_name",
  "industry",
  "website",
  "address",
  "full_name",
  "job_title",
  "email",
  "phone",
  // "deal_value",
  // "stage",
  // "priority",
  // "source",
  // "lead_score",
  // "next_action_date",
  // "partner",
  // "partner_rep",
  "products_of_interest",
  "notes",
];

const LEGACY_LEAD_FORM_FIELD_MAP = {
  company_name: ["company_name", "company"],
  notes: ["notes", "message"],
};

const LEAD_FORM_FIELD_LABELS = {
  company_name: "Company Name",
  industry: "Industry",
  website: "Website",
  address: "Address",
  full_name: "Full Name",
  job_title: "Job Title",
  email: "Email",
  phone: "Phone",
  deal_value: "Deal Value",
  stage: "Stage",
  priority: "Priority",
  source: "Source",
  lead_score: "Lead Score",
  next_action_date: "Next Action Date",
  partner: "Partner",
  partner_rep: "Partner Rep",
  products_of_interest: "Products Of Interest",
  notes: "Notes/Comments",
};

const LEAD_FORM_SECTIONS = [
  {
    title: "Company Information",
    fields: ["company_name", "industry", "website", "address"],
  },
  {
    title: "Primary Contact",
    fields: ["full_name", "job_title", "email", "phone"],
  },
  // {
  //   title: "Lead Details",
  //   fields: [
  //     "deal_value",
  //     "stage",
  //     "priority",
  //     "source",
  //     "lead_score",
  //     "next_action_date",
  //   ],
  // },
  // {
  //   title: "Partner",
  //   fields: ["partner", "partner_rep"],
  // },
  {
    title: "Additional Information",
    fields: ["products_of_interest", "notes"],
  },
];

const getDefaultLeadFormSettings = () => ({
  enabled: true,
  collapsed: false,
  submitButtonText: "",
  successMessage: "Lead submitted successfully",
  showOnBanner: true,
  showOnContactPage: true,
  fields: {
    company_name: { enabled: true, required: true },
    industry: { enabled: true, required: false },
    website: { enabled: true, required: false },
    address: { enabled: true, required: false },
    full_name: { enabled: true, required: true },
    job_title: { enabled: true, required: false },
    email: { enabled: true, required: true },
    phone: { enabled: true, required: false },
    deal_value: { enabled: true, required: false },
    stage: { enabled: true, required: false },
    priority: { enabled: true, required: false },
    source: { enabled: true, required: false },
    lead_score: { enabled: true, required: false },
    next_action_date: { enabled: true, required: false },
    partner: { enabled: true, required: false },
    partner_rep: { enabled: true, required: false },
    products_of_interest: { enabled: true, required: false },
    notes: { enabled: true, required: false },
  },
});

class Sharelink extends Component {
  constructor() {
    super();

    this.state = {
      tableData: [],
      tableDataContactLogs: [],
      tableDataLeadLogs: [],
      serviceData: [],
      selected_bundle: [],
      bundlesData: [],
      defaultServices: [],
      toastMessage: "",
      toastType: "success",
      toastTitle: "",
      errorMessage: "",
      uErrorMessage: "",
      uSuccessMessage: "",
      linkSuccessMessage: "",
      linkErrorMessage: "",
      getThemeErrorMessage: "",
      getServiceErrorMessage: "",
      getBundleErrorMessage: "",
      getLogoErrorMessage: "",
      getAboutErrorMessage: "",
      getContactErrorMessage: "",
      getSocialErrorMessage: "",
      getSeoErrorMessage: "",
      docErrorMessage: "",
      docSuccessMessage: "",
      formLoader: true,
      showImageLoader: false,
      edit_picture: "",
      edit_picture_name: "",
      edit_images_type: "logo",
      edit_image_title: "",
      serviceId: "",
      successMessage: "",
      waitMessage: "",
      tableLoaderListing: true,
      tableLoaderBlockImage: true,
      tableLoaderBlockService: true,
      tableLoaderBlockBundle: true,
      tableLoaderBlockLogo: true,
      tableLoaderBlockAbout: true,
      tableLoaderBlockSocial: true,
      tableLoaderBlockContact: true,
      tableLoaderBlockLeadForm: true,
      tableLoaderBlockSEO: true,
      tableLoaderLine: true,
      eErrorMessage: "",
      eSuccessMessage: "",
      copied: false,
      cpied_value: "",
      send_email: "",
      title: "",
      status: "",
      landing_page: "",
      // buttonColor: "",
      theme_color: "",
      about_me_settings: false,
      contact_settings: false,
      social_settings: false,
      lead_form_settings: getDefaultLeadFormSettings(),
      theme: "",
      meta_description: "",
      meta_title: "",
      slug: "",
      ogImage: "",
      robotsIndex: true,
      canonicalUrl: "",
      schemaJsonError: "",
      selectedSeoPage: "home",
      seo_pages: {
        home: {
          meta_title: "",
          meta_description: "",
          meta_og_image: "",
          canonical_url: "",
          schema_json: "",
          og_title: "",
          og_description: "",
          twitter_card: "summary_large_image",
          robots: "index, follow",
          schema_type: "Article",
          keywords: [],
          content_summary: "",
        },
        about: {
          meta_title: "",
          meta_description: "",
          meta_og_image: "",
          canonical_url: "",
          schema_json: "",
          og_title: "",
          og_description: "",
          twitter_card: "summary_large_image",
          robots: "index, follow",
          schema_type: "Article",
          keywords: [],
          content_summary: "",
        },
        services: {
          meta_title: "",
          meta_description: "",
          meta_og_image: "",
          canonical_url: "",
          schema_json: "",
          og_title: "",
          og_description: "",
          twitter_card: "summary_large_image",
          robots: "index, follow",
          schema_type: "Article",
          keywords: [],
          content_summary: "",
        },
        contact: {
          meta_title: "",
          meta_description: "",
          meta_og_image: "",
          canonical_url: "",
          schema_json: "",
          og_title: "",
          og_description: "",
          twitter_card: "summary_large_image",
          robots: "index, follow",
          schema_type: "Article",
          keywords: [],
          content_summary: "",
        },
        process: {
          meta_title: "",
          meta_description: "",
          meta_og_image: "",
          canonical_url: "",
          schema_json: "",
          og_title: "",
          og_description: "",
          twitter_card: "summary_large_image",
          robots: "index, follow",
          schema_type: "Article",
          keywords: [],
          content_summary: "",
        },
      },
      sharelink_id: "",
      complete_link: "",
      themesList: [],
      selected_service: [],
      select_logo: false,
      select_avatar: false,
      selected_logo: "",
      selected_avatar: "",
      avatarData: [],
      about_me_short: "",
      about_me: "",
      instagram_link: "",
      facebook_link: "",
      twitter_link: "",
      linkedin_link: "",
      youtube_link: "",
      settingData: [],
      logoData: [],
      reg_button: false,
      reg_email_button: false,
      sharelink2_id: "",
      signup_link: "",
      show_regenerate: "",
      custom_link: "",
      email_to: "",
      contact_address: auth.getAddress(),
      contact_email: auth.getEmail(),
      contact_phone: auth.getPhone(),
      stat_hits: 0,
      last_visit: "",
      statErrorMessage: "",
      available_domains: [],
      btn_loader: false,
      assigned_domain: "",
      sharelink_limit: 0,
      sharelink_added: 0,
      select_banner: false,
      selected_banner: "",
      bannerData: [],
      selected_background_image: "",
      backgroundImageData: [],
      selected_background_image2: "",
      backgroundImage2Data: [],
      emailError: "",
      phoneError: "",
      addressError: "",
      instagramError: "",
      facebookError: "",
      twitterError: "",
      linkedinError: "",
      youtubeError: "",
      isEditorReady: false,
      brightness: 100,
      showBrightnessRange: false,
      other_settings: {},
      original_other_settings: {},
      selected_avatar2: "",
      avatarData2: [],

      currentPage: {
        avatar: 1,
        avatar2: 1,
        logo: 1,
        banner: 1,
        backgroundImage: 1,
        backgroundImage2: 1,
      },
      avatarsPerPage: 3,
      currentPageAvatar: 1,
      currentPageAvatar2: 1,
      currentPageBanner: 1,
      currentPageLogo: 1,
      currentPageBackgroundImage: 1,
      currentPageBackgroundImage2: 1,

      all_service_types: [],
      selected_service_types: [],
      service_type_id: [],

      tableData_comment: [],
      invitation_comment: "",
      comment_id: "",
      sharelink_id_to_delete: "",
      name: "",
      loading_text: "",

      isAddingTestimonial: false,
      testimonials: [],
      selectedTestimonials: [],
      testimonial_name: "",
      testimonial_title: "",
      testimonial_comment: "",
      testimonial_img: "",
      selectedImageName: "",
      testimonialErrors: {
        nameError: "",
        titleError: "",
        commentError: "",
      },
      save_testimonial_btn_disable: false,
      anchorEl: null,
      selectedRowId: null,
      selectedRowStatus: null,
      selectedRowData: null,
      menuType: "",
      selectedTabMobile: "tab-1",
      columnTestimonials: [
        { name: "Id", options: { display: false } },
        {
          name: "Select",
          options: {
            customBodyRender: (value, tableMeta) => {
              return (
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={this.handleTestimonialSelection(
                        tableMeta.rowData[0],
                      )}
                      color="primary"
                      checked={
                        Array.isArray(this.state.selectedTestimonials) &&
                        this.state.selectedTestimonials.includes(
                          tableMeta.rowData[0],
                        )
                      }
                    />
                  }
                />
              );
            },
          },
        },

        { name: "Name" },
        { name: "Title" },
        { name: "Comment" },
        {
          name: "Image",
          options: {
            customBodyRender: (value, tableMeta) => {
              return (
                <div>
                  {tableMeta.rowData[5] && tableMeta.rowData[5] !== "" ? (
                    <img
                      style={{
                        height: "50px",
                        width: "auto",
                      }}
                      src={`${APP_LIVE_URL}files_data/sharelinks/${tableMeta.rowData[5]}`}
                      alt="Testimonial Image"
                    />
                  ) : (
                    <span>-</span>
                  )}
                </div>
              );
            },
          },
        },
        {
          name: "Actions",
          options: {
            customBodyRender: (value, tableMeta) => {
              return (
                <div>
                  <IconButton
                    onClick={(event) =>
                      this.handleMenuOpen(
                        event,
                        value,
                        null,
                        tableMeta.rowData,
                        "testimonials",
                      )
                    }
                    style={{
                      border: "1px solid #dbdfea",
                      borderRadius: "6px",
                      padding: "6px",
                      backgroundColor: "#fff",
                      outline: "none",
                    }}
                    size="small"
                  >
                    <MoreHorizIcon />
                  </IconButton>
                </div>
              );
            },
          },
        },
      ],
      columnServices: [
        {
          name: "Title",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return (
                <div>
                  {/* Add onClick function to the title */}
                  <a
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      this.showDetails(tableMeta.rowData[10], tableMeta)
                    }
                  >
                    {value}
                  </a>
                </div>
              );
            },
          },
        },
        { name: "Date Added",
           options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.format_date(value)}</div>;
            },
          },
         },
        { name: "Last Visit",
           options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.format_date(value)}</div>;
            },
          },
         },
        {
          name: "Total Hits",
        },
        {
          name: "About Me",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.defaultSettings(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "Contact Settings",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.defaultSettings(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "Social Settings",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.defaultSettings(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "Status",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.defaultText(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "Landing Page",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.landinPage(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: localization.sharelinkPage.agentLabel + " Link",
          options: {
            customBodyRender: (value, tableMeta) => {
              return (
                <>
                  <a
                    style={{ cursor: "pointer", color: "#0000EE" }}
                    onClick={() => this.agentLink(value, tableMeta)}
                    title={`Agent ${localization.sharelinkPage.label_single}`}
                    disabled={
                      this.props.is_msa_signed === "No" ||
                        this.props.defaultSettings === "missing"
                        ? true
                        : false
                    }
                  >
                    View
                    <em
                      className="icon ni ni-external-alt"
                      style={{ marginLeft: "3px" }}
                    ></em>
                  </a>
                </>
              );
              // return (
              //   <div>
              //     <div
              //       className="nk-tb-col nk-tb-col-tools"
              //       style={{ padding: "0px" }}
              //     >
              //       <ul className="nk-tb-actions gx-1">
              //         <li>
              //           <div className="">
              //             <a
              //               style={{ cursor: "pointer" }}
              //               onClick={() => this.agentLink(value, tableMeta)}
              //               title="Agent Share Link"
              //               disabled={
              //                 this.props.is_msa_signed === "No" ||
              //                 this.props.defaultSettings === "missing"
              //                   ? true
              //                   : false
              //               }
              //               className=" btn btn-icon  btn-outline-light"
              //             >
              //               <em className="icon ni ni-link-h"></em>
              //             </a>
              //           </div>
              //         </li>
              //       </ul>
              //     </div>
              //   </div>
              // );
            },
          },
        },
        {
          name: "Actions",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              const landingPageValue = tableMeta.rowData[8];
              return (
                <div>
                  <IconButton
                    onClick={(event) =>
                      this.handleMenuOpen(
                        event,
                        value,
                        landingPageValue,
                        tableMeta.rowData,
                        "sharelinks",
                      )
                    }
                    style={{
                      border: "1px solid #dbdfea",
                      borderRadius: "6px",
                      padding: "6px",
                      backgroundColor: "#fff",
                      outline: "none",
                    }}
                    disabled={
                      this.props.is_msa_signed === "No" ||
                        this.props.defaultSettings === "missing"
                        ? true
                        : false
                    }
                    size="small"
                  >
                    <MoreHorizIcon />
                  </IconButton>
                </div>
              );
            },
          },
        },
      ],
      columnContactLogs: [
        { name: "Date Added"
          ,
           options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.format_date(value)}</div>;
            },
          },
         },
        { name: "Name" },
        { name: "Email" },

        { name: "Phone" },
        { name: "Subject" },
        { name: "Message" },
      ],

      columnLeadLogs: [
        {
          name: "Date Added",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              // Match the Lead Detail "Created" formatting exactly (browser-local).
              return <div>{value ? new Date(value).toLocaleString() : ""}</div>;
            },
          },
        },
        { name: "Lead UID" },
        { name: "Status" },
        { name: "Priority" },
      ],

      columnComment: [
        {
          name: "#",
          options: {
            customBodyRender: (value, tableMeta) => {
              return <span>{tableMeta.rowIndex + 1}</span>;
            },
          },
        },
        {
          name: "Name",
          options: {
            customBodyRender: (value) => {
              return (
                <span>{value && value.trim() !== "" ? value : "---"}</span>
              );
            },
          },
        },

        { name: "Email" },
        {
          name: "Comment",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return (
                <div onClick={() => this.assignedTo(value, tableMeta)}>
                  <span
                    className="badge badge-outline-secondary"
                    style={{ cursor: "pointer" }}
                  >
                    View
                  </span>
                </div>
              );
            },
          },
        },
        { name: "Date Added",
           options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.format_date(value)}</div>;
            },
          }, },
        {
          name: "Actions",
          options: {
            customBodyRender: (value, tableMeta) => {
              let comment_id = tableMeta.rowData[0];
              return (
                <div>
                  <IconButton
                    onClick={(event) =>
                      this.handleMenuOpen(
                        event,
                        comment_id,
                        null,
                        tableMeta.rowData,
                        "comments",
                      )
                    }
                    style={{
                      border: "1px solid #dbdfea",
                      borderRadius: "6px",
                      padding: "6px",
                      backgroundColor: "#fff",
                      outline: "none",
                    }}
                    size="small"
                  >
                    <MoreHorizIcon />
                  </IconButton>
                </div>
              );
            },
          },
        },
      ],
    };
    this.cropperRef = createRef();
    this.phoneInputRef = createRef();
  }

  // A sharelink is system-protected when it is the Default Agent sharelink
  // (is_default = 1, row index 12) or the Master Agent sharelink
  // (main_sharelink = 1, row index 13). These cannot be edited.
  isProtectedSharelink = (sharelinkId) => {
    const rows = this.state.tableData || [];
    const row = rows.find((r) => r[10] === sharelinkId);
    return (
      !!row &&
      (parseInt(row[12], 10) === 1 || parseInt(row[13], 10) === 1)
    );
  };

  showDetails = async (value, tableMeta) => {
    if (this.isProtectedSharelink(value)) {
      this.showToast(
        "Default and Master Agent sharelinks are system-protected and cannot be modified.",
        "warning",
        "Warning",
      );
      return;
    }
    this.setState({
      sharelink_id: "",
    });
    let services_data = this.state.tableData;
    // console.log("value: ", value, ", services_data: ", services_data);
    for (let i = 0; i < services_data.length; i++) {
      if (services_data[i][10] === value) {
        // console.log(
        //   "value: ",
        //   value,
        //   ", services_data[i][10]: ",
        //   services_data[i][10]
        // );
        let about_setting = false;
        if (services_data[i][4] === "Yes") {
          about_setting = true;
        }
        let cont_setting = false;
        if (services_data[i][5] === "Yes") {
          cont_setting = true;
        }
        let sm_setting = false;
        if (services_data[i][6] === "Yes") {
          sm_setting = true;
        }
        this.setState({
          sharelink_id: services_data[i][10],
          title: services_data[i][0],
          status: services_data[i][7],
          about_me_settings: about_setting,
          contact_settings: cont_setting,
          social_settings: sm_setting,
          complete_link: services_data[i][9],
          landing_page: services_data[i][8],
          loading_text: services_data[i][11],
          buttonColor: "",
          theme_color: "",
        });
      }
    }

    //$('a[href="#tab-1"]').click();
    $("#detail_tabs ul li a").removeClass("active"); // remove from all buttons
    $(".tab-content .tab-pane").removeClass("active"); // remove from all tabs

    $("#detail_tabs ul li a[href='#tab-1']").addClass("active"); // add to the targeted button
    $(".tab-content #tab-1").addClass("active"); // add to the targedted tabs
    //console.log("title: ", this.state.title);
    window.$("#modalDetails").modal("show");
  };

  format_date = (value, tableMeta) => {
    let date = value;
    return dateFormat(date, "mm-dd-yyyy h:MM TT");
  };

  agentLink = (value, tableMeta) => {
    let agent_link = tableMeta.rowData[9];
    let sharelink_id = tableMeta.rowData[10];
    this.getAssignedDomain(sharelink_id);
    // console.log("agent_link: ", agent_link);
    this.setState({
      copied: false,
      signup_link: agent_link,
      sharelink2_id: sharelink_id,
      name: "",
      invitation_comment: "",
      email_to: "",
      send_email: "0",
    });
    window.$("#modalSignupLink").modal("show");
  };

  defaultText = (value, tableMeta) => {
    //console.log("tableMeta.rowData: ", tableMeta.rowData[9]);
    let is_default = tableMeta.rowData[7];

    if (is_default === 0) {
      return (
        <span className="badge badge-outline-danger">
          <em className="icon ni ni-na"></em> Inactive
        </span>
      );
    } else {
      return (
        <span className="badge badge-outline-success">
          <em className="icon ni ni-done"></em> Active
        </span>
      );
    }
  };

  landinPage = (value, tableMeta) => {
    //console.log("tableMeta.rowData: ", tableMeta.rowData[9]);
    let is_default = tableMeta.rowData[8];

    if (is_default === "No") {
      return (
        <span className="badge badge-outline-danger">
          <em className="icon ni ni-na"></em> No
        </span>
      );
    } else {
      return (
        <span className="badge badge-outline-success">
          <em className="icon ni ni-done"></em> Yes
        </span>
      );
    }
  };

  defaultSettings = (value, tableMeta) => {
    let is_default = value;
    if (is_default === "No") {
      return (
        <span className="badge badge-outline-warning">
          <em className="icon ni ni-na"></em> No
        </span>
      );
    } else {
      return (
        <span className="badge badge-outline-success">
          <em className="icon ni ni-done"></em> Yes
        </span>
      );
    }
  };

  getAssignedDomain = async (sharelink_id) => {
    const servicesResponce = await getAssignedDomain(
      auth.getAccount(),
      auth.getToken(),
      sharelink_id,
    );
    // console.log("getAssignedDomain: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "errors"
    ) {
      this.setState({
        tableLoaderLine: false,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        assigned_domain: "https://" + servicesResponce.data.domain,
        tableLoaderLine: false,
      });
    } else {
      this.setState({
        tableLoaderLine: false,
      });
    }
  };

  sharelinkStats = async (value, tableMeta) => {
    let sharelink_id = tableMeta.rowData[10];
    const servicesResponce = await getSharelinkStats(
      auth.getAccount(),
      auth.getToken(),
      sharelink_id,
    );
    //console.log("sharelinkStats: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "errors"
    ) {
      this.setState({
        statErrorMessage: servicesResponce.data.data,
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        statErrorMessage: "",

        stat_hits: servicesResponce.data.hits,
        last_visit: servicesResponce.data.last_visit,
      });
      //modalStats
      window.$("#modalStats").modal("show");
    } else {
      this.setState({
        statErrorMessage: "There is some error while getting the stats.",
      });
      // window.location.replace("/error");
    }
  };

  contactLogs = async (value, tableMeta) => {
    let sharelink_id = tableMeta.rowData[10];
    const servicesResponce = await getContactLogs(
      auth.getAccount(),
      auth.getToken(),
      sharelink_id,
    );
    this.setState({
      tableDataContactLogs: [],
    });
    //console.log("contactLogs: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "errors"
    ) {
      this.setState({
        tableDataContactLogs: [],
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        tableDataContactLogs: servicesResponce.data.data,
        tableLoaderListing: false,
      });
      //modalStats
      window.$("#modalContactLogs").modal("show");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "not_found"
    ) {
      this.setState({
        tableDataContactLogs: [],
      });
      //modalStats
      window.$("#modalContactLogs").modal("show");
    } else {
      this.setState({
        tableDataContactLogs: [],
      });
      // window.location.replace("/error");
    }
  };

  leadLogs = async (value, tableMeta) => {
    let sharelink_id = tableMeta.rowData[10];
    const servicesResponce = await getLeadLogs(
      auth.getAccount(),
      auth.getToken(),
      sharelink_id,
    );
    this.setState({
      tableDataLeadLogs: [],
    });
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "errors"
    ) {
      this.setState({
        tableDataLeadLogs: [],
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        tableDataLeadLogs: servicesResponce.data.data,
        tableLoaderListing: false,
      });
      window.$("#modalLeadLogs").modal("show");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "not_found"
    ) {
      this.setState({
        tableDataLeadLogs: [],
      });
      window.$("#modalLeadLogs").modal("show");
    } else {
      this.setState({
        tableDataLeadLogs: [],
      });
    }
  };

  send_email = async () => {
    const {
      sharelink2_id,
      email_to,
      assigned_domain,
      invitation_comment,
      name,
    } = this.state;

    this.setState({
      reg_email_button: true,
    });
    if (name === "") {
      this.setState({ reg_email_button: false });
      this.showToast("Please enter the name.", "error");
    } else if (email_to === "") {
      this.setState({ reg_email_button: false });
      this.showToast("Please enter the email address.", "error");
    } else if (ValidateEmail(email_to) === false) {
      this.setState({ reg_email_button: false });
      this.showToast("Invalid email format.", "error");
    } else if (invitation_comment === "") {
      this.setState({ reg_email_button: false });
      this.showToast("Please enter the comment.", "error");
    } else {
      const servicesResponce = await sendEmailSharelink(
        auth.getAccount(),
        auth.getToken(),
        sharelink2_id,
        email_to,
        this.state.signup_link,
        assigned_domain,
        invitation_comment,
        name,
      );
      // console.log("send_email: ", servicesResponce.data);

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        servicesResponce.data.status === 404 &&
        servicesResponce.data.message === "errors"
      ) {
        this.setState({ reg_email_button: false });
        this.showToast(servicesResponce.data.data, "error");
        //window.location.replace("/error");
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState({
          reg_email_button: false,
          email_to: "",
          invitation_comment: "",
          name: "",
          //send_email: ""
        });
        this.showToast(
          `${localization.sharelinkPage.label_single} sent successfully.`,
          "success"
        );
      } else {
        this.setState({ reg_email_button: false });
        this.showToast(
          `There is some error while emailing the ${localization.sharelinkPage.text_single}.`,
          "error"
        );
        // window.location.replace("/error");
      }
    }
  };

  handleMenuOpen = (event, rowId, rowStatus, rowData, menuType) => {
    this.setState({
      anchorEl: event.currentTarget,
      selectedRowId: rowId,
      selectedRowStatus: rowStatus,
      selectedRowData: rowData,
      menuType: menuType,
    });
  };

  handleMenuClose = () => {
    this.setState({
      anchorEl: null,
      selectedRowId: null,
      selectedRowStatus: null,
      selectedRowData: null,
      menuType: "",
    });
  };

  resetMobileTab = () => {
    this.setState({ selectedTabMobile: "tab-1" });
  };

  showToast = (message, type = "error", title) => {
    this.setState({ toastMessage: "" }, () =>
      this.setState({
        toastMessage: message,
        toastType: type,
        toastTitle: title || (type === "success" ? "Success" : "Error"),
      })
    );
  };

  async componentDidMount() {
    window.addEventListener("scroll", this.handleMenuClose);
    window.$("#modalDetails").on("hidden.bs.modal", this.resetMobileTab);
    await this.loadSharelinks();
    window.$('#detail_tabs a[data-toggle="tab"]').on('shown.bs.tab', this.syncTabFromSidebar);
  }

  loadSharelinks = async () => {
    const servicesResponce = await listSharelinks(
      auth.getAccount(),
      auth.getToken(),
    );
    // console.log("listSharelinks: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        tableData: [],
        tableLoaderListing: false,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        tableData: servicesResponce.data.data,
        tableLoaderListing: false,
        sharelink_added: servicesResponce.data.data.length,
        sharelink_limit: servicesResponce.data.sharelink_limit,
      });
    } else {
      this.setState({
        tableData: [],
        tableLoaderListing: false,
      });
    }
  };

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleMenuClose);
    window.$("#modalDetails").off("hidden.bs.modal", this.resetMobileTab);
    window.$('#detail_tabs a[data-toggle="tab"]').off('shown.bs.tab', this.syncTabFromSidebar);
  }

  syncTabFromSidebar = (e) => {
    const href = window.$(e.target).attr('href'); // "#tab-2"
    if (href) this.setState({ selectedTabMobile: href.replace('#', '') });
  };

  switchTab = (tabId) => {
    this.setState({ selectedTabMobile: tabId });
    const tabElement = document.querySelector(`a[href="#${tabId}"]`);
    if (tabElement) tabElement.click();
  };

  handleTabChange = (event) => {
    const selectedTab = event.target.value;
    this.setState({ selectedTabMobile: selectedTab });

    // Trigger the corresponding function based on selected tab
    switch (selectedTab) {
      case "tab-1":
        // Detail tab - no function needed
        break;
      case "tab-2":
        this.getSharelinkTheme();
        break;
      case "tab-3":
        this.getSharelinkServices();
        break;
      case "tab-8":
        this.getSharelinkLogos();
        break;
      case "tab-4":
        this.getSharelinkSettings("about");
        break;
      case "tab-5":
        this.getSharelinkSettings("social");
        break;
      case "tab-6":
        this.getSharelinkSettings("contact");
        break;
      case "tab-11":
        this.getSharelinkSettings("lead_form");
        break;
      case "tab-7":
        this.getSharelinkSettings("seo");
        break;
      case "tab-10":
        this.getSharelinkSettings("testimonials");
        break;
      case "tab-9":
        this.getSharelinkSettings("seo");
        break;
      default:
        break;
    }
  };

  listSharelinkComment = async (value, tableMeta) => {
    let sharelink_id = tableMeta.rowData[10];
    this.setState({
      sharelink_id: sharelink_id,
    });
    const servicesResponce = await getSharelinkComment(
      auth.getAccount(),
      auth.getToken(),
      sharelink_id,
    );
    // console.log("getSharelinkComment: ", servicesResponce.data);

    window.$("#modalComment").modal("show");

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        tableData_comment: [],
        tableLoaderListing: false,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        tableData_comment: servicesResponce.data.data,
        tableLoaderListing: false,
      });
    } else {
      this.setState({
        tableData_comment: [],
        tableLoaderListing: false,
      });
    }
  };

  reloadSharelinkComment = async () => {
    const servicesResponce = await getSharelinkComment(
      auth.getAccount(),
      auth.getToken(),
      this.state.sharelink_id,
    );
    // console.log("getSharelinkComment: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        tableData_comment: [],
        tableLoaderListing: false,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        tableData_comment: servicesResponce.data.data,
        tableLoaderListing: false,
      });
    } else {
      this.setState({
        tableData_comment: [],
        tableLoaderListing: false,
      });
    }
  };

  assignedTo = (value, tableMeta) => {
    let invitation_comment = tableMeta.rowData[3];
    this.setState(
      {
        invitation_comment: invitation_comment,
      },
      () => {
        window.$("#modalInvitationComment").modal("show");
      },
    );
  };

  modalHideDel = () => {
    window.$("#modalDeleteAlert").modal("hide");
  };

  groupBy = (arr, property) => {
    let intArray = arr;
    let evenArray = [];
    intArray.map((x) => {
      if (x.images_type === property) {
        evenArray.push(x);
      }
    });

    return evenArray;
  };

  handleEditorChange = (updatedContent) => {
    this.setState({
      about_me: updatedContent,
    });
  };

  handleEditorChangeShort = (updatedContent) => {
    this.setState({
      about_me_short: updatedContent,
    });
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  open_add_form = () => {
    window.$("#modalAddSharelink").modal("show");
  };

  show_email = () => {
    this.setState({
      send_email: "1",
      show_regenerate: "",
    });
  };

  normalizeXLink = (value) =>
    value
      .replace(/^https:\/\/(?:www\.)?twitter\.com\//, "https://x.com/")
      .replace(/^https:\/\/www\.x\.com\//, "https://x.com/");

  // Treat a bare base profile URL (e.g. "https://www.facebook.com/") the same
  // as an empty value so it does not get flagged as an invalid link.
  isBaseSocialUrl = (value, base) => {
    const trimmed = value.trim().replace(/\/+$/, "");
    return trimmed === "" || trimmed === base;
  };

  handleChange = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;

    const { name } = target;

    if (name === "selectedSeoPage") {
      this.handleSeoPageChange(event);
      return;
    }

    if (name === "robotsIndex") {
      this.updateSeoPageField(
        "robots",
        value ? "index, follow" : "noindex, nofollow",
      );
      return;
    }

    if (name === "schema_json") {
      this.updateSeoPageField("schema_json", value);

      if (typeof value !== "string" || value.trim() === "") {
        this.setState({ schemaJsonError: "" });
      } else {
        try {
          JSON.parse(value);
          this.setState({ schemaJsonError: "" });
        } catch (error) {
          this.setState({ schemaJsonError: "Schema JSON must be valid JSON." });
        }
      }

      return;
    }

    const seoFieldMap = {
      meta_title: "meta_title",
      meta_description: "meta_description",
      ogImage: "meta_og_image",
      canonicalUrl: "canonical_url",
      og_title: "og_title",
      og_description: "og_description",
      twitter_card: "twitter_card",
      robots: "robots",
      schema_type: "schema_type",
      schema_json: "schema_json",
      content_summary: "content_summary",
    };

    if (seoFieldMap[name]) {
      this.updateSeoPageField(seoFieldMap[name], value);
      return;
    }

    if (name === "keywords_text") {
      const keywordsArray =
        typeof value === "string" && value.trim() !== ""
          ? value
              .split(",")
              .map((item) => item.trim())
              .filter(Boolean)
          : [];
      this.updateSeoPageField("keywords", keywordsArray);
      return;
    }

    if (name === "contact_email") {
      if (value.trim() !== "") {
        const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
        this.setState({
          [name]: value,
          emailError: isValidEmail ? "" : "Invalid email address",
        });
        return;
      } else {
        this.setState({
          [name]: value,
          emailError: "",
        });
      }
    }

    if (name === "contact_phone") {
      if (value.trim() !== "") {
        const isValidPhone = /^\+?\d{7,}$/.test(value);
        this.setState({
          [name]: value,
          phoneError: isValidPhone ? "" : "Invalid phone number",
        });
        return;
      } else {
        this.setState({
          [name]: value,
          phoneError: "",
        });
      }
    }

    if (name === "contact_address") {
      if (value.trim() !== "") {
        const isValidAddress =
          value.trim().length >= 5 && !/^\d+$/.test(value.trim());
        this.setState({
          [name]: value,
          addressError: isValidAddress ? "" : "Invalid address",
        });
      } else {
        this.setState({
          [name]: value,
          addressError: "",
        });
      }
    }

    if (name === "instagram_link") {
      if (!this.isBaseSocialUrl(value, "https://www.instagram.com")) {
        const instagramRegex =
          /^https:\/\/www\.instagram\.com\/[a-zA-Z0-9_]{4,}\/?$/;
        const isValidInstagramLink = instagramRegex.test(value);
        this.setState({
          [name]: value,
          instagramError: isValidInstagramLink ? "" : "Invalid Instagram link",
        });
      } else {
        this.setState({
          [name]: value,
          instagramError: "",
        });
      }
      return;
    }

    if (name === "facebook_link") {
      if (!this.isBaseSocialUrl(value, "https://www.facebook.com")) {
        const facebookRegex =
          /^https:\/\/www\.facebook\.com\/[a-zA-Z0-9_.-]{4,}\/?$/;
        const isValidfacebookLink = facebookRegex.test(value);
        this.setState({
          [name]: value,
          facebookError: isValidfacebookLink ? "" : "Invalid Facebook link",
        });
      } else {
        this.setState({
          [name]: value,
          facebookError: "",
        });
      }
      return;
    }

    if (name === "twitter_link") {
      const normalizedValue = this.normalizeXLink(value);
      if (!this.isBaseSocialUrl(normalizedValue, "https://x.com")) {
        const twitterRegex = /^https:\/\/x\.com\/[a-zA-Z0-9_]{4,}\/?$/;
        const isValidtwitterLink = twitterRegex.test(normalizedValue);
        this.setState({
          [name]: normalizedValue,
          twitterError: isValidtwitterLink ? "" : "Invalid X link",
        });
      } else {
        this.setState({
          [name]: normalizedValue,
          twitterError: "",
        });
      }
      return;
    }

    if (name === "linkedin_link") {
      if (!this.isBaseSocialUrl(value, "https://www.linkedin.com")) {
        const linkedinRegex =
          /^https:\/\/www\.linkedin\.com\/in\/[a-zA-Z0-9_.-]{4,}\/?$/;
        const isValidlinkedinLink = linkedinRegex.test(value);
        this.setState({
          [name]: value,
          linkedinError: isValidlinkedinLink ? "" : "Invalid Linkedin link",
        });
      } else {
        this.setState({
          [name]: value,
          linkedinError: "",
        });
      }
      return;
    }

    if (name === "youtube_link") {
      if (!this.isBaseSocialUrl(value, "https://www.youtube.com")) {
        const youtubeRegex =
          /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|playlist\?list=|channel\/)|youtu\.be\/)[\w-]{4,}/;
        const isValidyoutubeLink = youtubeRegex.test(value);
        this.setState({
          [name]: value,
          youtubeError: isValidyoutubeLink ? "" : "Invalid Youtube link",
        });
      } else {
        this.setState({
          [name]: value,
          youtubeError: "",
        });
      }
      return;
    }

    // if (name === "youtube_link") {
    //   if (value.trim() !== "") {
    //     const youtubeRegex =
    //       /^https:\/\/www\.youtube\.com\/channel\/[a-zA-Z0-9_-]{4,}\/?$/;
    //     const isValidyoutubeLink = youtubeRegex.test(value);
    //     this.setState({
    //       [name]: value,
    //       youtubeError: isValidyoutubeLink ? "" : "Invalid Youtube link",
    //     });
    //   } else {
    //     this.setState({
    //       [name]: value,
    //       youtubeError: "",
    //     });
    //   }
    //   return;
    // }

    if (name === "edit_images_type") {
      const inputElement = document.getElementById("edit_picture");
      if (inputElement) {
        const selectedFile = inputElement.files[0];
        if (selectedFile) {
          inputElement.value = null;
          this.setState({
            docErrorMessage: "",
            edit_picture: "",
            edit_picture_name: "",
          });
        }
      }
    }
    if (name === "buttonColor") {
      this.setState({
        buttonColor: value,
      });
    } else {
      this.setState({
        [name]: value,
      });
    }
  };

  getSeoPageKeys = () => ["home", "about", "services", "contact", "process"];

  getDefaultSeoPage = (fallback = {}) => ({
    meta_title: fallback.meta_title || this.state.meta_title || "",
    meta_description: fallback.meta_description || this.state.meta_description || "",
    meta_og_image: fallback.meta_og_image || this.state.ogImage || "",
    canonical_url: fallback.canonical_url || this.state.canonicalUrl || "",
    schema_json:
      typeof fallback.schema_json === "string"
        ? fallback.schema_json
        : "",
    og_title: fallback.og_title || "",
    og_description: fallback.og_description || "",
    twitter_card: fallback.twitter_card || "summary_large_image",
    robots: fallback.robots || "index, follow",
    schema_type:
      typeof fallback.schema_type === "string"
        ? fallback.schema_type
        : "Article",
    keywords: Array.isArray(fallback.keywords) ? fallback.keywords : [],
    content_summary: fallback.content_summary || "",
  });

  getNormalizedSeoPages = (seoPagesInput = null, fallbackInput = null) => {
    const seoPages = seoPagesInput || this.state.seo_pages || {};
    const fallbackPage = this.getDefaultSeoPage(fallbackInput || {});
    const normalized = {};

    this.getSeoPageKeys().forEach((page) => {
      const pageData = seoPages[page] && typeof seoPages[page] === "object" ? seoPages[page] : {};
      const keywords = pageData.keywords;
      const schemaJson = pageData.schema_json;
      normalized[page] = {
        ...fallbackPage,
        ...pageData,
        schema_json:
          typeof schemaJson === "string"
            ? schemaJson
            : typeof fallbackPage.schema_json === "string"
              ? fallbackPage.schema_json
              : "",
        keywords: Array.isArray(keywords)
          ? keywords
          : typeof keywords === "string" && keywords.trim() !== ""
            ? keywords
                .split(",")
                .map((item) => item.trim())
                .filter(Boolean)
            : [],
      };
    });

    return normalized;
  };

  getCurrentSeoPageData = () => {
    const seoPages = this.getNormalizedSeoPages();
    const page = this.state.selectedSeoPage || "home";
    return seoPages[page] || this.getDefaultSeoPage();
  };

  getKeywordsText = () => {
    const currentSeoPage = this.getCurrentSeoPageData();
    return Array.isArray(currentSeoPage.keywords)
      ? currentSeoPage.keywords.join(", ")
      : "";
  };

  validateSchemaJson = (seoPagesInput = null) => {
    const seoPages = this.getNormalizedSeoPages(seoPagesInput);

    for (const page of this.getSeoPageKeys()) {
      const schemaJson = seoPages?.[page]?.schema_json;
      if (typeof schemaJson !== "string" || schemaJson.trim() === "") {
        continue;
      }

      try {
        JSON.parse(schemaJson);
      } catch (error) {
        return {
          isValid: false,
          invalidPage: page,
          message: `Schema JSON is invalid for ${page} page.`,
        };
      }
    }

    return { isValid: true, invalidPage: "", message: "" };
  };

  updateSeoPageField = (field, value) => {
    this.setState((prevState) => {
      const page = prevState.selectedSeoPage || "home";
      const nextSeoPages = this.getNormalizedSeoPages(prevState.seo_pages);
      nextSeoPages[page] = {
        ...nextSeoPages[page],
        [field]: value,
      };

      const nextState = {
        seo_pages: nextSeoPages,
      };

      if (field === "robots") {
        const robotsValue = (value || "").toLowerCase();
        nextState.robotsIndex = robotsValue.includes("index");
      }

      if (page === "home") {
        if (field === "meta_title") {
          nextState.meta_title = value;
        }
        if (field === "meta_description") {
          nextState.meta_description = value;
        }
        if (field === "meta_og_image") {
          nextState.ogImage = value;
        }
        if (field === "canonical_url") {
          nextState.canonicalUrl = value;
        }
      }

      return nextState;
    });
  };

  handleSeoPageChange = (event) => {
    const selectedSeoPage = event.target.value;
    const seoPages = this.getNormalizedSeoPages();
    const selectedPageData = seoPages[selectedSeoPage] || this.getDefaultSeoPage();

    this.setState({
      selectedSeoPage,
      seo_pages: seoPages,
      robotsIndex: (selectedPageData.robots || "").toLowerCase().includes("index"),
      schemaJsonError: "",
    });
  };

  buildSeoPagesPayload = () => this.getNormalizedSeoPages();

  getNormalizedLeadFormSettings = (input = null) => {
    const incoming = input || this.state.lead_form_settings || {};
    const defaults = getDefaultLeadFormSettings();
    const normalized = {
      enabled:
        typeof incoming.enabled === "boolean"
          ? incoming.enabled
          : defaults.enabled,
      collapsed:
        typeof incoming.collapsed === "boolean"
          ? incoming.collapsed
          : defaults.collapsed,
      submitButtonText:
        typeof incoming.submitButtonText === "string" &&
        incoming.submitButtonText.trim() !== ""
          ? incoming.submitButtonText
          : defaults.submitButtonText,
      successMessage:
        typeof incoming.successMessage === "string" &&
        incoming.successMessage.trim() !== ""
          ? incoming.successMessage
          : defaults.successMessage,
      showOnBanner:
        typeof incoming.showOnBanner === "boolean"
          ? incoming.showOnBanner
          : defaults.showOnBanner,
      showOnContactPage:
        typeof incoming.showOnContactPage === "boolean"
          ? incoming.showOnContactPage
          : defaults.showOnContactPage,
      fields: {},
    };

    LEAD_FORM_FIELD_KEYS.forEach((fieldKey) => {
      const defaultField = defaults.fields[fieldKey];
      const aliases = LEGACY_LEAD_FORM_FIELD_MAP[fieldKey] || [fieldKey];
      let incomingField = null;

      if (incoming.fields && typeof incoming.fields === "object") {
        for (const alias of aliases) {
          if (incoming.fields[alias] && typeof incoming.fields[alias] === "object") {
            incomingField = incoming.fields[alias];
            break;
          }
        }
      }
      const enabled =
        incomingField && typeof incomingField.enabled === "boolean"
          ? incomingField.enabled
          : defaultField.enabled;
      const required =
        incomingField && typeof incomingField.required === "boolean"
          ? incomingField.required
          : defaultField.required;

      normalized.fields[fieldKey] = {
        enabled,
        required: enabled ? required : false,
      };
    });

    return normalized;
  };

  handleLeadFormRootToggle = (name) => (event) => {
    const checked = event.target.checked;
    this.setState((prevState) => ({
      lead_form_settings: {
        ...this.getNormalizedLeadFormSettings(prevState.lead_form_settings),
        [name]: checked,
      },
    }));
  };

  handleLeadFormTextChange = (event) => {
    const { name, value } = event.target;
    this.setState((prevState) => ({
      lead_form_settings: {
        ...this.getNormalizedLeadFormSettings(prevState.lead_form_settings),
        [name]: value,
      },
    }));
  };

  handleLeadFormFieldToggle = (fieldKey, keyName) => (event) => {
    const checked = event.target.checked;
    this.setState((prevState) => {
      const current = this.getNormalizedLeadFormSettings(prevState.lead_form_settings);
      const nextField = {
        ...current.fields[fieldKey],
        [keyName]: checked,
      };

      if (keyName === "enabled" && !checked) {
        nextField.required = false;
      }

      if (keyName === "required" && checked) {
        nextField.enabled = true;
      }

      return {
        lead_form_settings: {
          ...current,
          fields: {
            ...current.fields,
            [fieldKey]: nextField,
          },
        },
      };
    });
  };

  clearSocialMediaLinks = () => {
    this.setState({
      instagram_link: "",
      facebook_link: "",
      twitter_link: "",
      linkedin_link: "",
      youtube_link: "",
      instagramError: "",
      facebookError: "",
      twitterError: "",
      linkedinError: "",
      youtubeError: "",
    });
  };

  setTheme = (id) => {
    //console.log("Theme: ", id);
    this.setState(
      {
        theme: id,
      },
      () => {
        // Fetch new other_settings for the selected theme
        this.getSharelinkSettings("other_settings");
      },
    );
  };

  setThemeClass = (id) => {
    //console.log("setThemeClass: ", this.state.theme + " " + id);
    if (this.state.theme === id) {
      return "read active";
    } else {
      return "read";
    }
  };

  setThemeClassMain = (id) => {
    if (this.state.theme === id) {
      return "pricingTable active2";
    } else {
      return "pricingTable";
    }
  };

  setService = (id) => {
    //console.log("Service: ", id);
    if (this.state.selected_service.includes(id)) {
      var checked = this.state.selected_service;
      var values = checked.indexOf(id);
      checked.splice(values, 1);
      this.setState({ selected_service: checked });
    } else {
      this.setState({
        selected_service: [...this.state.selected_service, id],
      });
    }
  };

  setServiceClass = (id) => {
    if (this.state.selected_service.includes(id)) {
      return "btn btn-primary active3";
    } else {
      return "btn btn-dim btn-white btn-outline-primary";
    }
  };

  setServiceClassMain = (id) => {
    if (this.state.selected_service.includes(id)) {
      return "card card-bordered sp-plan active2";
    } else {
      return "card card-bordered sp-plan";
    }
    /*if (this.state.selected_service.includes(id)) {
      return "pricingTable active2";
    } else {
      return "pricingTable";
    }*/
  };

  setBundleClassMainNew = (id) => {
    if (this.state.selected_bundle.includes(id)) {
      return "card card-bordered sp-plan active2";
    } else {
      return "card card-bordered sp-plan";
    }
  };

  setBundleClassNew = (id) => {
    if (this.state.selected_bundle.includes(id)) {
      return "btn btn-primary active3";
    } else {
      return "btn btn-dim btn-white btn-outline-primary";
    }
  };

  setBundles = (id) => {
    //console.log("Service: ", id);
    if (this.state.selected_bundle.includes(id)) {
      var checked = this.state.selected_bundle;
      var values = checked.indexOf(id);
      checked.splice(values, 1);
      this.setState({ selected_bundle: checked });
    } else {
      this.setState({
        selected_bundle: [...this.state.selected_bundle, id],
      });
    }
  };

  setLogo = (id) => {
    //console.log("Logo: ", id);
    this.setState({
      selected_logo: id,
    });
  };

  setLogoClass = (id) => {
    if (this.state.selected_logo === id) {
      return "read active";
    } else {
      return "read";
    }
  };

  setLogoClassMain = (id) => {
    if (this.state.selected_logo === id) {
      return "pricingTable active2";
    } else {
      return "pricingTable";
    }
  };

  setAvatar = (id) => {
    this.setState({
      selected_avatar: id,
    });
  };

  setAvatarClass = (id) => {
    if (this.state.selected_avatar === id) {
      return "read active";
    } else {
      return "read";
    }
  };

  setAvatarClassMain = (id) => {
    if (this.state.selected_avatar === id) {
      return "pricingTable active2";
    } else {
      return "pricingTable";
    }
  };

  setAvatar2 = (id) => {
    this.setState({
      selected_avatar2: id,
    });
  };

  setAvatar2Class = (id) => {
    if (this.state.selected_avatar2 === id) {
      return "read active";
    } else {
      return "read";
    }
  };

  setAvatar2ClassMain = (id) => {
    if (this.state.selected_avatar2 === id) {
      return "pricingTable active2";
    } else {
      return "pricingTable";
    }
  };

  setBanner = (id) => {
    // Toggle: re-clicking the selected banner clears it (deselect).
    this.setState((s) => ({
      selected_banner: s.selected_banner === id ? "" : id,
    }));
  };

  setBannerClass = (id) => {
    if (this.state.selected_banner === id) {
      return "read active";
    } else {
      return "read";
    }
  };

  setBannerClassMain = (id) => {
    if (this.state.selected_banner === id) {
      return "pricingTable active2";
    } else {
      return "pricingTable";
    }
  };

  setBackgroundImage = (id) => {
    this.setState({
      selected_background_image: id,
    });
  };

  setBackgroundImageClass = (id) => {
    if (this.state.selected_background_image === id) {
      return "read active";
    } else {
      return "read";
    }
  };

  setBackgroundImageClassMain = (id) => {
    if (this.state.selected_background_image === id) {
      return "pricingTable active2";
    } else {
      return "pricingTable";
    }
  };

  setBackgroundImage2 = (id) => {
    this.setState({
      selected_background_image2: id,
    });
  };

  setBackgroundImage2Class = (id) => {
    if (this.state.selected_background_image2 === id) {
      return "read active";
    } else {
      return "read";
    }
  };

  setBackgroundImage2ClassMain = (id) => {
    if (this.state.selected_background_image2 === id) {
      return "pricingTable active2";
    } else {
      return "pricingTable";
    }
  };

  getSharelinkTheme = async () => {
    const { theme, sharelink_id } = this.state;
    this.setState({
      tableLoaderBlockImage: true,
      getThemeErrorMessage: "",
    });
    const servicesResponce = await getSharelinkTheme(
      auth.getAccount(),
      auth.getToken(),
      sharelink_id,
      theme,
    );
    //console.log("sharelink_id: ", sharelink_id);
    // console.log("getSharelinkTheme: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "not_found"
    ) {
      this.setState({
        tableLoaderBlockImage: false,
        getThemeErrorMessage: "Theme not found.",
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        themesList: servicesResponce.data.data,
        theme: servicesResponce.data.theme,
        tableLoaderBlockImage: false,
        getThemeErrorMessage: "",
        buttonColor:
          this.state.buttonColor || servicesResponce.data.theme_color || "",
        theme_color: servicesResponce.data.theme_color || "",
      });
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "sharelink_not_found"
    ) {
      this.setState({
        themesList: [],
        theme: "",
        tableLoaderBlockImage: false,
        getThemeErrorMessage: `${localization.sharelinkPage.label_single} does not exist or Landing page setting is set to No. Please click ${localization.sharelinkPage.label_single} Detail tab, select Landing Page to Yes and Save Details.`,
      });
    } else {
      this.setState({
        tableLoaderBlockImage: false,
        getThemeErrorMessage: "There is some error while getting themes.",
      });
    }
  };

  getServiceTypes = async () => {
    const servicesResponce = await listServiceTypes(
      auth.getAccount(),
      auth.getToken(),
    );

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      let all_clients = [];
      if (servicesResponce.data.data && servicesResponce.data.data.length > 0) {
        for (let i = 0; i < servicesResponce.data.data.length; i++) {
          let newArr = {
            label: servicesResponce.data.data[i]["product_title"],
            value: servicesResponce.data.data[i]["product_id"],
          };
          all_clients.push(newArr);
        }
      }
      this.setState({
        all_service_types: all_clients,
      });
    } else {
      this.setState({
        all_service_types: [],
      });
    }
  };

  handleChangeSearch = async (changed_value) => {
    this.setState({
      tableLoaderBlockService: true,
    });
    const delay = 1000;

    if (changed_value) {
      const selectedIds = changed_value.map((item) => item.value);

      setTimeout(() => {
        this.setState(
          {
            service_type_id: selectedIds,
            selected_service_types: changed_value,
            tableLoaderBlockService: false,
          },
          () => {
            let services = this.state.serviceData.filter((service) =>
              selectedIds.includes(service.product_id),
            );
            const filteredSelectedServices = this.state.selected_service.filter(
              (serviceId) =>
                services.some((service) => service.id === serviceId),
            );

            this.setState({
              selected_service: filteredSelectedServices,
            });
          },
        );
      }, delay);
    } else {
      setTimeout(() => {
        this.setState(
          {
            service_type_id: [],
            selected_service_types: [],
            selected_service: [],
            tableLoaderBlockService: false,
          },
          () => {
            let services = [];
          },
        );
      }, delay);
    }
  };

  getSharelinkServices = async () => {
    const { theme, sharelink_id } = this.state;
    this.setState({
      tableLoaderBlockService: true,
      getServiceErrorMessage: "",
    });
    const servicesResponce = await getSharelinkServices(
      auth.getAccount(),
      auth.getToken(),
      sharelink_id,
    );
    //console.log("getSharelinkServices: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "not_found"
    ) {
      this.setState({
        tableLoaderBlockService: false,
        getServiceErrorMessage: "Services not found.",
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      const serviceData = servicesResponce.data.data;
      const selectedService = servicesResponce.data.assigned_services;
      const serviceTypeMap = new Map();

      serviceData
        .filter((service) => selectedService.includes(service.id))
        .forEach((service) => {
          if (!serviceTypeMap.has(service.product_id)) {
            serviceTypeMap.set(service.product_id, {
              value: service.product_id,
              label: service.product_title,
            });
          }
        });
      const selectedServiceTypes = Array.from(serviceTypeMap.values());
      const serviceTypeIds = selectedServiceTypes.map((type) => type.value);

      this.setState({
        serviceData: servicesResponce.data.data,
        selected_service: servicesResponce.data.assigned_services,
        selected_service_types: selectedServiceTypes,
        service_type_id: serviceTypeIds,
        tableLoaderBlockService: false,
        getServiceErrorMessage: "",
      });

      await this.getServiceTypes();
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "sharelink_not_found"
    ) {
      this.setState({
        serviceData: [],
        selected_service: "",
        tableLoaderBlockService: false,
        getServiceErrorMessage: `${localization.sharelinkPage.label_single} does not exist or Landing page setting is set to No. Please click ${localization.sharelinkPage.label_single} Detail tab, select Landing Page to Yes and Save Details.`,
      });
    } else {
      this.setState({
        tableLoaderBlockService: false,
        getServiceErrorMessage: "There is some error while getting services.",
      });
    }
  };

  getSharelinkBundles = async () => {
    const { theme, sharelink_id } = this.state;
    this.setState({
      tableLoaderBlockBundle: true,
      getBundleErrorMessage: "",
    });
    const servicesResponce = await getSharelinkBundles(
      auth.getAccount(),
      auth.getToken(),
      sharelink_id,
    );
    // console.log("getSharelinkBundles: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "not_found"
    ) {
      this.setState({
        tableLoaderBlockBundle: false,
        getBundleErrorMessage: "Bundles not found.",
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        bundlesData: servicesResponce.data.data,
        selected_bundle: servicesResponce.data.assigned_services,
        tableLoaderBlockBundle: false,
        getBundleErrorMessage: "",
      });
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "sharelink_not_found"
    ) {
      this.setState({
        tableLoaderBlockBundle: false,
        getBundleErrorMessage: `${localization.sharelinkPage.label_single} does not exist or Landing page setting is set to No. Please click ${localization.sharelinkPage.label_single} Detail tab, select Landing Page to Yes and Save Details.`,
      });
    } else {
      this.setState({
        tableLoaderBlockBundle: false,
        getBundleErrorMessage: "There is some error while getting the bundles.",
      });
    }
  };
  getSharelinkLogos = async () => {
    const { theme, sharelink_id, avatarsPerPage } = this.state;
    this.setState({
      tableLoaderBlockLogo: true,
      getLogoErrorMessage: "",
    });
    const servicesResponce = await getSharelinkLogos(
      auth.getAccount(),
      auth.getToken(),
      sharelink_id,
    );
    let logo_array = [];
    let avatar_array = [];
    let avatar2_array = [];
    let banner_array = [];
    let background_image_array = [];
    let background_image2_array = [];
    if (servicesResponce.data.data) {
      logo_array = this.groupBy(servicesResponce.data.data, "logo");
      avatar_array = this.groupBy(servicesResponce.data.data, "image");
      avatar2_array = this.groupBy(servicesResponce.data.data, "image2");
      banner_array = this.groupBy(servicesResponce.data.data, "banner");
      background_image_array = this.groupBy(
        servicesResponce.data.data,
        "background_image",
      );
      background_image2_array = this.groupBy(
        servicesResponce.data.data,
        "background_image2",
      );
      
    }

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "not_found"
    ) {
      this.setState({
        tableLoaderBlockLogo: false,
        getLogoErrorMessage: "Logos not found.",
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      const selectedAvatarIndex = avatar_array.findIndex(
        (avatar) => avatar.id === servicesResponce.data.avatar,
      );
      const selectedAvatar2Index = avatar2_array.findIndex(
        (avatar2) => avatar2.id === servicesResponce.data.avatar2,
      );
      const selectedLogoIndex = logo_array.findIndex(
        (logo) => logo.id === servicesResponce.data.logo,
      );
      const selectedBannerIndex = banner_array.findIndex(
        (banner) => banner.id === servicesResponce.data.banner,
      );
      const selectedBackgroundImageIndex = background_image_array.findIndex(
        (bg) => bg.id === servicesResponce.data.background_image,
      );
      const selectedBackgroundImage2Index = background_image2_array.findIndex(
        (bg2) => bg2.id === servicesResponce.data.background_image2,
      );
      const selectedAvatarPage =
        Math.floor(selectedAvatarIndex / avatarsPerPage) + 1;
      const selectedAvatar2Page =
        Math.floor(selectedAvatar2Index / avatarsPerPage) + 1;
      const selectedLogoPage =
        Math.floor(selectedLogoIndex / avatarsPerPage) + 1;
      const selectedBannerPage =
        Math.floor(selectedBannerIndex / avatarsPerPage) + 1;
      const selectedBackgroundImagePage =
        Math.floor(selectedBackgroundImageIndex / avatarsPerPage) + 1;
      const selectedBackgroundImage2Page =
        Math.floor(selectedBackgroundImage2Index / avatarsPerPage) + 1;
      this.setState({
        logoData: logo_array,
        avatarData: avatar_array,
        avatarData2: avatar2_array,
        selected_logo: servicesResponce.data.logo,
        selected_avatar: servicesResponce.data.avatar,
        selected_avatar2:
          servicesResponce.data.avatar2 && servicesResponce.data.avatar2 !== ""
            ? servicesResponce.data.avatar2
            : "",
        bannerData: banner_array,
        selected_banner: servicesResponce.data.banner,
        backgroundImageData: background_image_array,
        selected_background_image: servicesResponce.data.background_image || "",
        backgroundImage2Data: background_image2_array,
        selected_background_image2:
          servicesResponce.data.background_image2 || "",
        tableLoaderBlockLogo: false,
        getLogoErrorMessage: "",
        currentPageAvatar:
          selectedAvatarIndex && selectedAvatarIndex !== -1
            ? selectedAvatarPage
            : 1,
        currentPageAvatar2:
          selectedAvatar2Index && selectedAvatar2Index !== -1
            ? selectedAvatar2Page
            : 1,
        currentPageLogo:
          selectedLogoIndex && selectedLogoIndex !== -1 ? selectedLogoPage : 1,
        currentPageBanner:
          selectedBannerIndex && selectedBannerIndex !== -1
            ? selectedBannerPage
            : 1,
        currentPageBackgroundImage:
          selectedBackgroundImageIndex && selectedBackgroundImageIndex !== -1
            ? selectedBackgroundImagePage
            : 1,
        currentPageBackgroundImage2:
          selectedBackgroundImage2Index && selectedBackgroundImage2Index !== -1
            ? selectedBackgroundImage2Page
            : 1,
      });
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "sharelink_not_found"
    ) {
      this.setState({
        tableLoaderBlockLogo: false,
        getLogoErrorMessage: `${localization.sharelinkPage.label_single} does not exist or Landing page setting is set to No. Please click ${localization.sharelinkPage.label_single} Detail tab, select Landing Page to Yes and Save Details.`,
      });
    } else {
      this.setState({
        tableLoaderBlockLogo: false,
        getLogoErrorMessage: "There is some error while getting the logos.",
      });
    }
  };

  handlePageChange = (type, direction) => {
    const {
      avatarsPerPage,
      currentPageAvatar,
      currentPageAvatar2,
      currentPageLogo,
      currentPageBanner,
      currentPageBackgroundImage,
      currentPageBackgroundImage2,
      avatarData,
      avatarData2,
      logoData,
      bannerData,
      backgroundImageData,
      backgroundImage2Data,
    } = this.state;

    let currentPage, data;

    switch (type) {
      case "avatar":
        currentPage = currentPageAvatar;
        data = avatarData;
        break;
      case "avatar2":
        currentPage = currentPageAvatar2;
        data = avatarData2;
        break;
      case "logo":
        currentPage = currentPageLogo;
        data = logoData;
        break;
      case "banner":
        currentPage = currentPageBanner;
        data = bannerData;
        break;
      case "backgroundImage":
        currentPage = currentPageBackgroundImage;
        data = backgroundImageData;
        break;
      case "backgroundImage2":
        currentPage = currentPageBackgroundImage2;
        data = backgroundImage2Data;
        break;
      default:
        return;
    }

    const totalPages = Math.ceil(data.length / avatarsPerPage);

    if (direction === "next") {
      if (currentPage < totalPages) {
        currentPage += 1;
      }
    } else if (direction === "prev") {
      if (currentPage > 1) {
        currentPage -= 1;
      }
    }

    this.setState({
      [`currentPage${type.charAt(0).toUpperCase() + type.slice(1)}`]:
        currentPage,
    });
  };
  /*getSharelinkLogos = async () => {
    const { theme, sharelink_id } = this.state;
    this.setState({
      tableLoaderBlockLogo: true,
      getLogoErrorMessage: "",
    });
    const servicesResponce = await getSharelinkLogos(
      auth.getAccount(),
      auth.getToken(),
      sharelink_id
    );
    console.log("getSharelinkLogos: ", servicesResponce.data);
    let logo_array = [];
    let avatar_array = [];
    let banner_array = [];
    let avatar2_array = [];
    if (servicesResponce.data.data) {
      logo_array = this.groupBy(servicesResponce.data.data, "logo");
      avatar_array = this.groupBy(servicesResponce.data.data, "image");
      banner_array = this.groupBy(servicesResponce.data.data, "banner");
      avatar2_array = this.groupBy(servicesResponce.data.data, "image2");
    }

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "not_found"
    ) {
      this.setState({
        tableLoaderBlockLogo: false,
        getLogoErrorMessage: "Logos not found.",
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        logoData: logo_array,
        avatarData: avatar_array,
        selected_logo: servicesResponce.data.logo,
        selected_avatar: servicesResponce.data.avatar,
        avatarData2: avatar2_array,
        selected_avatar2: servicesResponce.data.avatar2,
        bannerData: banner_array,
        selected_banner: servicesResponce.data.banner,
        tableLoaderBlockLogo: false,
        getLogoErrorMessage: "",
      });
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "sharelink_not_found"
    ) {
      this.setState({
        tableLoaderBlockLogo: false,
        getLogoErrorMessage:
          "Share link does not exists or Landing page setting is set to No. Please click Sharelink Detail tab, select Landing Page to Yes and Save Details.",
      });
    } else {
      this.setState({
        tableLoaderBlockLogo: false,
        getLogoErrorMessage: "There is some error while getting the logos.",
      });
    }
  };*/

  getSharelinkSettings = async (type) => {
    const { theme, sharelink_id } = this.state;
    this.setState({
      getAboutErrorMessage: "",
      getSeoErrorMessage: "",
      getContactErrorMessage: "",
      getSocialErrorMessage: "",
      about_me_short: "",
      about_me: "",
      instagram_link: "",
      facebook_link: "",
      twitter_link: "",
      linkedin_link: "",
      youtube_link: "",
      contact_address: "",
      contact_email: "",
      contact_phone: "",
      meta_description: "",
      meta_title: "",
      slug: "",
      ogImage: "",
      robotsIndex: true,
      canonicalUrl: "",
      selectedSeoPage: "home",
      seo_pages: this.getNormalizedSeoPages({}, {
        meta_title: "",
        meta_description: "",
        meta_og_image: "",
        canonical_url: "",
      }),
      lead_form_settings: getDefaultLeadFormSettings(),
    });
    //if (this.state.about_me === "") {
    if (type === "about") {
      this.setState({
        tableLoaderBlockAbout: true,
        getAboutErrorMessage: "",
      });
    }
    if (type === "social") {
      this.setState({
        tableLoaderBlockSocial: true,
        getSocialErrorMessage: "",
      });
    }
    if (type === "contact") {
      this.setState({
        tableLoaderBlockContact: true,
        getContactErrorMessage: "",
      });
    }
    if (type === "seo") {
      this.setState({
        tableLoaderBlockSEO: true,
        getSeoErrorMessage: "",
      });
    }

    if (type === "lead_form") {
      this.setState({
        tableLoaderBlockLeadForm: true,
        getContactErrorMessage: "",
      });
    }

    if (type === "other_settings") {
      this.setState({
        tableLoaderBlockSEO: true,
        getSeoErrorMessage: "",
      });
    }

    if (type === "testimonials") {
      this.setState({
        tableLoaderBlockSEO: true,
        getSeoErrorMessage: "",
      });
    }

    const servicesResponce = await getSharelinkSettings(
      auth.getAccount(),
      auth.getToken(),
      sharelink_id,
    );
    // console.log("getSharelinkSettings sharelink_id: ", sharelink_id);
    // console.log("getSharelinkSettings: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "not_found"
    ) {
      if (type === "about") {
        this.setState({
          getSocialErrorMessage: "",
          getContactErrorMessage: "",
          getSeoErrorMessage: "",
          getAboutErrorMessage: "About me content not found.",
          isEditorReady: true,
        });
      }
      if (type === "social") {
        this.setState({
          getSocialErrorMessage: "Social media links not found.",
          getAboutErrorMessage: "",
          getContactErrorMessage: "",
          getSeoErrorMessage: "",
        });
      }
      if (type === "contact") {
        this.setState({
          getContactErrorMessage: "Contact details not found.",
          getAboutErrorMessage: "",
          getSocialErrorMessage: "",
          getSeoErrorMessage: "",
        });
      }
      if (type === "lead_form") {
        this.setState({
          getContactErrorMessage: "Lead form settings not found.",
          getAboutErrorMessage: "",
          getSocialErrorMessage: "",
          getSeoErrorMessage: "",
        });
      }
      if (type === "seo") {
        this.setState({
          getSeoErrorMessage: "SEO details not found.",
          getAboutErrorMessage: "",
          getSocialErrorMessage: "",
          getContactErrorMessage: "",
        });
      }
      if (type === "testimonials") {
        this.setState({
          getSeoErrorMessage: "Testimonial details not found.",
          getAboutErrorMessage: "",
          getSocialErrorMessage: "",
          getContactErrorMessage: "",
        });
      }
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      let default_other_settings = JSON.parse(
        servicesResponce.data.default_theme_data[0]["data_json"],
      );
      let other_settings;
      try {
        const responseOtherSettings =
          servicesResponce.data.sharelink_settings[0]["other_settings"];
        other_settings = JSON.parse(
          responseOtherSettings || default_other_settings,
        );
      } catch (error) {
        // If parsing fails, use default settings
        console.warn(
          "Failed to parse other_settings, using default settings:",
          error,
        );
        other_settings = default_other_settings;
      }
      if (
        other_settings.login &&
        (!other_settings.login.login_link ||
          other_settings.login.login_link.trim() === "")
      ) {
        other_settings.login.login_link = `${APP_LIVE_URL}${auth.getResellerRegToken()}/client`;
      }
      const selectedTestimonials =
        servicesResponce.data.sharelink_settings[0]["selected_testimonials"];
      const testimonialsArray =
        selectedTestimonials && selectedTestimonials.trim() !== ""
          ? selectedTestimonials.split(",").map(Number)
          : [];
      const rawRobotsIndex =
        servicesResponce.data.robots_index ?? servicesResponce.data.robotsIndex;
      const robotsIndex =
        rawRobotsIndex === undefined || rawRobotsIndex === null
          ? true
          : rawRobotsIndex === true ||
              rawRobotsIndex === 1 ||
              rawRobotsIndex === "1" ||
              rawRobotsIndex === "true" ||
              rawRobotsIndex === "yes" ||
              rawRobotsIndex === "Yes";

      const normalizedSeoPages = this.getNormalizedSeoPages(
        servicesResponce.data.seo_pages || {},
        {
          meta_title: servicesResponce.data.meta_title,
          meta_description: servicesResponce.data.meta_description,
          meta_og_image:
            servicesResponce.data.og_image || servicesResponce.data.ogImage,
          canonical_url:
            servicesResponce.data.canonical_url ||
            servicesResponce.data.canonicalUrl,
          schema_json:
            servicesResponce.data.schema_json ||
            servicesResponce.data.schemaJson ||
            "",
        },
      );

      const selectedSeoPage = this.state.selectedSeoPage || "home";
      const selectedSeoData =
        normalizedSeoPages[selectedSeoPage] || normalizedSeoPages.home;
      const homeSeoData = normalizedSeoPages.home || this.getDefaultSeoPage();
      
      // Use the normalized lead_form_settings from the API response
      const responseLeadFormSettings =
        servicesResponce.data.lead_form_settings ||
        servicesResponce.data.sharelink_settings[0]["lead_form_settings"];
      let parsedLeadFormSettings = {};
      if (
        typeof responseLeadFormSettings === "string" &&
        responseLeadFormSettings.trim() !== ""
      ) {
        try {
          parsedLeadFormSettings = JSON.parse(responseLeadFormSettings);
        } catch (error) {
          parsedLeadFormSettings = {};
        }
      } else if (
        responseLeadFormSettings &&
        typeof responseLeadFormSettings === "object"
      ) {
        parsedLeadFormSettings = responseLeadFormSettings;
      }

      this.setState(
        {
          about_me_short:
            servicesResponce.data.sharelink_settings[0]["about_me_short"],
          about_me: servicesResponce.data.sharelink_settings[0]["about_me"],
          other_settings: other_settings,
          original_other_settings: JSON.parse(JSON.stringify(other_settings)),
          testimonials: servicesResponce.data.testimonials,
          selectedTestimonials: testimonialsArray,
          instagram_link:
            servicesResponce.data.sharelink_settings[0]["instagram_link"],
          facebook_link:
            servicesResponce.data.sharelink_settings[0]["facebook_link"],
          twitter_link: this.normalizeXLink(
            servicesResponce.data.sharelink_settings[0]["twitter_link"] || ""
          ),
          linkedin_link:
            servicesResponce.data.sharelink_settings[0]["linkedin_link"],
          youtube_link:
            servicesResponce.data.sharelink_settings[0]["youtube_link"],
          settingData: servicesResponce.data.data,
          contact_address:
            servicesResponce.data.sharelink_settings[0]["contact_address"],
          contact_email:
            servicesResponce.data.sharelink_settings[0]["contact_email"],
          contact_phone:
            servicesResponce.data.sharelink_settings[0]["contact_phone"],
          meta_description: homeSeoData.meta_description || "",
          meta_title: homeSeoData.meta_title || "",
          slug: servicesResponce.data.slug || "",
          ogImage: homeSeoData.meta_og_image || "",
          robotsIndex:
            selectedSeoData && selectedSeoData.robots
              ? selectedSeoData.robots.toLowerCase().includes("index")
              : robotsIndex,
          canonicalUrl: homeSeoData.canonical_url || "",
          selectedSeoPage,
          seo_pages: normalizedSeoPages,
          lead_form_settings:
            this.getNormalizedLeadFormSettings(parsedLeadFormSettings),
          buttonColor:
            this.state.buttonColor || servicesResponce.data.theme_color || "",
          theme_color: servicesResponce.data.theme_color || "",
          isEditorReady: false,
        },
        () => {
          setTimeout(() => {
            this.setState({ isEditorReady: true });
          }, 500);
        },
      );
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "sharelink_not_found"
    ) {
      if (type === "about") {
        this.setState({
          getAboutErrorMessage: `${localization.sharelinkPage.label_single} does not exist or Landing page setting is set to No. Please click ${localization.sharelinkPage.label_single} Detail tab, select Landing Page to Yes and Save Details.`,
          isEditorReady: true,
        });
      }
      if (type === "social") {
        this.setState({
          getSocialErrorMessage: `${localization.sharelinkPage.label_single} does not exist or Landing page setting is set to No. Please click ${localization.sharelinkPage.label_single} Detail tab, select Landing Page to Yes and Save Details.`,
        });
      }
      if (type === "contact") {
        this.setState({
          getContactErrorMessage: `${localization.sharelinkPage.label_single} does not exist or Landing page setting is set to No. Please click ${localization.sharelinkPage.label_single} Detail tab, select Landing Page to Yes and Save Details.`,
        });
      }
      if (type === "lead_form") {
        this.setState({
          getContactErrorMessage: `${localization.sharelinkPage.label_single} does not exist or Landing page setting is set to No. Please click ${localization.sharelinkPage.label_single} Detail tab, select Landing Page to Yes and Save Details.`,
        });
      }
      if (type === "seo") {
        this.setState({
          getSeoErrorMessage: `${localization.sharelinkPage.label_single} does not exist or Landing page setting is set to No. Please click ${localization.sharelinkPage.label_single} Detail tab, select Landing Page to Yes and Save Details.`,
        });
      }
    } else {
      if (type === "about") {
        this.setState({
          getAboutErrorMessage:
            "There is some error while getting about me content.",
          isEditorReady: true,
        });
      }
      if (type === "social") {
        this.setState({
          getSocialErrorMessage:
            "There is some error while getting social media links.",
        });
      }
      if (type === "contact") {
        this.setState({
          getContactErrorMessage:
            "There is some error while getting contact details.",
        });
      }
      if (type === "lead_form") {
        this.setState({
          getContactErrorMessage:
            "There is some error while getting lead form settings.",
        });
      }
      if (type === "seo") {
        this.setState({
          getSeoErrorMessage: "There is some error while getting SEO data.",
        });
      }
      if (type === "testimonials") {
        this.setState({
          getSeoErrorMessage:
            "There is some error while getting testimonials data.",
        });
      }
    }
    if (type === "about") {
      this.setState({
        tableLoaderBlockAbout: false,
      });
    }
    if (type === "social") {
      this.setState({
        tableLoaderBlockSocial: false,
      });
    }
    if (type === "contact") {
      this.setState({
        tableLoaderBlockContact: false,
      });
    }
    if (type === "lead_form") {
      this.setState({
        tableLoaderBlockLeadForm: false,
      });
    }
    if (type === "testimonials") {
      this.setState({
        tableLoaderBlockSEO: false,
      });
    }
    if (type === "seo") {
      this.setState({
        tableLoaderBlockSEO: false,
      });
    }
    /* } else {
      this.setState({
        tableLoaderBlockContact: false,
        tableLoaderBlockAbout: false,
        tableLoaderBlockSocial: false,
        tableLoaderBlockSEO: false,
      });
    }*/
  };

  addTestimonial = () => {
    let randomNumber = Math.floor(Math.random() * 1000000);
    this.setState({
      isAddingTestimonial: true,
      isEditing: false,
      editingIndex: null,
      testimonial_name: "",
      testimonial_title: "",
      testimonial_comment: "",
      testimonial_img: "",
      selectedImageName: "",
      testimonialErrors: {},
      testimonial_id: randomNumber,
    });
  };

  editTestimonial = (index) => {
    const testimonial = this.state.testimonials[index];
    this.setState({
      isAddingTestimonial: true,
      isEditing: true,
      editingIndex: index,
      testimonial_name: testimonial.name,
      testimonial_title: testimonial.title,
      testimonial_comment: testimonial.comment,
      testimonial_img: testimonial.image_name,
      testimonial_id: testimonial.id,
      testimonialErrors: {},
    });
  };

  saveTestimonial = async () => {
    const {
      isEditing,
      editingIndex,
      testimonial_name,
      testimonial_title,
      testimonial_comment,
      testimonials,
      testimonial_img,
      testimonial_id,
    } = this.state;
    let errors = {};
    if (!testimonial_name) errors.nameError = "Name is required";
    if (!testimonial_title) errors.titleError = "Title is required";
    if (!testimonial_comment) errors.commentError = "Comment is required";

    if (Object.keys(errors).length > 0) {
      this.setState({ testimonialErrors: errors });
      this.showToast("Please fill in the required fields.", "error");
      return;
    }
    if (isEditing) {
      const currentTestimonial = testimonials[editingIndex];
      const editedTestimonial = {
        id: currentTestimonial.id,
        name: testimonial_name,
        title: testimonial_title,
        comment: testimonial_comment,
        image_name: testimonial_img,
      };
      await this.updateTestimonial(
        currentTestimonial.id,
        testimonial_name,
        testimonial_title,
        testimonial_comment,
        testimonial_img,
      );
      const updatedTestimonials = testimonials.map((item, index) =>
        index === editingIndex ? editedTestimonial : item,
      );
      this.setState({
        testimonials: updatedTestimonials,
        isAddingTestimonial: false,
        isEditing: false,
        editingIndex: null,
        testimonial_name: "",
        testimonial_title: "",
        testimonial_comment: "",
        testimonial_img: "",
        selectedImageName: "",
        testimonialErrors: {},
      });
    } else {
      const newTestimonial = {
        name: testimonial_name,
        title: testimonial_title,
        comment: testimonial_comment,
        image_name: testimonial_img,
        id: testimonial_id,
      };
      await this.saveNewTestimonial(
        testimonial_id,
        testimonial_name,
        testimonial_title,
        testimonial_comment,
        testimonial_img,
      );
      this.setState((prevState) => ({
        testimonials: [...prevState.testimonials, newTestimonial],
        isAddingTestimonial: false,
        testimonial_name: "",
        testimonial_title: "",
        testimonial_comment: "",
        testimonial_img: "",
        selectedImageName: "",
        testimonialErrors: {},
      }));
    }
  };

  saveNewTestimonial = async (
    testimonial_id,
    testimonial_name,
    testimonial_title,
    testimonial_comment,
    testimonial_img,
  ) => {
    try {
      const saveResponse = await saveNewTestimonial(
        auth.getAccount(),
        auth.getToken(),
        testimonial_name,
        testimonial_title,
        testimonial_comment,
        testimonial_img,
        testimonial_id,
      );
      if (
        saveResponse.data.status === 403 ||
        saveResponse.data.errors === "authentication missing" ||
        saveResponse.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        saveResponse.data.status === 200 &&
        saveResponse.data.message === "success"
      ) {
        this.setState({ disabled: false });
        this.showToast("Testimonial added successfully.", "success");
      } else {
        this.setState({ disabled: false });
        this.showToast(
          "There is some error while adding the testimonial.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error while saving testimonial:", error);
      this.setState({ disabled: false });
      this.showToast("An unexpected error occurred.", "error");
    }
  };

  updateTestimonial = async (
    testimonial_id,
    testimonial_name,
    testimonial_title,
    testimonial_comment,
    testimonial_img,
  ) => {
    try {
      const saveResponse = await updateTestimonial(
        auth.getAccount(),
        auth.getToken(),
        testimonial_name,
        testimonial_title,
        testimonial_comment,
        testimonial_img,
        testimonial_id,
      );
      if (
        saveResponse.data.status === 403 ||
        saveResponse.data.errors === "authentication missing" ||
        saveResponse.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        saveResponse.data.status === 200 &&
        saveResponse.data.message === "success"
      ) {
        this.setState({ disabled: false });
        this.showToast("Testimonials updated successfully.", "success");
      } else {
        this.setState({ disabled: false });
        this.showToast(
          "There is some error while updating the testimonials.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error while saving testimonial:", error);
      this.setState({ disabled: false });
      this.showToast("An unexpected error occurred.", "error");
    }
  };

  deleteTestimonial = async (index) => {
    const currentTestimonial = this.state.testimonials[index];
    try {
      const saveResponse = await deleteTestimonial(
        auth.getAccount(),
        auth.getToken(),
        currentTestimonial.id,
      );
      if (
        saveResponse.data.status === 403 ||
        saveResponse.data.errors === "authentication missing" ||
        saveResponse.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        saveResponse.data.status === 200 &&
        saveResponse.data.message === "success"
      ) {
        const updatedTestimonials = this.state.testimonials.filter(
          (_, i) => i !== index,
        );
        this.setState({
          testimonials: updatedTestimonials,
          disabled: false,
        });
        this.showToast("Testimonial Deleted Successfully.", "success");
      } else {
        this.setState({ disabled: false });
        this.showToast(
          "There is some error while deleting the testimonial.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error while saving testimonial:", error);
      this.setState({ disabled: false });
      this.showToast("An unexpected error occurred.", "error");
    }
  };

  handleTestimonialImageChange = (event) => {
    const file = event.target.files[0];
    this.setState({
      save_testimonial_btn_disable: true,
    });
    const formData = new FormData();
    formData.append("token", process.env.REACT_APP_API_TOKEN);
    formData.append("api_accountno", process.env.REACT_APP_API_ACCOUNTNO);
    formData.append("file", file);

    axios
      .post(
        process.env.REACT_APP_API_URL + "uploads/upload_testimonial_image",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "http://localhost:3000",
            "Access-Control-Allow-Credentials": true,
          },
        },
      )
      .then((res) => {
        if (
          res.data.status === 403 ||
          res.data.errors === "authentication missing" ||
          res.data.errors === "jwt expired"
        ) {
          auth.logout();
        } else if (res.data.status === 404 && res.data.error === "error") {
          this.setState({ save_testimonial_btn_disable: false });
          this.showToast(res.data.message, "error");
        } else if (res.data.status === 200 && res.data.message === "success") {
          this.setState({
            testimonial_img: res.data.img_url,
            selectedImageName: file.name,
            save_testimonial_btn_disable: false,
          });
        }
      })
      .catch((error) => {
        console.error("Error uploading image: ", error);
        this.showToast("Error uploading image. Please try again later.", "error");
      });
  };

  saveSharelinkDetail = async () => {
    const { title, status, sharelink_id, loading_text } = this.state;

    const saveResponce = await saveSharelinkDetail(
      auth.getAccount(),
      auth.getToken(),
      sharelink_id,
      title,
      status,
      loading_text,
    );
    //console.log("saveSharelinkDetail: ", saveResponce.data);
    if (
      saveResponce.data.status === 403 ||
      saveResponce.data.errors === "authentication missing" ||
      saveResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      saveResponce.data.status === 404 &&
      saveResponce.data.message === "not_found"
    ) {
      // window.location.replace("/error");
      this.setState({ disabled: false });
      this.showToast(
        `${localization.sharelinkPage.label_single} does not found.`,
        "error"
      );
    } else if (
      saveResponce.data.status === 200 &&
      saveResponce.data.message === "success"
    ) {
      this.setState({ disabled: false });
      this.showToast(
        `${localization.sharelinkPage.label_single} detail updated successfully.`,
        "success"
      );
    } else {
      this.setState({ disabled: false });
      this.showToast(
        `There is some error while updating the ${localization.sharelinkPage.text_single} detail.`,
        "error"
      );
      //window.location.replace("/error");
    }
  };

  saveSharelinkTheme = async () => {
    const { theme, sharelink_id, buttonColor, theme_color } = this.state;
    // Prefer buttonColor if set, else fallback to theme_color
    const colorToSave = buttonColor || theme_color;
    const saveResponce = await saveSharelinkTheme(
      auth.getAccount(),
      auth.getToken(),
      sharelink_id,
      theme,
      colorToSave,
    );
    //console.log("saveSharelinkTheme: ", saveResponce.data);
    if (
      saveResponce.data.status === 403 ||
      saveResponce.data.errors === "authentication missing" ||
      saveResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      saveResponce.data.status === 404 &&
      saveResponce.data.message === "not_found"
    ) {
      // window.location.replace("/error");
      this.setState({ disabled: false });
      this.showToast(
        `${localization.sharelinkPage.label_single} does not found.`,
        "error"
      );
    } else if (
      saveResponce.data.status === 200 &&
      saveResponce.data.message === "success"
    ) {
      this.setState({ disabled: false });
      this.showToast("Theme updated successfully.", "success");
    } else {
      this.setState({ disabled: false });
      this.showToast("There is some error while updating the theme.", "error");
      //window.location.replace("/error");
    }
  };

  saveSharelinkServices = async () => {
    const { sharelink_id } = this.state;
    //console.log("this.state.selected_service: ", this.state.selected_service);
    const modalBody = document.getElementById("modalDetails");
    if (modalBody) {
      setTimeout(() => {
        modalBody.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 0);
    }
    const saveResponce = await saveSharelinkServices(
      auth.getAccount(),
      auth.getToken(),
      sharelink_id,
      this.state.selected_service,
    );
    //console.log("saveSharelinkServices: ", saveResponce.data);
    if (
      saveResponce.data.status === 403 ||
      saveResponce.data.errors === "authentication missing" ||
      saveResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      saveResponce.data.status === 404 &&
      saveResponce.data.message === "not_found"
    ) {
      // window.location.replace("/error");
      this.setState({ disabled: false });
      this.showToast(
        `${localization.sharelinkPage.label_single} does not exists.`,
        "error"
      );
    } else if (
      saveResponce.data.status === 200 &&
      saveResponce.data.message === "success"
    ) {
      this.setState({ disabled: false });
      this.showToast("Services updated successfully.", "success");
    } else {
      this.setState({ disabled: false });
      this.showToast("There is some error while updating the services.", "error");
      //window.location.replace("/error");
    }
  };

  saveSharelinkBundles = async () => {
    const { sharelink_id } = this.state;
    //console.log("this.state.selected_service: ", this.state.selected_service);
    const saveResponce = await saveSharelinkBundles(
      auth.getAccount(),
      auth.getToken(),
      sharelink_id,
      this.state.selected_bundle,
    );
    // console.log("saveSharelinkBundles: ", saveResponce.data);
    if (
      saveResponce.data.status === 403 ||
      saveResponce.data.errors === "authentication missing" ||
      saveResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      saveResponce.data.status === 404 &&
      saveResponce.data.message === "not_found"
    ) {
      // window.location.replace("/error");
      this.setState({ disabled: false });
      this.showToast(
        `${localization.sharelinkPage.label_single} does not exists.`,
        "error"
      );
    } else if (
      saveResponce.data.status === 200 &&
      saveResponce.data.message === "success"
    ) {
      this.setState({ disabled: false });
      this.showToast("Bundles updated successfully.", "success");
    } else {
      this.setState({ disabled: false });
      this.showToast("There is some error while updating the bundles.", "error");
      //window.location.replace("/error");
    }
  };

  saveSharelinkLogos = async () => {
    const {
      sharelink_id,
      selected_logo,
      selected_avatar,
      selected_banner,
      selected_avatar2,
      selected_background_image,
      selected_background_image2,
    } = this.state;

    const modalBody = document.getElementById("modalDetails");
    if (modalBody) {
      setTimeout(() => {
        modalBody.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 0);
    }

    const saveResponce = await saveSharelinkLogos(
      auth.getAccount(),
      auth.getToken(),
      sharelink_id,
      selected_logo,
      selected_avatar,
      selected_banner,
      selected_avatar2,
      selected_background_image,
      selected_background_image2,
    );

    if (
      saveResponce.data.status === 403 ||
      saveResponce.data.errors === "authentication missing" ||
      saveResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      saveResponce.data.status === 404 &&
      saveResponce.data.message === "not_found"
    ) {
      // window.location.replace("/error");
      this.setState({ disabled: false });
      this.showToast(
        `${localization.sharelinkPage.label_single} does not found.`,
        "error"
      );
    } else if (
      saveResponce.data.status === 200 &&
      saveResponce.data.message === "success"
    ) {
      this.setState({ disabled: false });
      this.showToast("Images updated successfully.", "success");
    } else {
      this.setState({ disabled: false });
      this.showToast("There is some error while updating the images.", "error");
      //window.location.replace("/error");
    }
  };

  saveSharelinkAbout = async () => {
    const { sharelink_id, about_me_short, about_me, about_me_settings } = this.state;
    this.setState({
      disabled: false,
    });
    const modalBody = document.getElementById("modalDetails");
    if (modalBody) {
      setTimeout(() => {
        modalBody.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 0);
    }
    // Convert boolean checkbox to "Yes" or "No"
    const aboutSettings = about_me_settings === true ? "Yes" : "No";
    const saveResponce = await saveSharelinkAbout(
      auth.getAccount(),
      auth.getToken(),
      sharelink_id,
      about_me_short,
      about_me,
      aboutSettings,
    );
    //console.log("saveSharelinkAbout: ", saveResponce.data);

    if (
      saveResponce.data.status === 403 ||
      saveResponce.data.errors === "authentication missing" ||
      saveResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      saveResponce.data.status === 404 &&
      saveResponce.data.message === "not_found"
    ) {
      // window.location.replace("/error");
      this.setState({ disabled: false });
      this.showToast(
        `${localization.sharelinkPage.label_single} does not found.`,
        "error"
      );
    } else if (
      saveResponce.data.status === 200 &&
      saveResponce.data.message === "success"
    ) {
      this.setState({ disabled: false });
      this.showToast("About me detail updated successfully.", "success");
    } else {
      this.setState({ disabled: false });
      this.showToast(
        "There is some error while updating the about me detail.",
        "error"
      );
      //window.location.replace("/error");
    }
  };

  saveSharelinkContact = async () => {
    const {
      sharelink_id,
      contact_address,
      contact_email,
      contact_phone,
      contact_settings,
      emailError,
      phoneError,
      addressError,
    } = this.state;
    if (emailError === "" && phoneError === "" && addressError === "") {
      // Convert boolean checkbox to "Yes" or "No"
      const ctSettings = contact_settings === true ? "Yes" : "No";
      const saveResponce = await saveSharelinkContact(
        auth.getAccount(),
        auth.getToken(),
        sharelink_id,
        contact_address,
        contact_email,
        contact_phone,
        ctSettings,
      );

      if (
        saveResponce.data.status === 403 ||
        saveResponce.data.errors === "authentication missing" ||
        saveResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        saveResponce.data.status === 404 &&
        saveResponce.data.message === "not_found"
      ) {
        // window.location.replace("/error");
        this.setState({ disabled: false });
        this.showToast(
          `${localization.sharelinkPage.label_single} does not found.`,
          "error"
        );
      } else if (
        saveResponce.data.status === 200 &&
        saveResponce.data.message === "success"
      ) {
        this.setState({ disabled: false });
        this.showToast("Contact detail updated successfully.", "success");
      } else {
        this.setState({ disabled: false });
        this.showToast(
          "There is some error while updating the contact detail.",
          "error"
        );
        //window.location.replace("/error");
      }
    } else {
      this.setState({ disabled: false });
      this.showToast("Please fill the fields correctly.", "error");
    }
  };

  saveSharelinkSocial = async () => {
    const {
      sharelink_id,
      instagram_link,
      facebook_link,
      twitter_link,
      linkedin_link,
      youtube_link,
      social_settings,
      instagramError,
      facebookError,
      twitterError,
      linkedinError,
      youtubeError,
    } = this.state;
    if (
      instagramError === "" &&
      facebookError === "" &&
      twitterError === "" &&
      linkedinError === "" &&
      youtubeError === ""
    ) {
      // Convert boolean checkbox to "Yes" or "No"
      const sSettings = social_settings === true ? "Yes" : "No";
      const saveResponce = await saveSharelinkSocial(
        auth.getAccount(),
        auth.getToken(),
        sharelink_id,
        instagram_link,
        facebook_link,
        twitter_link,
        linkedin_link,
        youtube_link,
        sSettings,
      );

      if (
        saveResponce.data.status === 403 ||
        saveResponce.data.errors === "authentication missing" ||
        saveResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        saveResponce.data.status === 404 &&
        saveResponce.data.message === "not_found"
      ) {
        // window.location.replace("/error");
        this.setState({ disabled: false });
        this.showToast(
          `${localization.sharelinkPage.label_single} does not found.`,
          "error"
        );
      } else if (
        saveResponce.data.status === 200 &&
        saveResponce.data.message === "success"
      ) {
        this.setState({ disabled: false });
        this.showToast("Social media links updated successfully.", "success");
      } else {
        this.setState({ disabled: false });
        this.showToast(
          "There is some error while updating the social media links.",
          "error"
        );
        //window.location.replace("/error");
      }
    } else {
      this.setState({ disabled: false });
      this.showToast("Please fill the fields correctly.", "error");
    }
  };

  saveSharelinkLeadForm = async () => {
    const { sharelink_id } = this.state;
    const leadFormPayload = this.getNormalizedLeadFormSettings();

    const saveResponce = await saveLeadForm(
      auth.getAccount(),
      auth.getToken(),
      sharelink_id,
      leadFormPayload,
    );

    if (
      saveResponce.data.status === 403 ||
      saveResponce.data.errors === "authentication missing" ||
      saveResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      saveResponce.data.status === 404 &&
      saveResponce.data.message === "not_found"
    ) {
      this.setState({ disabled: false });
      this.showToast(
        `${localization.sharelinkPage.label_single} does not found.`,
        "error"
      );
    } else if (
      saveResponce.data.status === 200 &&
      saveResponce.data.message === "success"
    ) {
      this.setState({ disabled: false });
      this.showToast("Lead form settings updated successfully.", "success");
    } else {
      this.setState({ disabled: false });
      this.showToast(
        "There is some error while updating lead form settings.",
        "error"
      );
    }
  };

  saveSharelinkSEO = async () => {
    const {
      sharelink_id,
      meta_description,
      meta_title,
      slug,
      ogImage,
      robotsIndex,
      canonicalUrl,
    } = this.state;

    const seo_pages = this.buildSeoPagesPayload();
    const schemaJsonValidation = this.validateSchemaJson(seo_pages);
    if (!schemaJsonValidation.isValid) {
      this.setState({
        selectedSeoPage: schemaJsonValidation.invalidPage,
        schemaJsonError: schemaJsonValidation.message,
        disabled: false,
      });
      this.showToast(schemaJsonValidation.message, "error");
      return;
    }
    this.setState({ schemaJsonError: "" });

    const homeSeo = seo_pages.home || {};
    const meta_title_value = homeSeo.meta_title || meta_title;
    const meta_description_value = homeSeo.meta_description || meta_description;
    const og_image_value = homeSeo.meta_og_image || ogImage;
    const canonical_url_value = homeSeo.canonical_url || canonicalUrl;

    const saveResponce = await saveSharelinkSEO(
      auth.getAccount(),
      auth.getToken(),
      sharelink_id,
      meta_description_value,
      meta_title_value,
      slug,
      og_image_value,
      robotsIndex,
      canonical_url_value,
      seo_pages,
    );

    if (
      saveResponce.data.status === 403 ||
      saveResponce.data.errors === "authentication missing" ||
      saveResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      saveResponce.data.status === 404 &&
      saveResponce.data.message === "not_found"
    ) {
      // window.location.replace("/error");
      this.setState({ disabled: false });
      this.showToast(
        `${localization.sharelinkPage.label_single} does not found.`,
        "error"
      );
    } else if (
      saveResponce.data.status === 200 &&
      saveResponce.data.message === "success"
    ) {
      this.setState({ disabled: false });
      this.showToast("SEO detail updated successfully.", "success");
    } else {
      this.setState({ disabled: false });
      this.showToast("There is some error while updating the SEO detail.", "error");
      //window.location.replace("/error");
    }
  };

  show_regenerate = () => {
    this.setState({
      show_regenerate: "1",
      send_email: "",
    });
  };

  regenerate_link = async () => {
    const { sharelink2_id, custom_link } = this.state;

    this.setState({
      reg_button: true,
    });

    if (custom_link === "") {
      this.setState({ reg_button: false });
      this.showToast("Please enter the custom link ID.", "error");
    } else {
      const servicesResponce = await regenerateSharelink(
        auth.getAccount(),
        auth.getToken(),
        sharelink2_id,
        custom_link,
      );
      //console.log("Regenerate.data: ", servicesResponce.data);

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        servicesResponce.data.status === 404 &&
        servicesResponce.data.message === "errors"
      ) {
        this.setState({ reg_button: false });
        this.showToast(servicesResponce.data.data, "error");
        //window.location.replace("/error");
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState({
          signup_link: servicesResponce.data.data,
          reg_button: false,
          custom_link: "",
        });
        this.showToast(
          `${localization.sharelinkPage.label_single} generated successfully.`,
          "success"
        );
      } else {
        this.setState({ reg_button: false });
        this.showToast(
          `There is some error while updating the ${localization.sharelinkPage.text_single}.`,
          "error"
        );
        // window.location.replace("/error");
      }
    }
  };

  connectDomain = async (value, tableMeta) => {
    //modalConfirm

    this.setState({
      confirm_status: "Are you sure you want to connect this domain. ",
      sharelink_id: tableMeta.rowData[10],
    });
    const sharelinkResponce = await getDomains(
      auth.getAccount(),
      auth.getToken(),
    );

    // console.log("getDomains.data: ", sharelinkResponce.data);

    if (
      sharelinkResponce.data.status === 403 ||
      sharelinkResponce.data.errors === "authentication missing" ||
      sharelinkResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      sharelinkResponce.data.status === 404 &&
      sharelinkResponce.data.message === "no_record"
    ) {
      this.showToast("Domains are not available.", "error");
    } else if (
      sharelinkResponce.data.status === 200 &&
      sharelinkResponce.data.message === "success"
    ) {
      this.setState({
        available_domains: sharelinkResponce.data.data,
      });
    } else {
      this.showToast(
        "There is some error while getting available domains.",
        "error"
      );
    }

    window.$("#modalConfirm").modal("show");
  };

  connectDomainSubmit = async () => {
    let { domain_id, sharelink_id } = this.state;
    if (domain_id === "") {
      this.showToast("Please select a domain to connect.", "error");
    } else {
      const disableResponce = await connectSharelinkSubmit(
        auth.getAccount(),
        auth.getToken(),
        domain_id,
        sharelink_id,
      );
      // console.log("connectSharelinkSubmit.data: ", disableResponce.data);
      this.setState({
        btn_loader: true,
      });
      if (
        disableResponce.data.status === 403 ||
        disableResponce.data.errors === "authentication missing" ||
        disableResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        disableResponce.data.status === 404 &&
        disableResponce.data.message === "config_error"
      ) {
        this.setState({ btn_loader: false });
        this.showToast(
          "There is some error while connecting the domain.",
          "error"
        );
      } else if (
        disableResponce.data.status === 404 &&
        disableResponce.data.message !== "config_error"
      ) {
        this.setState({ btn_loader: false });
        this.showToast(
          "There is some error while adding the domain configuration.",
          "error"
        );
      } else if (
        disableResponce.data.status === 404 &&
        disableResponce.data.message !== "verify_error"
      ) {
        this.showToast("DNS records of given domain are not verified.", "error");
      } else if (
        disableResponce.data.status === 404 &&
        disableResponce.data.message !== "remove_config_error"
      ) {
        this.setState({ btn_loader: false });
        this.showToast(
          "There is some error while removing the domain configuration.",
          "error"
        );
      } else if (
        disableResponce.data.status === 200 &&
        disableResponce.data.message === "success"
      ) {
        this.setState({ btn_loader: false });
        this.showToast(
          "Your request has been received. It will be processed in 5 to 10 minutes.",
          "success"
        );
      } else {
        this.setState({ btn_loader: false });
        this.showToast(
          "There is some error while connecting the domain.",
          "error"
        );
      }
    }
  };

  getImageUpload = () => {
    this.setState({
      docErrorMessage: "",
      docSuccessMessage: "",
      edit_picture: "",
      edit_image_title: "",
      showImageLoader: true,
    });

    setTimeout(() => {
      this.setState({
        formLoader: false,
      });
    }, 2000);
  };

  handleFileChange = async (e) => {
    const selectedFile = e.target.files[0];

    if (!selectedFile) {
      return; // No file selected
    }

    // File type validation
    const allowedFileTypes = [".png", ".jpg", ".jpeg"];
    const fileExtension = selectedFile.name.split(".").pop().toLowerCase();

    // console.log("Selected file extension:", fileExtension);

    if (!allowedFileTypes.includes("." + fileExtension)) {
      // console.log("Invalid file type:", fileExtension);
      this.showToast(
        "Invalid file type. Please select a valid file format (e.g., .png, .jpg, .jpeg).",
        "error"
      );
      return;
    }

    // File size validation (e.g., limit to 5MB)
    const maxSizeBytes = 5 * 1024 * 1024; // 5MB
    if (selectedFile.size > maxSizeBytes) {
      this.showToast(
        "File size exceeds the limit (5MB). Please choose a smaller file.",
        "error"
      );
      return;
    }

    const resizedImage = await this.resizeImage(selectedFile);

    // Clear any previous errors if file passes validations
    this.setState({
      edit_picture: URL.createObjectURL(resizedImage),
      edit_picture_name: selectedFile.name,
    });
    if (this.state.edit_images_type === "logo") {
      setTimeout(() => {
        if (this.cropperRef.current && this.cropperRef.current.cropper) {
          this.cropperRef.current.cropper.zoom(-2.3);
        }
      }, 100);
    }
  };

  resizeImage = async (file) => {
    const { edit_images_type, theme } = this.state;
    const maxDimensions = {
      logo: { width: 325, height: 130 },
      image: { width: 1400, height: 980 },
      image2: { width: 549, height: 611 },
      banner: { width: 1400, height: 980 },
      background_image: { width: 1920, height: 1080 },
      background_image2: { width: 1920, height: 1080 },
    };

    // THEME 3: Override banner dimensions to square for 1:1 aspect ratio
    // Using == for loose comparison to handle both string "3" and number 3
    if (edit_images_type === "banner" && theme == "3") {
      maxDimensions.banner = { width: 1000, height: 1000 };
    }

    const maxW = maxDimensions[edit_images_type].width;
    const maxH = maxDimensions[edit_images_type].height;

    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;

        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          let { width, height } = img;

          // THEME 3 BANNER: Center-crop to square (1:1 aspect ratio)
          // Using == for loose comparison to handle both string "3" and number 3
          if (edit_images_type === "banner" && theme == "3") {
            const minDim = Math.min(img.width, img.height);
            const startX = (img.width - minDim) / 2;
            const startY = (img.height - minDim) / 2;

            canvas.width = maxW;
            canvas.height = maxH;

            // Extract center square portion and scale to target dimensions
            ctx.drawImage(
              img,
              startX,
              startY,
              minDim,
              minDim,
              0,
              0,
              maxW,
              maxH
            );
          } else if (edit_images_type === "image") {
            // AVATAR: Keep original dimensions (free crop, no reshape)
            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0);
          } else if (edit_images_type !== "logo") {
            // THEME 9 & Other Themes: Preserve existing behavior
            let resizePercent = 0;

            // Calculate the aspect ratio based on the original image dimensions
            const aspectRatio = width / height;

            // Determine the target aspect ratio based on the image type
            const targetAspectRatio =
              edit_images_type === "image"
                ? 1.43
                : edit_images_type === "image2"
                  ? 0.89
                  : edit_images_type === "banner"
                    ? 2.93
                    : edit_images_type === "background_image"
                      ? 1.78
                      : edit_images_type === "background_image2"
                        ? 1.78
                        : 1; // Default aspect ratio if none matched

            // Adjust the dimensions to maintain the aspect ratio
            if (aspectRatio > targetAspectRatio) {
              width = maxW;
              height = Math.round(width / targetAspectRatio);
            } else {
              height = maxH;
              width = Math.round(height * targetAspectRatio);
            }

            // Draw the image onto the canvas at the adjusted dimensions
            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0, width, height);

            // console.log(
            //   `Resized ${edit_images_type} image to ${width}x${height}`
            // );
          } else {
            // Keep the original dimensions for the logo
            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0);
            // console.log(
            //   `Kept ${edit_images_type} image size: ${width}x${height}`
            // );
          }

          canvas.toBlob((blob) => {
            resolve(new File([blob], file.name, { type: file.type }));
          }, file.type);
        };
      };
    });
  };

  saveNewImage = async () => {
    const {
      edit_picture,
      edit_picture_name,
      edit_image_title,
      edit_images_type,
    } = this.state;

    const modalBody = document.getElementById("modalDetails");
    if (modalBody) {
      setTimeout(() => {
        modalBody.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 0);
    }

    if (edit_image_title === "") {
      this.showToast("Title is required.", "error");
    } else if (!edit_picture) {
      this.showToast("Please choose an image to upload.", "error");
    } else {
      const croppedBlob = await this.getCroppedBlob();
      const imageElement = this.cropperRef.current;
      const cropper = imageElement.cropper;
      const { width, height } = cropper.getCropBoxData();

      // Define maximum dimensions based on image type
      let maxWidth, maxHeight;

      if (edit_images_type === "logo") {
        maxWidth = 325;
        maxHeight = 130;
      } else if (edit_images_type === "image") {
        maxWidth = 1550;
        maxHeight = 840;
      } else if (edit_images_type === "image2") {
        maxWidth = 549;
        maxHeight = 611;
      } else if (edit_images_type === "banner") {
        maxWidth = 1640;
        maxHeight = 840;
      } else if (edit_images_type === "background_image") {
        maxWidth = 1920;
        maxHeight = 1080;
      } else if (edit_images_type === "background_image2") {
        maxWidth = 1920;
        maxHeight = 1080;
      }

      // Check if dimensions exceed the allowed values
      if (width > maxWidth || height > maxHeight) {
        this.showToast(
          `Image dimensions exceed the allowed size for ${edit_images_type}. Maximum allowed size is W: ${maxWidth} x H: ${maxHeight}.`,
          "error"
        );
        return;
      }

      // console.log(
      //   "edit_picture_name: " +
      //     edit_picture_name +
      //     " edit_image_title: " +
      //     edit_image_title +
      //     " edit_images_type: " +
      //     edit_images_type
      // );

      const formData = new FormData();
      formData.append("token", process.env.REACT_APP_API_TOKEN);
      formData.append("api_accountno", process.env.REACT_APP_API_ACCOUNTNO);

      // Append the cropped blob instead of the original image
      formData.append("file", croppedBlob);

      formData.append("image_title", edit_image_title);
      formData.append("image_type", edit_images_type);
      formData.append("status", 1);
      formData.append("accountno", auth.getAccount());
      formData.append("fileName", edit_picture_name);

      

      axios
        .post(
          process.env.REACT_APP_API_URL + "uploads/upload_user_image",
          formData,
        )
        .then((res) => {
          
          if (
            res.data.status === 403 ||
            res.data.errors === "authentication missing" ||
            res.data.errors === "jwt expired"
          ) {
            auth.logout();
          } else if (res.data.status === 404 && res.data.error === "error") {
            this.showToast(res.data.message, "error");
          } else if (
            res.data.status === 200 &&
            res.data.message === "success"
          ) {
            this.setState({
              edit_picture_name: "",
              edit_picture: "",
              edit_image_title: "",
            });
            this.showToast("Image added successfully.", "success");
            setTimeout(() => {
              this.setState({
                showImageLoader: false,
              });
              this.getSharelinkLogos();
            }, 3000);
          } else {
            console.error("Upload failed with response:", res.data);
            console.error("Image type that failed:", edit_images_type);
            this.showToast(
              res.data.message ||
                "There is some error while adding the image.",
              "error"
            );
          }
        })
        .catch((error) => {
          console.error("Error uploading image:", error);
          console.error("Error response:", error.response?.data);
          console.error("Image type in error:", edit_images_type);
          this.showToast(
            error.response?.data?.message ||
              "Error uploading image. Please try again later.",
            "error"
          );
        });
    }
  };

  handleCloseModal = () => {
    this.setState({ selectedTabMobile: "tab-1" });
    window.$("#modalDetails").modal("hide");
    //window.location.reload();
  };

  onCrop = () => {
    const imageElement = this.cropperRef.current;
    const cropper = imageElement.cropper;
    const { width, height } = cropper.getCropBoxData();
    const { edit_images_type } = this.state;

    // Define dimensions based on image type
    let minWidth, minHeight;
    let aspectRatio;

    if (edit_images_type === "logo") {
      minWidth = 325;
      minHeight = 130;
      aspectRatio = 325 / 130;
    } else if (edit_images_type === "image") {
      minWidth = 1400;
      minHeight = 980;
      aspectRatio = 1400 / 900;
    } else if (edit_images_type === "image2") {
      minWidth = 549;
      minHeight = 611;
      aspectRatio = 549 / 611;
    } else if (edit_images_type === "banner") {
      minWidth = 1640;
      minHeight = 980;
      aspectRatio = 1640 / 980;
    } else if (edit_images_type === "background_image") {
      minWidth = 1920;
      minHeight = 1080;
      aspectRatio = 1920 / 1080;
    } else if (edit_images_type === "background_image2") {
      minWidth = 1920;
      minHeight = 1080;
      aspectRatio = 1920 / 1080;
    }

    // console.log(`Aspect ratio for ${edit_images_type}: ${aspectRatio}`);

    // Apply dimension restrictions
    if (width < minWidth || height < minHeight) {
      // Adjust cropping dimensions if they don't meet the minimum requirements
      cropper.setCropBoxData({
        width: Math.max(width, minWidth),
        height: Math.max(height, minHeight),
      });

      // Update dimensions directly in the DOM
      const cropSizeElement = document.getElementById("cropSize");
      if (cropSizeElement) {
        cropSizeElement.textContent = `Current Crop Size: W: ${Math.round(
          Math.max(width, minWidth),
        )} x H: ${Math.round(Math.max(height, minHeight))}`;
      }
    } else {
      // Update dimensions directly in the DOM
      const cropSizeElement = document.getElementById("cropSize");
      if (cropSizeElement) {
        cropSizeElement.textContent = `Current Crop Size: W: ${Math.round(
          width,
        )} x H: ${Math.round(height)}`;
      }
    }
  };

  getCroppedBlob = () => {
    return new Promise((resolve, reject) => {
      const imageElement = this.cropperRef.current;

      if (imageElement && imageElement.cropper) {
        const cropper = imageElement.cropper;
        const croppedCanvas = cropper.getCroppedCanvas();

        if (croppedCanvas) {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          canvas.width = croppedCanvas.width;
          canvas.height = croppedCanvas.height;

          ctx.filter = `brightness(${this.state.brightness}%)`;
          ctx.drawImage(croppedCanvas, 0, 0, canvas.width, canvas.height);

          canvas.toBlob((blob) => {
            resolve(blob);
          }, "image/png");
        } else {
          reject(new Error("Failed to get cropped canvas."));
        }
      }
    });
  };

  rotateImage = (degree) => {
    const cropper = this.cropperRef.current.cropper;
    cropper.rotate(degree);
  };

  handleZoomIn = () => {
    const cropper = this.cropperRef.current.cropper;
    cropper.zoom(0.1); // Adjust zoom factor as needed
  };

  handleZoomOut = () => {
    const cropper = this.cropperRef.current.cropper;
    cropper.zoom(-0.1); // Adjust zoom factor as needed
  };

  flipBoth = () => {
    const cropper = this.cropperRef.current.cropper;
    cropper.scale(-1);
  };

  flipHorizontal = () => {
    const cropper = this.cropperRef.current.cropper;
    cropper.scale(-1, 1);
  };

  flipVertical = () => {
    const cropper = this.cropperRef.current.cropper;
    cropper.scale(1, -1);
  };

  handleResetCrop = () => {
    const imageElement = this.cropperRef.current;
    const cropper = imageElement.cropper;

    // Reset the crop box to its initial state
    cropper.reset();
    this.handleReady();
    this.setState({ brightness: 100 });

    // Apply zoom out if images_type is "logo"
    if (this.state.edit_images_type === "logo") {
      setTimeout(() => {
        if (this.cropperRef.current && this.cropperRef.current.cropper) {
          this.cropperRef.current.cropper.zoom(-2.3); // Zoom out by 2.3
        }
      }, 100);
    }
  };

  handleBrightnessChange = (e) => {
    this.setState({ brightness: parseInt(e.target.value) });
  };

  toggleBrightnessRange = () => {
    this.setState((prevState) => ({
      showBrightnessRange: !prevState.showBrightnessRange,
    }));
  };

  handleReady = () => {
    const cropper = this.cropperRef.current.cropper;
    const containerData = cropper.getContainerData();
    const imageData = cropper.getImageData();

    const aspectRatio = this.calculateAspectRatio();

    let newWidth = imageData.naturalWidth * 0.5;
    let newHeight = newWidth / aspectRatio;

    const maxWidth = containerData.width;
    const maxHeight = containerData.height;

    if (newWidth > maxWidth) {
      newWidth = maxWidth;
      newHeight = newWidth / aspectRatio;
    }
    if (newHeight > maxHeight) {
      newHeight = maxHeight;
      newWidth = newHeight * aspectRatio;
    }

    let offsetTop = 0;
    let offsetLeft = 0;
    if (this.state.edit_images_type === "logo") {
      offsetTop = 20;
      offsetLeft = 90;
    }
    // THEME 3 BANNER: Maintain square aspect ratio during crop preview
    // Using == for loose comparison to handle both string "3" and number 3
    else if (this.state.edit_images_type === "banner" && this.state.theme == "3") {
      offsetTop = 0;
      offsetLeft = 0;
    }

    const newLeft = (containerData.width - newWidth) / 2 - offsetLeft;
    const newTop = (containerData.height - newHeight) / 2 - offsetTop;

    cropper.setCropBoxData({
      left: newLeft,
      top: newTop,
      width: newWidth,
      height: newHeight,
    });
  };

  calculateAspectRatio = () => {
    const { edit_images_type, theme } = this.state;
    
    // THEME 3 BANNER: Return 1:1 square aspect ratio
    // Using == for loose comparison to handle both string "3" and number 3
    if (edit_images_type === "banner" && theme == "3") {
      return 1;
    }

    // AVATAR: Free crop (no fixed ratio) so the full avatar is preserved.
    if (edit_images_type === "image") {
      return NaN;
    }

    switch (edit_images_type) {
      case "logo":
        return 325 / 130;
      case "image":
        return 1400 / 980;
      case "image2":
        return 549 / 611;
      case "banner":
        return 1640 / 980; // THEME 9 & other themes default
      case "background_image":
        return 1920 / 1080;
      case "background_image2":
        return 1920 / 1080;
      default:
        return 1640 / 560;
    }
  };

  getReadableLabel = (backendKey, sectionName = null) => {
    const labelMap = {
      navbar: {
        nav_link1: "Nav Link 1",
        nav_link2: "Nav Link 2",
        nav_link3: "Nav Link 3",
        nav_link4: "Nav Link 4",
        nav_link5: "Nav Link 5",
      },
      sidebar: {
        contact_section_title: "Contact Section Title",
        social_section_title: "Social Section Title",
      },
      banner: {
        btn_text1: "Banner Button Text 1",
        btn_text2: "Banner Button Text 2",
        title: "Banner Title",
      },
      about: {
        title: "About Title",
        about_banner_title: "About Banner Title",
        features_title: "About Features Title",
        btn_text: "About Button Text",
        helpline_text: "Helpline Text",
        main_feature_highlight: "Main Feature Highlight",
        main_feature: "Main Feature",
        feature1: "Feature 1",
        feature2: "Feature 2",
        feature3: "Feature 3",
        feature4: "Feature 4",
      },
      services: {
        title: "Services Title",
        description: "Services Description",
        service_rate_text: "Service Rate Text",
        service_read_more_btn: "Service Read More Button",
      },
      services_modal: {
        btn_text: "Button Text",
        link_btn_text: "Link Button Text",
        file_btn_text: "File Button Text",
        nda_sign_up_text: "NDA Sign Up Text",
        pricing_heading: "Pricing Heading",
        misc_charges_table_title: "Misc Charges Table Title",
        misc_charges_th_title: "Misc Charges Column Title",
        misc_charges_th_type: "Misc Charges Column Type",
        misc_charges_th_rate: "Misc Charges Column Rate",
        pricing_breakdown_table_title: "Pricing Breakdown Table Title",
        pricing_breakdown_th_title: "Pricing Breakdown Column Title",
        pricing_breakdown_th_charge_type: "Pricing Breakdown Charge Type",
        pricing_breakdown_th_rate_type: "Pricing Breakdown Rate Type",
        pricing_breakdown_th_rate: "Pricing Breakdown Rate",
        cancellation_fee_table_title: "Cancellation Fee Table Title",
        cancellation_fee_th_type: "Cancellation Fee Column Type",
        cancellation_fee_th_value: "Cancellation Fee Column Value",
        service_type_did_tfn_teams_table_title: "Service Type Rates Title",
        service_type_did_tfn_teams_th_type: "Service Type Column Type",
        service_type_did_tfn_teams_th_value: "Service Type Column Value",
        service_type_did_tfn_teams_th_mrc: "Service Type MRC",
        service_type_did_tfn_teams_th_nrc: "Service Type NRC",
        service_type_did_tfn_teams_th_portin: "Service Type Port-In Rate",
        service_type_did_tfn_teams_th_portout: "Service Type Port-Out Rate",
        service_type_did_tfn_teams_th_smsin: "Service Type SMS In Rate",
        service_type_did_tfn_teams_th_smsout: "Service Type SMS Out Rate",
        service_type_did_tfn_teams_th_cnam: "Service Type CNAM Update (MRC)",
        service_type_did_tfn_teams_th_dip: "Service Type DIP Charges",
        service_type_did_tfn_teams_th_storage_dip:
          "Service Type Storage DIP Charges",
      },
      testimonial: {
        title: "Testimonial Title",
        customers: "Testimonial Customers",
      },
      contact: {
        title: "Contact Title",
        heading: "Contact Heading",
        description: "Contact Description",
        point1: "Contact Point 1",
        point2: "Contact Point 2",
        point3: "Contact Point 3",
        point4: "Contact Point 4",
        email_label: "Email Label",
        name_label: "Name Label",
        phone_label: "Phone Label",
        subject_label: "Subject Label",
        message_label: "Message Label",
        btn_text: "Contact Button Text",
      },
      footer: {
        support_title: "Footer Support Title",
        contact_text: "Footer Contact Text",
        link_text: "Footer Link Text",
        copyright_text_before_company_name:
          "Copyright Text (Before Company Name)",
        copyright_text_after_company_name:
          "Copyright Text (After Company Name)",
        footer_link1: "Footer Link 1",
        footer_link2: "Footer Link 2",
        footer_link3: "Footer Link 3",
      },
      process: {
        title: "Process Title",
        lead_text: "Lead Text",
        step1_title: "Step 1 Title",
        step1_desc: "Step 1 Description",
        step2_title: "Step 2 Title",
        step2_desc: "Step 2 Description",
        step3_title: "Step 3 Title",
        step3_desc: "Step 3 Description",
        step4_title: "Step 4 Title",
        step4_desc: "Step 4 Description",
        step5_title: "Step 5 Title",
        step5_desc: "Step 5 Description",
        step6_title: "Step 6 Title",
        step6_desc: "Step 6 Description",
      },
    };
    // If section is provided, use it directly (highest priority)
    if (
      sectionName &&
      labelMap[sectionName] &&
      labelMap[sectionName][backendKey]
    ) {
      return labelMap[sectionName][backendKey];
    }

    // Search for the key in all nested sections
    for (const section of Object.values(labelMap)) {
      if (typeof section === "object" && section[backendKey]) {
        return section[backendKey];
      }
    }

    // Try case-insensitive match in all sections
    const lowerKey = String(backendKey).toLowerCase();
    for (const section of Object.values(labelMap)) {
      if (typeof section === "object") {
        for (const [k, v] of Object.entries(section)) {
          if (k.toLowerCase() === lowerKey) {
            return v;
          }
        }
      }
    }

    // Convert UPPERCASE_WITH_UNDERSCORES to Title Case
    if (
      typeof backendKey === "string" &&
      backendKey === backendKey.toUpperCase()
    ) {
      return backendKey
        .split("_")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
        )
        .join(" ");
    }

    // Convert snake_case to Title Case
    if (typeof backendKey === "string" && backendKey.includes("_")) {
      return backendKey
        .split("_")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
        )
        .join(" ");
    }

    // Convert camelCase to Title Case
    if (typeof backendKey === "string") {
      return backendKey
        .replace(/([A-Z])/g, " $1")
        .trim()
        .split(" ")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
        )
        .join(" ");
    }

    return backendKey;
  };

  getRedirectNavLinkOptions = (section) => {
    const optionSet = new Set();

    // Use original_other_settings to preserve options from backend
    const sourceSettings = this.state.original_other_settings;

    if (
      sourceSettings[section] &&
      typeof sourceSettings[section] === "object"
    ) {
      Object.keys(sourceSettings[section]).forEach((key) => {
        // Collect values only from redirect_nav_link fields
        if (key.startsWith("redirect_nav_link")) {
          const value = sourceSettings[section][key];
          if (value && typeof value === "string" && value.trim() !== "") {
            optionSet.add(value);
          }
        }
      });
    }

    return Array.from(optionSet).sort();
  };

  handleChangeOtherSettings = (event, backendKey) => {
    const { value } = event.target;
    const keys = backendKey.split(".");

    this.setState((prevState) => {
      let other_settings = { ...prevState.other_settings };
      let nestedObj = other_settings;
      keys.forEach((key, index) => {
        if (index === keys.length - 1) {
          nestedObj[key] = value;
        } else {
          if (!nestedObj[key]) {
            nestedObj[key] = {};
          }
          nestedObj = nestedObj[key];
        }
      });

      return { other_settings };
    });
  };

  saveSharelinkOtherSettings = async () => {
    const { sharelink_id, other_settings } = this.state;
    const modalBody = document.getElementById("modalDetails");
    if (modalBody) {
      setTimeout(() => {
        modalBody.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 0);
    }
    const saveResponce = await saveSharelinkOtherSettings(
      auth.getAccount(),
      auth.getToken(),
      sharelink_id,
      other_settings,
    );
    // console.log("saveSharelinkOtherSettings: ", saveResponce.data);
    if (
      saveResponce.data.status === 403 ||
      saveResponce.data.errors === "authentication missing" ||
      saveResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      saveResponce.data.status === 404 &&
      saveResponce.data.message === "not_found"
    ) {
      // window.location.replace("/error");
      this.setState({ disabled: false });
      this.showToast(
        `${localization.sharelinkPage.label_single} does not found.`,
        "error"
      );
    } else if (
      saveResponce.data.status === 200 &&
      saveResponce.data.message === "success"
    ) {
      this.setState({ disabled: false });
      this.showToast("Settings updated successfully.", "success");
    } else {
      this.setState({ disabled: false });
      this.showToast(
        `There is some error while updating the ${localization.sharelinkPage.text_single} settings.`,
        "error"
      );
      //window.location.replace("/error");
    }
  };

  getTableData() {
    return this.state.testimonials.map((testimonial, index) => ({
      Id: testimonial.id,
      Name: testimonial.name,
      Title: testimonial.title,
      Comment: testimonial.comment,
      Image: testimonial.image_name,
      Actions: index,
    }));
  }

  handleTestimonialSelection = (id) => (event) => {
    const { selectedTestimonials } = this.state;
    if (event.target.checked) {
      this.setState({
        selectedTestimonials: [...selectedTestimonials, id],
      });
    } else {
      this.setState({
        selectedTestimonials: selectedTestimonials.filter(
          (selectedId) => selectedId !== id,
        ),
      });
    }
  };

  getSelectedTestimonials = () => {
    return this.state.selectedTestimonials.join(",");
  };

  saveSharelinkTestimonials = async () => {
    const { sharelink_id } = this.state;
    const testimonials = this.getSelectedTestimonials();
    const saveResponce = await saveSharelinkTestimonials(
      auth.getAccount(),
      auth.getToken(),
      sharelink_id,
      testimonials,
    );

    if (
      saveResponce.data.status === 403 ||
      saveResponce.data.errors === "authentication missing" ||
      saveResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      saveResponce.data.status === 404 &&
      saveResponce.data.message === "not_found"
    ) {
      this.setState({ disabled: false });
      this.showToast(
        `${localization.sharelinkPage.label_single} does not found.`,
        "error"
      );
    } else if (
      saveResponce.data.status === 200 &&
      saveResponce.data.message === "success"
    ) {
      this.setState({ disabled: false });
      this.showToast("Testimonials updated successfully.", "success");
    } else {
      this.setState({ disabled: false });
      this.showToast(
        "There is some error while updating the testimonials.",
        "error"
      );
    }
  };

  deleteCommentModal = (comment_id) => {
    this.setState({
      comment_id: comment_id,
    });
    window.$("#modalDeleteAlert").modal("show");
  };

  deleteSharelinkModal = (sharelink_id) => {
    this.setState({
      sharelink_id_to_delete: sharelink_id,
    });
    window.$("#modalDeleteSharelinkAlert").modal("show");
  };

  deleteSharelinkFun = async () => {
    this.setState({ disabled: true });
    const servicesResponce = await deleteSharelink(
      auth.getAccount(),
      auth.getToken(),
      this.state.sharelink_id_to_delete,
    );

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({ disabled: false });
      this.showToast(
        `${localization.sharelinkPage.label_single} deleted successfully.`,
        "success",
      );
      window.$("#modalDeleteSharelinkAlert").modal("hide");
      this.loadSharelinks();
    } else {
      this.setState({ disabled: false });
      this.showToast(
        `Error deleting the ${localization.sharelinkPage.text_single}.`,
        "error",
      );
    }
  };

  deleteSharelinkCommentFun = async (value, tableMeta) => {
    const servicesResponce = await deleteSharelinkComment(
      auth.getAccount(),
      auth.getToken(),
      this.state.comment_id,
    );
    // console.log("deleteSharelinkCommentFun: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({ disabled: false });
      this.showToast(
        `Error deleting the ${localization.sharelinkPage.text_single} comment.`,
        "error"
      );
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({ disabled: false });
      this.showToast(
        `${localization.sharelinkPage.label_single} comment deleted successfully.`,
        "success"
      );
      setTimeout(() => {
        window.$("#modalDeleteAlert").modal("hide");
        this.reloadSharelinkComment();
      }, 3000);
    } else {
      this.setState({ disabled: false });
      this.showToast(
        `Error deleting the ${localization.sharelinkPage.text_single} comment.`,
        "error"
      );
    }
  };

  render() {
    const {
      edit_picture,
      showBrightnessRange,
      brightness,
      anchorEl,
      menuType,
      selectedRowId,
    } = this.state;
    const currentSeoPageData = this.getCurrentSeoPageData();
    const seoKeywordsText = this.getKeywordsText();
    let filtered_services =
      this.state.service_type_id.length > 0
        ? this.state.serviceData.filter((service) =>
          this.state.service_type_id.includes(service.product_id),
        )
        : this.state.serviceData;
    const fetchToken = async () => {
      try {
        const response = await fetch(
          API_URL + "agents/editor_token_url_agents",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              request_type: "ckeditor-tokenUrl",
              user: auth.getAccount(),
            }),
          },
        );
        const data = await response.json();
        return data.token;
      } catch (error) {
        console.error("Failed to fetch token:", error);
        return null;
      }
    };

    //$(".nk-block .MUIDataTable-paper-2").css("padding", "10px");
    return (
      <div className="nk-content " id="Services_Block">
        <NotificationToast
          message={this.state.toastMessage}
          type={this.state.toastType}
          title={this.state.toastTitle}
          onDismiss={() => this.setState({ toastMessage: "" })}
        />
        <div className="container-fluid">
          {this.props.defaultSettings === "missing" &&
            this.props.from !== "dashboard" ? (
            <SettingsError />
          ) : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" &&
            this.props.from !== "dashboard" ? (
            <MsaWarning />
          ) : null}

          {/* MSA WARNING END */}

          <div className="nk-content-inner">
            <div className="nk-content-body">
              {/* PAGE TITLE START */}
              <div className="nk-block-head nk-block-head-sm">
                <div
                  className="nk-block-between"
                  style={{ alignItems: "flex-start" }}
                >
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">
                      <PageTitle
                        name={localization.sharelinkPage.heading}
                        icon="icon ni ni-share"
                      />
                    </h3>
                    <div className="nk-block-des">
                      <p className="lead" style={{ paddingRight: "100px" }}>
                        {this.state.sharelink_limit > 0 ? (
                          <>
                            You are allowed to create up to{" "}
                            <b>{this.state.sharelink_limit}</b>{" "}
                            {localization.sharelinkPage.text}. With our
                            platform, you have the freedom to generate and share
                            up to {this.state.sharelink_limit} unique links.
                            This limit ensures that you have a reasonable number
                            of shareable links while maintaining control and
                            manageability. Should you require more{" "}
                            {localization.sharelinkPage.text}, please contact
                            our support team who will be happy to assist you
                            with any additional requirements.
                          </>
                        ) : null}
                      </p>
                    </div>
                  </div>
                  <div
                    className="nk-block-head-content sharelink-head-tools"
                    id="HeadContent"
                  >
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <a
                        href="#"
                        className="btn btn-icon btn-trigger toggle-expand mr-n1"
                        data-target="pageMenu"
                      >
                        <em className="icon ni ni-more-v"></em>
                      </a>
                      <div
                        className="toggle-expand-content"
                        data-content="pageMenu"
                      >
                        <ul className="nk-block-tools g-3">
                          {this.state.sharelink_limit > 0 &&
                            this.state.sharelink_added <
                            this.state.sharelink_limit ? (
                            <li className="nk-block-tools-opt">
                              <a
                                onClick={() =>
                                  this.addMenuHistory(
                                    "sharelinks/add_sharelink",
                                  )
                                }
                                style={{
                                  color: "#fff",
                                  cursor: "pointer",
                                }}
                                className="btn btn-primary"
                              >
                                <em className="icon ni ni-plus-round"></em>
                                <span>
                                  {localization.sharelinkPage.addNewButton}
                                </span>
                              </a>
                            </li>
                          ) : null}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* PAGE TITLE END */}
              <div className="nk-block">
                <div className="row g-gs">
                  {/* Table 5th Col Start */}
                  <div className="col-xxl-12">
                    <div className="nk-block nk-block-lg">
                      {/* START DATATABLE */}
                      {this.state.tableLoaderListing === true ? ( tableLoaderListing() ) : (
                        <DataTable
                          columns={this.state.columnServices}
                          tableData={this.state.tableData}
                          title={`All ${localization.sharelinkPage.label}`}
                        />
                      )}

                      {/* END TABLE */}
                    </div>
                  </div>
                  {/* Table 5th Col End */}
                </div>
              </div>
              {/* Sharelink MODAL START */}
              <div className="modal fade zoom" tabIndex="-1" id="modalSignupLink">
                <div className="modal-dialog  modal-xl" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <div
                        className="modal-title"
                        style={{ textAlign: "center", fontSize: "20px" }}
                      >
                        <strong>
                          <em className="icon ni ni-link-alt"></em>{" "}
                          {localization.sharelinkPage.heading_single}
                        </strong>
                      </div>
                      <a
                        href="#"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                    </div>

                    <div className="modal-body modal-body-lg">
                      <div className="nk-modal">
                        <div className="nk-modal-text">
                          {this.state.tableLoaderLine === true ? (
                            tableLoaderLine()
                          ) : (
                            <>
                              {this.state.assigned_domain !== "" ? (
                                <div
                                  className="example-alert"
                                  style={{
                                    marginBottom: "15px",
                                  }}
                                >
                                  <div className="alert alert-info alert-icon">
                                    <em className="icon ni ni-link-alt"></em>{" "}
                                    <strong>Assigned Domain: </strong>{" "}
                                    {this.state.assigned_domain}{" "}
                                  </div>
                                </div>
                              ) : null}
                            </>
                          )}
                          <div className="example-alert">
                            <div className="alert alert-light alert-icon">
                              <em className="icon ni ni-alert-circle"></em>{" "}
                              <strong>NOTE: </strong> Share this link with your
                              clients to showcase your services and assist them
                              with signing up.{" "}
                            </div>
                          </div>
                          <div className="row g-3 mb-3 mt-3">
                            <div className="col-12 col-md-8">
                              <div className="example-alert mb-3">
                                <div
                                  className="alert alert-light column"
                                  style={{ wordWrap: "break-word" }}
                                >
                                  {this.state.assigned_domain &&
                                    this.state.assigned_domain !== ""
                                    ? this.state.assigned_domain
                                    : this.state.signup_link}
                                </div>
                              </div>
                            </div>
                            <div className="col-12 col-md-4">
                              {this.state.signup_link !== "" ? (
                                <div className="example-alert mb-3">
                                  <div className="alert alert-light d-flex justify-content-center p-2">
                                    <QRCode
                                      value={
                                        this.state.assigned_domain &&
                                          this.state.assigned_domain !== ""
                                          ? this.state.assigned_domain
                                          : this.state.signup_link
                                      }
                                      size={200}
                                    />
                                    {/*<img
                                      src={`https://chart.googleapis.com/chart?chs=200x200&cht=qr&chl=${this.state.signup_link}`}
                                    />*/}
                                  </div>
                                </div>
                              ) : null}
                            </div>
                          </div>
                          <div className="row g-2">
                            <div className="col-12 col-md-auto">
                              <button
                                className="btn btn-primary w-100 w-md-auto"
                                onClick={() => this.show_regenerate()}
                              >
                                <em className="icon ni ni-swap mr-1"></em> Regenerate
                              </button>
                            </div>
                            <div className="col-12 col-md-auto">
                              <CopyToClipboard
                                text={
                                  this.state.assigned_domain &&
                                    this.state.assigned_domain !== ""
                                    ? this.state.assigned_domain
                                    : this.state.signup_link
                                }
                                onCopy={() => this.setState({ copied: true })}
                              >
                                <button className="btn btn-success w-100 w-md-auto">
                                  <em className="icon ni ni-copy mr-1"></em> Copy to
                                  clipboard{" "}
                                  {this.state.copied ? (
                                    <span style={{ color: "white" }}>
                                      <em className="icon ni ni-done"></em>
                                    </span>
                                  ) : null}
                                </button>
                              </CopyToClipboard>
                            </div>
                            <div className="col-12 col-md-auto">
                              <button
                                className="btn btn-warning w-100 w-md-auto"
                                onClick={() => this.show_email()}
                              >
                                <em className="icon ni ni-emails mr-1"></em> Email
                                Link
                              </button>
                            </div>
                            <div className="col-12 col-md-auto">
                              <a
                                href={this.state.signup_link}
                                target="_blank"
                                className="btn btn-secondary w-100 w-md-auto"
                              >
                                <em className="icon ni ni-external-alt mr-1"></em>{" "}
                                Preview{" "}
                                {localization.sharelinkPage.label_single}
                              </a>
                            </div>
                          </div>
                          {this.state.show_regenerate === "1" ? (
                            <div
                              className="row g-4 mt-15"
                              style={{ marginTop: "35px", clear: "both" }}
                            >
                              <div className="row g-3 align-items-start">
                                <div className="col-12 col-md-8">
                                  <MutextField
                                    required
                                    id="custom_link"
                                    name="custom_link"
                                    type="text"
                                    label="Custom Link ID"
                                    defaultValue={this.state.custom_link}
                                    inputProps={{ maxLength: 50 }}
                                    onChange={this.handleChange}
                                    onInput={(e) => {
                                      e.target.value = e.target.value.replace(
                                        /[^a-z0-9]/gi,
                                        "",
                                      );
                                    }}
                                    helperText="Without spaces and special characters."
                                    variant="outlined"
                                    fullWidth
                                  />
                                </div>
                                <div className="col-12 col-md-4 d-flex align-items-start gap-2">
                                  {this.state.reg_button === false ? (
                                    <>
                                      <button
                                        className="btn btn-primary flex-fill"
                                        onClick={() => this.regenerate_link()}
                                        disabled={this.state.disabled}
                                      >
                                        <em className="icon ni ni-swap mr-1"></em>{" "}
                                        Submit
                                      </button>
                                      <button
                                        className="btn btn-danger flex-fill ml-2"
                                        onClick={() =>
                                          this.setState({
                                            show_regenerate: "0",
                                            linkErrorMessage: "",
                                            linkSuccessMessage: "",
                                          })
                                        }
                                      >
                                        <em className="icon ni ni-cross mr-1"></em>{" "}
                                        Cancel
                                      </button>
                                    </>
                                  ) : (
                                    <button
                                      className="btn btn-primary w-100 d-inline-flex align-items-center justify-content-center"
                                      disabled
                                    >
                                      <em className="icon ni ni-swap"></em>{" "}
                                      Submit
                                      <div
                                        className="spinner-grow spinner-grow-sm"
                                        role="status"
                                      >
                                        <span className="sr-only">
                                          Loading...
                                        </span>
                                      </div>
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.send_email === "1" ? (
                            <div
                              className="row g-4 mt-15"
                              style={{ marginTop: "25px" }}
                            >
                              <div className="row g-3">
                                <div className="col-12 col-md-6">
                                  <MutextField
                                    required
                                    id="name"
                                    name="name"
                                    type="email"
                                    label="Enter Name"
                                    value={this.state.name}
                                    inputProps={{ maxLength: 100 }}
                                    onChange={this.handleChange}
                                    helperText="Enter full name here."
                                    variant="outlined"
                                    fullWidth
                                  />
                                </div>
                                <div className="col-12 col-md-6">
                                  <MutextField
                                    required
                                    id="email_to"
                                    name="email_to"
                                    type="email"
                                    label="Enter Email Address"
                                    value={this.state.email_to}
                                    inputProps={{ maxLength: 100 }}
                                    onChange={this.handleChange}
                                    helperText="Enter valid email address here."
                                    variant="outlined"
                                    fullWidth
                                  />
                                </div>
                                <div className="col-12">
                                  <TextareaAutosize
                                    maxrows={4}
                                    name="invitation_comment"
                                    id="invitation_comment"
                                    aria-label=""
                                    placeholder="Add Comment *"
                                    inputProps={{ maxLength: 500 }}
                                    value={this.state.invitation_comment}
                                    helperText="Maximum 500 characters"
                                    onChange={this.handleChange}
                                    style={{
                                      width: "100%",
                                      height: "100px",
                                      borderColor: "rgba(0, 0, 0, 0.125)",
                                      borderRadius: "4px",
                                      padding: "5px",
                                    }}
                                    variant="outlined"
                                  />
                                </div>
                                <div className="col-12">
                                  <div className="row g-2 justify-content-md-end">
                                    {this.state.reg_email_button === false ? (
                                      <>
                                        <div className="col-12 col-md-auto">
                                          <button
                                            className="btn btn-danger w-100"
                                            onClick={() =>
                                              this.setState({
                                                send_email: "0",
                                                name: "",
                                                invitation_comment: "",
                                                email_to: "",
                                              })
                                            }
                                          >
                                            <em className="icon ni ni-cross mr-1"></em>{" "}
                                            Close
                                          </button>
                                        </div>
                                        <div className="col-12 col-md-auto">
                                          <button
                                            className="btn btn-primary w-100"
                                            onClick={() => this.send_email()}
                                            disabled={this.state.disabled}
                                          >
                                            <em className="icon ni ni-emails mr-1"></em>{" "}
                                            Send Email
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <div className="col-12 col-md-auto">
                                        <button
                                          className="btn btn-primary w-100 d-inline-flex align-items-center justify-content-center"
                                          disabled
                                        >
                                          <em className="icon ni ni-swap  mr-1"></em>{" "}
                                          Send Email
                                          <div
                                            className="spinner-grow spinner-grow-sm"
                                            role="status"
                                          >
                                            <span className="sr-only">
                                              Loading...
                                            </span>
                                          </div>
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Sharelink MODAL End */}
              {/* STATS MODAL */}
              <div className="modal fade zoom" tabIndex="-1" id="modalStats">
                <div
                  className="modal-dialog modal-dialog-top  modal-lg"
                  role="document"
                >
                  <div className="modal-content">
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-header">
                      <h5 className="modal-title">
                        <em className="icon ni ni-share"></em>{" "}
                        {localization.sharelinkPage.label_single} Stats
                      </h5>
                    </div>
                    <div className="modal-body">
                      {this.state.statErrorMessage !== "" ? (
                        <div
                          className="example-alert col-md-12"
                          style={{ marginBottom: "15px" }}
                        >
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p>{this.state.statErrorMessage}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      <div className="card-inner">
                        <div className="row text-center">
                          <div className="col-6">
                            <div className="profile-stats">
                              <span className="amount">
                                {this.state.stat_hits}
                              </span>
                              <span className="sub-text">Total Hits</span>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="profile-stats">
                              <span className="amount">
                                {this.state.last_visit}
                              </span>
                              <span className="sub-text">Last Visit</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* STATS MODAL */}
              {/* Comment Logs MODAL Start */}
              <div className="modal fade" tabIndex="-1" id="modalComment">
                <div
                  className="modal-dialog  modal-xl modal-dialog-top new_modal_width"
                  role="document"
                >
                  <div className="modal-content">
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-header">
                      <h5 className="modal-title">Email Logs</h5>
                    </div>
                    <div className="modal-body">
                      <DataTableSmall
                        columns={this.state.columnComment}
                        tableData={this.state.tableData_comment}
                        title={`${localization.sharelinkPage.label_single} Email Logs`}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* Comment Logs MODAL End */}

              {/* MODAL Delete Client START */}
              <div className="modal fade" tabIndex="-1" id="modalDeleteAlert">
                <div className="modal-dialog modal-dialog-top" role="document">
                  <div className="modal-content">
                    <a
                      style={{ cursor: "pointer" }}
                      className="close"
                      onClick={() => {
                        this.modalHideDel();
                      }}
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-body modal-body-lg text-center">
                      <div className="nk-modal">
                        <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-success"></em>
                        <h4 className="nk-modal-title">
                          Delete{" "}
                          {localization.sharelinkPage.addNewButton.label_single}{" "}
                          Comment?
                        </h4>
                        <div className="nk-modal-text">
                          <div className="caption-text">
                            Are you sure you want to delete this{" "}
                            {localization.sharelinkPage.text_single} comment?
                          </div>
                        </div>
                        <div className="nk-modal-action">
                          <a
                            style={{ cursor: "pointer", color: "white" }}
                            className="btn btn-lg btn-mw btn-primary"
                            onClick={() => {
                              this.modalHideDel();
                            }}
                          >
                            CANCEL
                          </a>
                          {"  "}
                          <button
                            style={{ cursor: "pointer" }}
                            className="btn btn-lg btn-mw btn-danger"
                            onClick={() => {
                              this.deleteSharelinkCommentFun();
                            }}
                            disabled={this.state.disabled}
                          >
                            DELETE
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* MODAL Delete Client End */}

              {/* MODAL Delete Sharelink START */}
              <div
                className="modal fade"
                tabIndex="-1"
                id="modalDeleteSharelinkAlert"
              >
                <div className="modal-dialog modal-dialog-top" role="document">
                  <div className="modal-content">
                    <a
                      style={{ cursor: "pointer" }}
                      className="close"
                      onClick={() => {
                        window.$("#modalDeleteSharelinkAlert").modal("hide");
                      }}
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-body modal-body-lg text-center">
                      <div className="nk-modal">
                        <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-success"></em>
                        <h4 className="nk-modal-title">
                          Delete{" "}
                          {localization.sharelinkPage.addNewButton.label_single}?
                        </h4>
                        <div className="nk-modal-text">
                          <div className="caption-text">
                            Are you sure you want to delete this{" "}
                            {localization.sharelinkPage.text_single}?
                          </div>
                        </div>
                        <div className="nk-modal-action">
                          <a
                            style={{ cursor: "pointer", color: "white" }}
                            className="btn btn-lg btn-mw btn-primary"
                            onClick={() => {
                              window
                                .$("#modalDeleteSharelinkAlert")
                                .modal("hide");
                            }}
                          >
                            CANCEL
                          </a>
                          {"  "}
                          <button
                            style={{ cursor: "pointer" }}
                            className="btn btn-lg btn-mw btn-danger"
                            onClick={() => {
                              this.deleteSharelinkFun();
                            }}
                            disabled={this.state.disabled}
                          >
                            DELETE
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* MODAL Delete Sharelink End */}

              {/* Modal Invitation Comment */}
              <div className="modal fade" tabIndex="-1" id="modalInvitationComment">
                <div
                  className="modal-dialog modal-xl modal-dialog-top"
                  role="document"
                >
                  <div className="modal-content">
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-header">
                      <h5 className="modal-title">Invitation Comments</h5>
                    </div>
                    <div className="modal-body">
                      <p className="text-dark">
                        {this.state.invitation_comment &&
                          this.state.invitation_comment !== ""
                          ? this.state.invitation_comment
                          : "No Comments"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Modal Invitation Comment */}
              {/* DETAIL MODAL START */}
              <div className="modal fade zoom" tabIndex="-1" id="modalDetails">
                <div
                  className="modal-dialog  modal-xl modal-dialog-top new_modal_width"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <div
                        className=""
                        style={{ paddingLeft: "0px" }}
                      >
                        <div
                          className="modal-title"
                          style={{
                            textAlign: "left",
                            fontSize: "20px",
                            display: "inline-block",
                          }}
                        >
                          <strong className="p-2">
                            <em className="icon ni ni-link-alt"></em>{" "}
                            {localization.sharelinkPage.label_single} Detail
                          </strong>
                        </div>
                        <a
                          href={this.state.complete_link}
                          style={{ zIndex: "100" }}
                          target="_blank"
                          className="btn btn-outline-primary d-none d-md-inline-block"
                        >
                          Preview {localization.sharelinkPage.label_single}
                        </a>
                        <Tooltip title="Preview" arrow>
                          <a
                            href={this.state.complete_link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn-outline-primary d-md-none mb-2"
                          >
                            <em className="icon ni ni-external" style={{ fontSize: "large" }}></em>
                          </a>
                        </Tooltip>
                      </div>
                      <div className="">
                        <a
                          onClick={this.handleCloseModal}
                          style={{ cursor: "pointer" }}
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <em className="icon ni ni-cross"></em>
                        </a>
                      </div>
                    </div>

                    <div
                      className="modal-body modal-body-lg"
                      style={{ padding: ".2rem .2rem" }}
                    >
                      <div className="nk-modal" id="sharelinkdetail">
                        <div className="nk-modal-text">
                          <section className="tabs-section text-white">
                            <div className="container">
                              <div className="d-block d-md-flex">
                                <div
                                  className="col-sm-5 col-lg-3"
                                  id="detail_tabs"
                                >
                                  {/* Mobile Dropdown for Tabs */}
                                  <div className="mobile-tab-dropdown">
                                    <FormControl variant="outlined" fullWidth>
                                      <InputLabel id="tab-select-label">
                                        Select Tab
                                      </InputLabel>
                                      <SelectTab
                                        labelId="tab-select-label"
                                        id="tab-select"
                                        value={this.state.selectedTabMobile}
                                        onChange={(e) => {
                                          const selectedTab = e.target.value;
                                          this.setState({
                                            selectedTabMobile: selectedTab,
                                          });
                                          // Navigate to the selected tab
                                          const tabElement =
                                            document.querySelector(
                                              `a[href="#${selectedTab}"]`,
                                            );
                                          if (tabElement) {
                                            tabElement.click();
                                          }
                                        }}
                                        label="Select Tab"
                                        MenuProps={{
                                          disablePortal: true,
                                          getContentAnchorEl: null,
                                          anchorOrigin: {
                                            vertical: "bottom",
                                            horizontal: "left",
                                          },
                                          transformOrigin: {
                                            vertical: "top",
                                            horizontal: "left",
                                          },
                                          PaperProps: {
                                            style: {
                                              maxHeight: 250,
                                              minWidth: 150,
                                            },
                                          },
                                        }}
                                      >
                                        <MenuItem value="tab-1">
                                          {
                                            localization.sharelinkPage
                                              .label_single
                                          }{" "}
                                          Detail
                                        </MenuItem>
                                        {this.state.landing_page === "Yes" && [
                                          <MenuItem key="tab-2" value="tab-2">
                                            Theme
                                          </MenuItem>,
                                          <MenuItem key="tab-11" value="tab-11">
                                            Lead Form
                                          </MenuItem>
                                          ,
                                          <MenuItem key="tab-3" value="tab-3">
                                            Services
                                          </MenuItem>,
                                          <MenuItem key="tab-8" value="tab-8">
                                            Image Library
                                          </MenuItem>,
                                          <MenuItem key="tab-4" value="tab-4">
                                            About Me
                                          </MenuItem>,
                                          <MenuItem key="tab-5" value="tab-5">
                                            Social Media Links
                                          </MenuItem>,
                                          <MenuItem key="tab-6" value="tab-6">
                                            Contact Details
                                          </MenuItem>,
                                          <MenuItem key="tab-7" value="tab-7">
                                            SEO Section
                                          </MenuItem>,
                                          <MenuItem key="tab-10" value="tab-10">
                                            Testimonials
                                          </MenuItem>,
                                          <MenuItem key="tab-9" value="tab-9">
                                            Other Settings
                                          </MenuItem>,
                                        ]}
                                      </SelectTab>
                                    </FormControl>
                                  </div>

                                  <ul className="nav nav-tabs mb-3">
                                    <li className="nav-item">
                                      <a
                                        className="nav-link active show"
                                        data-toggle="tab"
                                        href="#tab-1"
                                      >
                                        <em className="icon ni ni-share"></em>
                                        {
                                          localization.sharelinkPage
                                            .label_single
                                        }{" "}
                                        Detail
                                      </a>
                                    </li>
                                    {this.state.landing_page === "Yes" ? (
                                      <>
                                        <li className="nav-item">
                                          <a
                                            className="nav-link"
                                            data-toggle="tab"
                                            href="#tab-2"
                                            onClick={() =>
                                              this.getSharelinkTheme()
                                            }
                                          >
                                            <em className="icon ni ni-dashboard"></em>{" "}
                                            Theme
                                          </a>
                                        </li>
                                        <li className="nav-item">
                                          <a
                                            className="nav-link"
                                            data-toggle="tab"
                                            href="#tab-3"
                                            onClick={() =>
                                              this.getSharelinkServices()
                                            }
                                          >
                                            <em className="icon ni ni-list-round"></em>{" "}
                                            Services
                                          </a>
                                        </li>
                                        <li className="nav-item">
                                          <a
                                            className="nav-link"
                                            data-toggle="tab"
                                            href="#tab-8"
                                            onClick={() =>
                                              this.getSharelinkLogos()
                                            }
                                          >
                                            <em className="icon ni ni-camera"></em>{" "}
                                            Image Library
                                          </a>
                                        </li>
                                        <li className="nav-item">
                                          <a
                                            className="nav-link"
                                            data-toggle="tab"
                                            href="#tab-4"
                                            onClick={() =>
                                              this.getSharelinkSettings("about")
                                            }
                                          >
                                            <em className="icon ni ni-align-justify"></em>{" "}
                                            About Me
                                          </a>
                                        </li>
                                        <li className="nav-item">
                                          <a
                                            className="nav-link"
                                            data-toggle="tab"
                                            href="#tab-5"
                                            onClick={() =>
                                              this.getSharelinkSettings(
                                                "social",
                                              )
                                            }
                                          >
                                            <em className="icon ni ni-link-group"></em>
                                            Social Media Links
                                          </a>
                                        </li>
                                        <li className="nav-item">
                                          <a
                                            className="nav-link"
                                            data-toggle="tab"
                                            href="#tab-6"
                                            onClick={() =>
                                              this.getSharelinkSettings(
                                                "contact",
                                              )
                                            }
                                          >
                                            <em className="icon ni ni-contact"></em>
                                            Contact Details
                                          </a>
                                        </li>
                                        <li className="nav-item">
                                          <a
                                            className="nav-link"
                                            data-toggle="tab"
                                            href="#tab-11"
                                            onClick={() =>
                                              this.getSharelinkSettings(
                                                "lead_form",
                                              )
                                            }
                                          >
                                            <em className="icon ni ni-contact"></em>
                                            Lead Form
                                          </a>
                                        </li>
                                        <li className="nav-item">
                                          <a
                                            className="nav-link"
                                            data-toggle="tab"
                                            href="#tab-7"
                                            onClick={() =>
                                              this.getSharelinkSettings("seo")
                                            }
                                          >
                                            <em className="icon ni ni-list-round"></em>{" "}
                                            SEO Section
                                          </a>
                                        </li>
                                        <li className="nav-item">
                                          <a
                                            className="nav-link"
                                            data-toggle="tab"
                                            href="#tab-10"
                                            onClick={() =>
                                              this.getSharelinkSettings(
                                                "testimonials",
                                              )
                                            }
                                          >
                                            <em className="icon ni ni-star"></em>{" "}
                                            Testimonials
                                          </a>
                                        </li>
                                        <li className="nav-item">
                                          <a
                                            className="nav-link"
                                            data-toggle="tab"
                                            href="#tab-9"
                                            onClick={() =>
                                              this.getSharelinkSettings("seo")
                                            }
                                          >
                                            <em className="icon ni ni-list-round"></em>{" "}
                                            Other Settings
                                          </a>
                                        </li>
                                      </>
                                    ) : null}
                                  </ul>
                                </div>
                                <div className="col-sm-7 col-lg-9">
                                  <div className="tab-content">
                                    <div
                                      className="tab-pane active show"
                                      id="tab-1"
                                    >
                                      <div className="row">
                                        <div className="col-lg-12 details">
                                          <div
                                            className="col-md-8 col-lg-8"
                                            style={{
                                              paddingLeft: "0px",
                                              float: "left",
                                            }}
                                          >
                                            <h3>Initial Detail</h3>
                                          </div>

                                          <div
                                            className="col-md-4 col-lg-4"
                                            style={{
                                              paddingLeft: "0px",
                                              float: "right",
                                              textAlign: "right",
                                            }}
                                          >
                                            {/*<a
                                              href={this.state.complete_link}
                                              style={{ zIndex: "100" }}
                                              target="_blank"
                                              className="btn btn-outline-success"
                                            >
                                              Preview
                                            </a>*/}
                                          </div>

                                          <div
                                            className="form-group col-md-12 col-lg-12"
                                            style={{ paddingLeft: "0px" }}
                                          >
                                            <MutextField
                                              required
                                              id="title"
                                              name="title"
                                              type="text"
                                              label={`${localization.sharelinkPage.label_single} Title`}
                                              inputProps={{ maxLength: 100 }}
                                              value={this.state.title}
                                              onChange={this.handleChange}
                                              helperText="Enter the title here."
                                              onInput={(e) => {
                                                e.target.value =
                                                  e.target.value.replace(
                                                    /[^a-z0-9 ]/gi,
                                                    "",
                                                  );
                                              }}
                                              variant="outlined"
                                              fullWidth
                                            />
                                          </div>

                                          <div
                                            className="form-group col-md-12 col-lg-12"
                                            style={{ paddingLeft: "0px" }}
                                          >
                                            <MutextField
                                              id="loading_text"
                                              name="loading_text"
                                              type="text"
                                              label="Loading Text"
                                              inputProps={{ maxLength: 64 }}
                                              value={this.state.loading_text}
                                              onChange={this.handleChange}
                                              helperText={`${localization.sharelinkPage.label_single} loading text. Maximum 64 characters.`}
                                              onInput={(e) => {
                                                e.target.value =
                                                  e.target.value.replace(
                                                    /[^a-z0-9 ]/gi,
                                                    "",
                                                  );
                                              }}
                                              variant="outlined"
                                              fullWidth
                                            />
                                          </div>

                                          <div
                                            className="form-group col-md-12 col-lg-12"
                                            style={{ paddingLeft: "0px" }}
                                          >
                                            <MutextField
                                              id="status"
                                              name="status"
                                              select
                                              label="Status"
                                              value={this.state.status}
                                              onChange={this.handleChange}
                                              SelectProps={{
                                                native: true,
                                              }}
                                              helperText="e.g Active or Inactive"
                                              variant="outlined"
                                              fullWidth
                                            >
                                              <option key="status1" value="1">
                                                Active
                                              </option>
                                              <option key="status0" value="0">
                                                Inactive
                                              </option>
                                            </MutextField>
                                          </div>

                                          <div
                                            className="form-group col-md-12 col-lg-12"
                                            style={{ paddingLeft: "0px" }}
                                          >
                                            <MutextField
                                              id="landing_page"
                                              name="landing_page"
                                              select
                                              label="Landing Page"
                                              value={this.state.landing_page}
                                              onChange={this.handleChange}
                                              SelectProps={{
                                                native: true,
                                              }}
                                              helperText="Yes: Displays a landing page where the client can select a service and register. No: Skips the landing page and redirects the client directly to the registration page."
                                              variant="outlined"
                                              fullWidth
                                            >
                                              <option
                                                key="landing_page1"
                                                value="Yes"
                                              >
                                                Yes
                                              </option>
                                              <option
                                                key="landing_page0"
                                                value="No"
                                              >
                                                No
                                              </option>
                                            </MutextField>
                                          </div>

                                          <div
                                            className="form-group col-md-12 col-lg-12"
                                            style={{
                                              paddingLeft: "0px",
                                              textAlign: "right",
                                            }}
                                          >
                                            <button
                                              type="button"
                                              className="btn btn-lg btn-primary ml-2"
                                              onClick={this.saveSharelinkDetail}
                                              disabled={this.state.disabled}
                                            >
                                              <em className="icon ni ni-note-add"></em>
                                              {"  "} &nbsp;  Save 
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="tab-pane" id="tab-2">
                                      <div className="row">
                                        <div
                                          className="col-lg-12 details"
                                          style={{ paddingLeft: "0px" }}
                                        >
                                          <h3>Update Theme</h3>
                                          <div
                                            className="col-md-12 col-lg-12"
                                            style={{ paddingLeft: "0px" }}
                                          >
                                            {this.state.getThemeErrorMessage !==
                                              "" ? (
                                              <div
                                                className="example-alert"
                                                style={{
                                                  marginBottom: "15px",
                                                  color: "#526484",
                                                }}
                                              >
                                                <div className="alert alert-pro alert-danger">
                                                  <div className="alert-text">
                                                    <h4
                                                      style={{
                                                        color: "#364a63",
                                                      }}
                                                    >
                                                      Error
                                                    </h4>
                                                    <p
                                                      style={{
                                                        color: "#364a63",
                                                      }}
                                                    >
                                                      { this.state.getThemeErrorMessage }
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                            ) : null}
                                            {this.state
                                              .tableLoaderBlockImage ===
                                              true ? (
                                              tableLoaderBlockImage()
                                            ) : (
                                              <>
                                                {this.state.themesList &&
                                                  this.state.themesList.length >
                                                  0 ? (
                                                  <div
                                                    className="card card-bordered"
                                                    id="sharelink_div"
                                                  >
                                                    <div className="card-inner">
                                                      <div
                                                        className="row g-4"
                                                        style={{
                                                          padding: "0px",
                                                        }}
                                                      >
                                                        {this.state.themesList.map(
                                                          (themes) => (
                                                            <div
                                                              className="col-xl-6 col-lg-6 col-12"
                                                              key={`theme_key${themes.id}`}
                                                            >
                                                              <div
                                                                className={this.setThemeClassMain(
                                                                  themes.id,
                                                                )}
                                                              >
                                                                <div className="pricingTable-header">
                                                                  <img
                                                                    src={`../../assets/images/${themes.theme_image}`}
                                                                  />
                                                                </div>

                                                                <a
                                                                  onClick={() =>
                                                                    this.setTheme(
                                                                      themes.id,
                                                                    )
                                                                  }
                                                                  className={this.setThemeClass(
                                                                    themes.id,
                                                                  )}
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                    fontSize:
                                                                      "12px",
                                                                    paddingLeft:
                                                                      "25px",
                                                                    paddingRight:
                                                                      "25px",
                                                                  }}
                                                                >
                                                                  {this.state
                                                                    .theme ===
                                                                    themes.id ? (
                                                                    <em className="icon ni ni-done"></em>
                                                                  ) : null}
                                                                  {"  "}
                                                                  Choose Theme
                                                                  <i className="fa fa-angle-right"></i>
                                                                </a>
                                                              </div>
                                                            </div>
                                                          ),
                                                        )}
                                                      </div>
                                                    </div>
                                                  </div>
                                                ) : null}
                                              </>
                                            )}
                                            <div
                                              className="form-group col-md-3 col-lg-3"
                                              style={{
                                                paddingLeft: "0px",
                                                marginTop: "20px",
                                              }}
                                            >
                                              <MutextField
                                                required
                                                id="buttonColor"
                                                name="buttonColor"
                                                type="color"
                                                label="Pick a Color"
                                                value={this.state.buttonColor}
                                                onChange={this.handleChange}
                                                helperText="Choose a color for your Buttons."
                                                variant="outlined"
                                                fullWidth
                                              />
                                            </div>{" "}
                                          </div>
                                          <div
                                            className="form-group col-md-12 col-lg-12"
                                            style={{
                                              marginTop: "20px",
                                              paddingLeft: "0px",
                                              textAlign: "right",
                                            }}
                                          >
                                            {this.state.themesList &&
                                              this.state.themesList.length > 0 ? (
                                              <button
                                                type="button"
                                                className="btn btn-lg btn-primary"
                                                onClick={
                                                  this.saveSharelinkTheme
                                                }
                                                disabled={this.state.disabled}
                                              >
                                                <em className="icon ni ni-note-add"></em>
                                                {"  "}&nbsp; Save 
                                              </button>
                                            ) : null}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="tab-pane" id="tab-3">
                                      <div className="row">
                                        <h3
                                          style={{
                                            color: "#526484",
                                            fontSize: "26px",
                                            fontWeight: "500",
                                            marginBottom: "20px",
                                          }}
                                        >
                                          Update Services
                                        </h3>
                                        <div
                                          className="col-lg-12 details"
                                          style={{ paddingLeft: "0px" }}
                                        >
                                          {this.state.getServiceErrorMessage !==
                                            "" ? (
                                            <div
                                              className="example-alert"
                                              style={{
                                                marginBottom: "15px",
                                                color: "#526484",
                                              }}
                                            >
                                              <div className="alert alert-pro alert-danger">
                                                <div className="alert-text">
                                                  <h4
                                                    style={{
                                                      color: "#364a63",
                                                    }}
                                                  >
                                                    Error
                                                  </h4>
                                                  <p
                                                    style={{
                                                      color: "#364a63",
                                                    }}
                                                  >
                                                    {
                                                      this.state
                                                        .getServiceErrorMessage
                                                    }
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                          ) : null}
                                          {this.state
                                            .tableLoaderBlockService ===
                                            true ? (
                                            tableLoaderBlockImage()
                                          ) : (
                                            <>
                                              {this.state.serviceData &&
                                                this.state.serviceData.length >
                                                0 ? (
                                                <div className="card card-bordered">
                                                  <div className="card-inner">
                                                    {/** NEW SERVICE BLOCK **/}
                                                    <div className="selectedservicetypes"
                                                      style={{
                                                        marginBottom: "1.5rem",
                                                      }}
                                                    >
                                                      <Select
                                                        options={
                                                          this.state
                                                            .all_service_types
                                                        }
                                                        name="selected_service_types"
                                                        placeholder="Select service types"
                                                        value={
                                                          this.state
                                                            .selected_service_types
                                                        }
                                                        autoComplete="off"
                                                        onChange={
                                                          this
                                                            .handleChangeSearch
                                                        }
                                                        isClearable
                                                        isSearchable
                                                        isMulti
                                                        styles={{
                                                          control: (
                                                            baseStyles,
                                                            state,
                                                          ) => ({
                                                            ...baseStyles,
                                                            lineHeight: "40px",
                                                          }),
                                                          option: (
                                                            baseStyles,
                                                            state,
                                                          ) => ({
                                                            ...baseStyles,
                                                            color: "black",
                                                            backgroundColor:
                                                              state.isFocused
                                                                ? "#e0e0e0"
                                                                : "white",
                                                            "&:hover": {
                                                              backgroundColor:
                                                                "#f0f0f0",
                                                            },
                                                          }),
                                                          menu: (
                                                            baseStyles,
                                                          ) => ({
                                                            ...baseStyles,
                                                            zIndex: 9999,
                                                          }),
                                                        }}
                                                      />
                                                    </div>
                                                    <div className="nk-block">
                                                      {filtered_services.map(
                                                        (services, sid) => (
                                                          <div
                                                            className={this.setServiceClassMain(
                                                              services.id,
                                                            )}
                                                            key={`servKey${sid}`}
                                                          >
                                                            <div className="row no-gutters">
                                                              <div className="col-md-8">
                                                                <div className="sp-plan-info card-inner">
                                                                  <div className="row gx-0 gy-3">
                                                                    <div className="col-xl-9 col-sm-8">
                                                                      <div className="sp-plan-name">
                                                                        <h6 className="title">
                                                                          <a
                                                                            style={{
                                                                              cursor:
                                                                                "pointer",
                                                                              color:
                                                                                "#6576ff",
                                                                            }}
                                                                          >
                                                                            {
                                                                              services.service_title
                                                                            }{" "}
                                                                            {services.coming_soon == 1 ? (
                                                                              <span className="badge badge-outline-warning">
                                                                                <em className="icon ni ni-clock"></em>{" "}Coming Soon
                                                                              </span>
                                                                            ) : null}
                                                                            {/*<span className="badge badge-outline-primary">
                                                                              {services.service_type ===
                                                                              "did"
                                                                                ? "DID Origination"
                                                                                : ""}
                                                                              {services.service_type ===
                                                                              "tfn"
                                                                                ? "Toll Free Origination"
                                                                                : ""}
                                                                              {services.service_type ===
                                                                              "term"
                                                                                ? "Voice Termination"
                                                                                : ""}
                                                                              {services.service_type ===
                                                                              "teams"
                                                                                ? "Microsoft Teams UCAAS"
                                                                                : ""}
                                                                              {services.service_type ===
                                                                              "ivr"
                                                                                ? "Voyce Admins"
                                                                                : ""}
                                                                              {services.service_type ===
                                                                              "tfn_term"
                                                                                ? "Toll Free Termination"
                                                                                : ""}
                                                                              {services.service_type ===
                                                                              "az_term"
                                                                                ? "International A-Z Termination"
                                                                                : ""}
                                                                              {services.service_type ===
                                                                              "live_agent"
                                                                                ? "Live Agent"
                                                                                : ""}
                                                                              {services.service_type ===
                                                                              "live_agent"
                                                                                ? "CNAM"
                                                                                : ""}
                                                                              {services.service_type ===
                                                                              "sms"
                                                                                ? "SMS Inbound / Outbound"
                                                                                : ""}
                                                                              {services.service_type ===
                                                                              "generic"
                                                                                ? "Other Services"
                                                                                : ""}
                                                                              {services.service_type ===
                                                                              "cnam"
                                                                                ? "CNAM"
                                                                                : ""}
                                                                            </span>*/}
                                                                            <span className="badge badge-outline-primary">
                                                                              {services.product_title &&
                                                                                services.product_title !==
                                                                                ""
                                                                                ? `${services.product_title}`
                                                                                : ""}
                                                                            </span>
                                                                          </a>
                                                                        </h6>
                                                                        <p>
                                                                          Type:{" "}
                                                                          <span className="text-base">
                                                                            {services.per_min_type ===
                                                                              "unmetered"
                                                                              ? "Unmetered"
                                                                              : "Metered"}
                                                                          </span>
                                                                        </p>
                                                                      </div>
                                                                    </div>
                                                                    <div className="col-xl-3 col-sm-4"></div>
                                                                  </div>
                                                                </div>
                                                                <div className="sp-plan-desc card-inner">
                                                                  {services.service_type ===
                                                                    "did" ||
                                                                    services.service_type ===
                                                                    "tfn" ||
                                                                    services.service_type ===
                                                                    "teams" ? (
                                                                    <ul className="row gx-1">
                                                                      <li className="col-6 col-lg-3">
                                                                        <p>
                                                                          <span className="text-soft">
                                                                            NRC{" "}
                                                                            <Tooltip
                                                                              title="Non-Recurring Charge – A one-time fee that is deducted on service setup."
                                                                              placement="top"
                                                                            >
                                                                              <em
                                                                                className="icon ni ni-info"
                                                                                style={{
                                                                                  color:
                                                                                    "#6576ff",
                                                                                }}
                                                                              ></em>
                                                                            </Tooltip>
                                                                          </span>{" "}
                                                                          $
                                                                          {services.nrc &&
                                                                            services.nrc !==
                                                                            null &&
                                                                            services.nrc !==
                                                                            ""
                                                                            ? services.nrc.toFixed(
                                                                              4,
                                                                            )
                                                                            : "0.00"}
                                                                        </p>
                                                                      </li>
                                                                      <li className="col-6 col-lg-3">
                                                                        <p>
                                                                          <span className="text-soft">
                                                                            MRC{" "}
                                                                            <Tooltip
                                                                              title="Monthly Recurring Charge - what you pay each month for the service."
                                                                              placement="top"
                                                                            >
                                                                              <em
                                                                                className="icon ni ni-info"
                                                                                style={{
                                                                                  color:
                                                                                    "#6576ff",
                                                                                }}
                                                                              ></em>
                                                                            </Tooltip>
                                                                          </span>{" "}
                                                                          $
                                                                          {services.mrc &&
                                                                            services.mrc !==
                                                                            null &&
                                                                            services.mrc !==
                                                                            ""
                                                                            ? services.mrc.toFixed(
                                                                              4,
                                                                            )
                                                                            : "0.00"}
                                                                        </p>
                                                                      </li>
                                                                      {services.main_type !==
                                                                        "ratedeck" &&
                                                                        services.per_min_type !==
                                                                        "unmetered" ? (
                                                                        <li className="col-6 col-lg-3">
                                                                          <p>
                                                                            <span className="text-soft">
                                                                              Rate
                                                                              Per
                                                                              Minute{" "}
                                                                              <Tooltip
                                                                                title="Rate assigned per minute."
                                                                                placement="top"
                                                                              >
                                                                                <em
                                                                                  className="icon ni ni-info"
                                                                                  style={{
                                                                                    color:
                                                                                      "#6576ff",
                                                                                  }}
                                                                                ></em>
                                                                              </Tooltip>
                                                                            </span>{" "}
                                                                            $
                                                                            {services.rate &&
                                                                              services.rate !==
                                                                              null &&
                                                                              services.rate !==
                                                                              ""
                                                                              ? services.rate.toFixed(
                                                                                4,
                                                                              )
                                                                              : "0.00"}
                                                                          </p>
                                                                        </li>
                                                                      ) : null}
                                                                      {services.per_min_type ===
                                                                        "unmetered" ? (
                                                                        <li className="col-6 col-lg-3">
                                                                          <p>
                                                                            <span className="text-soft">
                                                                              Rate
                                                                              Per
                                                                              Session{" "}
                                                                              <Tooltip
                                                                                title="Rate assigned per session."
                                                                                placement="top"
                                                                              >
                                                                                <em
                                                                                  className="icon ni ni-info"
                                                                                  style={{
                                                                                    color:
                                                                                      "#6576ff",
                                                                                  }}
                                                                                ></em>
                                                                              </Tooltip>
                                                                            </span>{" "}
                                                                            $
                                                                            {services.rate &&
                                                                              services.rate !==
                                                                              null &&
                                                                              services.rate !==
                                                                              ""
                                                                              ? services.rate.toFixed(
                                                                                4,
                                                                              )
                                                                              : "0.00"}
                                                                          </p>
                                                                        </li>
                                                                      ) : null}
                                                                      {services.main_type ===
                                                                        "ratedeck" ? (
                                                                        <>
                                                                          <li className="col-6 col-lg-3">
                                                                            <p>
                                                                              <span className="text-soft">
                                                                                Effective
                                                                                Date{" "}
                                                                                <Tooltip
                                                                                  title="Effective Date."
                                                                                  placement="top"
                                                                                >
                                                                                  <em
                                                                                    className="icon ni ni-info"
                                                                                    style={{
                                                                                      color:
                                                                                        "#6576ff",
                                                                                    }}
                                                                                  ></em>
                                                                                </Tooltip>
                                                                              </span>{" "}
                                                                              {services.effective_date &&
                                                                                services.effective_date !==
                                                                                null &&
                                                                                services.effective_date !==
                                                                                "" ? (
                                                                                <>
                                                                                  {this.format_date(
                                                                                    services.effective_date,
                                                                                  )}
                                                                                </>
                                                                              ) : null}
                                                                            </p>
                                                                          </li>
                                                                        </>
                                                                      ) : null}
                                                                      <li className="col-6 col-lg-3">
                                                                        <p>
                                                                          <span className="text-soft">
                                                                            Cancellation
                                                                            Fee{" "}
                                                                            <Tooltip
                                                                              title="A cancellation fee is a sum of money charged to a customer who has enlisted your services."
                                                                              placement="top"
                                                                            >
                                                                              <em
                                                                                className="icon ni ni-info"
                                                                                style={{
                                                                                  color:
                                                                                    "#6576ff",
                                                                                }}
                                                                              ></em>
                                                                            </Tooltip>
                                                                          </span>{" "}
                                                                          $
                                                                          {services.cancellation_fee &&
                                                                            services.cancellation_fee !==
                                                                            null &&
                                                                            services.cancellation_fee !==
                                                                            ""
                                                                            ? services.cancellation_fee.toFixed(
                                                                              4,
                                                                            )
                                                                            : "0.00"}
                                                                        </p>
                                                                      </li>
                                                                    </ul>
                                                                  ) : null}
                                                                  {services.service_type ===
                                                                    "term" ||
                                                                    services.service_type ===
                                                                    "ivr" ||
                                                                    services.service_type ===
                                                                    "live_agent" ||
                                                                    services.service_type ===
                                                                    "tfn_term" ||
                                                                    services.service_type ===
                                                                    "az_term" ||
                                                                    services.service_type ===
                                                                    "generic" ? (
                                                                    <ul className="row gx-1">
                                                                      {services.main_type !==
                                                                        "ratedeck" &&
                                                                        services.per_min_type !==
                                                                        "unmetered" ? (
                                                                        <li className="col-6 col-lg-3">
                                                                          <p>
                                                                            <span className="text-soft">
                                                                              {services.service_type ===
                                                                                "generic"
                                                                                ? "Rate"
                                                                                : "Rate Per Minute"}{" "}
                                                                              <Tooltip
                                                                                title={
                                                                                  services.service_type ===
                                                                                    "generic"
                                                                                    ? "Rate assigned"
                                                                                    : "Rate assigned per minute."
                                                                                }
                                                                                placement="top"
                                                                              >
                                                                                <em
                                                                                  className="icon ni ni-info"
                                                                                  style={{
                                                                                    color:
                                                                                      "#6576ff",
                                                                                  }}
                                                                                ></em>
                                                                              </Tooltip>
                                                                            </span>{" "}
                                                                            $
                                                                            {services.rate &&
                                                                              services.rate !==
                                                                              null &&
                                                                              services.rate !==
                                                                              ""
                                                                              ? services.rate.toFixed(
                                                                                4,
                                                                              )
                                                                              : "0.00"}
                                                                          </p>
                                                                        </li>
                                                                      ) : null}
                                                                      {services.per_min_type ===
                                                                        "unmetered" ? (
                                                                        <li className="col-6 col-lg-3">
                                                                          <p>
                                                                            <span className="text-soft">
                                                                              {services.service_type ===
                                                                                "generic"
                                                                                ? "Session Rate"
                                                                                : "Rate Per Session"}{" "}
                                                                              <Tooltip
                                                                                title={
                                                                                  services.service_type ===
                                                                                    "generic"
                                                                                    ? "Session rate assigned"
                                                                                    : "Rate assigned per session"
                                                                                }
                                                                                placement="top"
                                                                              >
                                                                                <em
                                                                                  className="icon ni ni-info"
                                                                                  style={{
                                                                                    color:
                                                                                      "#6576ff",
                                                                                  }}
                                                                                ></em>
                                                                              </Tooltip>
                                                                            </span>{" "}
                                                                            $
                                                                            {services.rate &&
                                                                              services.rate !==
                                                                              null &&
                                                                              services.rate !==
                                                                              ""
                                                                              ? services.rate.toFixed(
                                                                                4,
                                                                              )
                                                                              : "0.00"}
                                                                          </p>
                                                                        </li>
                                                                      ) : null}
                                                                      {services.main_type ===
                                                                        "ratedeck" ? (
                                                                        <>
                                                                          <li className="col-6 col-lg-3">
                                                                            <p>
                                                                              <span className="text-soft">
                                                                                Effective
                                                                                Date{" "}
                                                                                <Tooltip
                                                                                  title="Effective Date."
                                                                                  placement="top"
                                                                                >
                                                                                  <em
                                                                                    className="icon ni ni-info"
                                                                                    style={{
                                                                                      color:
                                                                                        "#6576ff",
                                                                                    }}
                                                                                  ></em>
                                                                                </Tooltip>
                                                                              </span>{" "}
                                                                              {services.effective_date &&
                                                                                services.effective_date !==
                                                                                null &&
                                                                                services.effective_date !==
                                                                                "" ? (
                                                                                <>
                                                                                  {this.format_date(
                                                                                    services.effective_date,
                                                                                  )}
                                                                                </>
                                                                              ) : null}
                                                                            </p>
                                                                          </li>
                                                                        </>
                                                                      ) : null}
                                                                      <li className="col-6 col-lg-3">
                                                                        <p>
                                                                          <span className="text-soft">
                                                                            Cancellation
                                                                            Fee{" "}
                                                                            <Tooltip
                                                                              title="A cancellation fee is a sum of money charged to a customer who has enlisted your services."
                                                                              placement="top"
                                                                            >
                                                                              <em
                                                                                className="icon ni ni-info"
                                                                                style={{
                                                                                  color:
                                                                                    "#6576ff",
                                                                                }}
                                                                              ></em>
                                                                            </Tooltip>
                                                                          </span>{" "}
                                                                          $
                                                                          {services.cancellation_fee &&
                                                                            services.cancellation_fee !==
                                                                            null &&
                                                                            services.cancellation_fee !==
                                                                            ""
                                                                            ? services.cancellation_fee.toFixed(
                                                                              4,
                                                                            )
                                                                            : "0.00"}
                                                                        </p>
                                                                      </li>
                                                                    </ul>
                                                                  ) : null}
                                                                  {services.service_type ===
                                                                    "sms" ? (
                                                                    <ul className="row gx-1">
                                                                      <li className="col-6 col-lg-3">
                                                                        <p>
                                                                          <span className="text-soft">
                                                                            SMS
                                                                            IN{" "}
                                                                            <Tooltip
                                                                              title="Price applied to SMS In Services."
                                                                              placement="top"
                                                                            >
                                                                              <em
                                                                                className="icon ni ni-info"
                                                                                style={{
                                                                                  color:
                                                                                    "#6576ff",
                                                                                }}
                                                                              ></em>
                                                                            </Tooltip>
                                                                          </span>{" "}
                                                                          $
                                                                          {services.sms_in &&
                                                                            services.sms_in !==
                                                                            null &&
                                                                            services.sms_in !==
                                                                            ""
                                                                            ? services.sms_in.toFixed(
                                                                              4,
                                                                            )
                                                                            : "0.00"}
                                                                        </p>
                                                                      </li>
                                                                      <li className="col-6 col-lg-3">
                                                                        <p>
                                                                          <span className="text-soft">
                                                                            SMS
                                                                            OUT{" "}
                                                                            <Tooltip
                                                                              title="Price applied to SMS Out Services."
                                                                              placement="top"
                                                                            >
                                                                              <em
                                                                                className="icon ni ni-info"
                                                                                style={{
                                                                                  color:
                                                                                    "#6576ff",
                                                                                }}
                                                                              ></em>
                                                                            </Tooltip>
                                                                          </span>{" "}
                                                                          $
                                                                          {services.sms_out &&
                                                                            services.sms_out !==
                                                                            null &&
                                                                            services.sms_out !==
                                                                            ""
                                                                            ? services.sms_out.toFixed(
                                                                              4,
                                                                            )
                                                                            : "0.00"}
                                                                        </p>
                                                                      </li>
                                                                      <li className="col-6 col-lg-3">
                                                                        <p>
                                                                          <span className="text-soft">
                                                                            Cancellation
                                                                            Fee{" "}
                                                                            <Tooltip
                                                                              title="A cancellation fee is a sum of money charged to a customer who has enlisted your services."
                                                                              placement="top"
                                                                            >
                                                                              <em
                                                                                className="icon ni ni-info"
                                                                                style={{
                                                                                  color:
                                                                                    "#6576ff",
                                                                                }}
                                                                              ></em>
                                                                            </Tooltip>
                                                                          </span>{" "}
                                                                          $
                                                                          {services.cancellation_fee &&
                                                                            services.cancellation_fee !==
                                                                            null &&
                                                                            services.cancellation_fee !==
                                                                            ""
                                                                            ? services.cancellation_fee.toFixed(
                                                                              4,
                                                                            )
                                                                            : "0.00"}
                                                                        </p>
                                                                      </li>
                                                                    </ul>
                                                                  ) : null}
                                                                  {services.service_type ===
                                                                    "cnam" ? (
                                                                    <ul className="row gx-1">
                                                                      <li className="col-6 col-lg-3">
                                                                        <p>
                                                                          <span className="text-soft">
                                                                            Update
                                                                            CNAM
                                                                            (MRC){" "}
                                                                            <Tooltip
                                                                              title="Price applied to Update CNAM (MRC)."
                                                                              placement="top"
                                                                            >
                                                                              <em
                                                                                className="icon ni ni-info"
                                                                                style={{
                                                                                  color:
                                                                                    "#6576ff",
                                                                                }}
                                                                              ></em>
                                                                            </Tooltip>
                                                                          </span>{" "}
                                                                          $
                                                                          {services.cnam_mrc &&
                                                                            services.cnam_mrc !==
                                                                            null &&
                                                                            services.cnam_mrc !==
                                                                            ""
                                                                            ? services.cnam_mrc.toFixed(
                                                                              4,
                                                                            )
                                                                            : "0.00"}
                                                                        </p>
                                                                      </li>
                                                                      <li className="col-6 col-lg-3">
                                                                        <p>
                                                                          <span className="text-soft">
                                                                            CNAM
                                                                            DIP{" "}
                                                                            <Tooltip
                                                                              title="Price applied to CNAM DIP."
                                                                              placement="top"
                                                                            >
                                                                              <em
                                                                                className="icon ni ni-info"
                                                                                style={{
                                                                                  color:
                                                                                    "#6576ff",
                                                                                }}
                                                                              ></em>
                                                                            </Tooltip>
                                                                          </span>{" "}
                                                                          $
                                                                          {services.cnam_dip &&
                                                                            services.cnam_dip !==
                                                                            null &&
                                                                            services.cnam_dip !==
                                                                            ""
                                                                            ? services.cnam_dip.toFixed(
                                                                              4,
                                                                            )
                                                                            : "0.00"}
                                                                        </p>
                                                                      </li>

                                                                      <li className="col-6 col-lg-3">
                                                                        <p>
                                                                          <span className="text-soft">
                                                                            Storage
                                                                            DIP{" "}
                                                                            <Tooltip
                                                                              title="Price applied to Storage DIP."
                                                                              placement="top"
                                                                            >
                                                                              <em
                                                                                className="icon ni ni-info"
                                                                                style={{
                                                                                  color:
                                                                                    "#6576ff",
                                                                                }}
                                                                              ></em>
                                                                            </Tooltip>
                                                                          </span>{" "}
                                                                          $
                                                                          {services.cnam_dip_local &&
                                                                            services.cnam_dip_local !==
                                                                            null &&
                                                                            services.cnam_dip_local !==
                                                                            ""
                                                                            ? services.cnam_dip_local.toFixed(
                                                                              4,
                                                                            )
                                                                            : "0.00"}
                                                                        </p>
                                                                      </li>

                                                                      <li className="col-6 col-lg-3">
                                                                        <p>
                                                                          <span className="text-soft">
                                                                            Cancellation
                                                                            Fee{" "}
                                                                            <Tooltip
                                                                              title="A cancellation fee is a sum of money charged to a customer who has enlisted your services."
                                                                              placement="top"
                                                                            >
                                                                              <em
                                                                                className="icon ni ni-info"
                                                                                style={{
                                                                                  color:
                                                                                    "#6576ff",
                                                                                }}
                                                                              ></em>
                                                                            </Tooltip>
                                                                          </span>{" "}
                                                                          $
                                                                          {services.cancellation_fee &&
                                                                            services.cancellation_fee !==
                                                                            null &&
                                                                            services.cancellation_fee !==
                                                                            ""
                                                                            ? services.cancellation_fee.toFixed(
                                                                              4,
                                                                            )
                                                                            : "0.00"}
                                                                        </p>
                                                                      </li>
                                                                    </ul>
                                                                  ) : null}
                                                                </div>
                                                              </div>
                                                              <div className="col-md-4">
                                                                <div className="sp-plan-action card-inner">
                                                                  <div className="sp-plan-btn">
                                                                    {services.coming_soon == 1 ? (
                                                                      <a
                                                                        style={{
                                                                          cursor: "not-allowed",
                                                                          opacity: 0.6,
                                                                          pointerEvents: "none",
                                                                        }}
                                                                        className="btn btn-dim btn-outline-warning btn-sm"
                                                                      >
                                                                        <span style={{ whiteSpace: "normal" }}>
                                                                          <em className="icon ni ni-clock"></em>
                                                                          {"  "}COMING SOON
                                                                        </span>
                                                                      </a>
                                                                    ) : (
                                                                      <a
                                                                        onClick={() =>
                                                                          this.setService(
                                                                            services.id,
                                                                          )
                                                                        }
                                                                        style={{
                                                                          cursor:
                                                                            "pointer",
                                                                        }}
                                                                        className={this.setServiceClass(
                                                                          services.id,
                                                                        )}
                                                                      >
                                                                        <span style={{ whiteSpace: "normal" }}>
                                                                          {this.state.selected_service.includes(
                                                                            services.id,
                                                                          ) ? (
                                                                            <em className="icon ni ni-done"></em>
                                                                          ) : null}
                                                                          {"  "}
                                                                          CHOOSE
                                                                          SERVICE
                                                                        </span>
                                                                      </a>
                                                                    )}
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        ),
                                                      )}
                                                    </div>
                                                    {/** NEW SERVICE BLOCK **/}
                                                  </div>
                                                </div>
                                              ) : null}
                                              <div
                                                className="form-group col-12 d-flex flex-column flex-lg-row justify-content-between mt-3"
                                              >
                                                <a
                                                  href={
                                                    this.state.complete_link
                                                  }
                                                  style={{ zIndex: "100" }}
                                                  target="_blank"
                                                  className="btn btn-outline-primary p-2 mb-2 mb-lg-0"
                                                >
                                                  Preview{" "}
                                                  {
                                                    localization.sharelinkPage
                                                      .label_single
                                                  }
                                                </a>
                                                {this.state.serviceData &&
                                                  this.state.serviceData.length >
                                                  0 ? (
                                                  <button
                                                    type="button"
                                                    className="btn btn-lg btn-primary"
                                                    onClick={
                                                      this.saveSharelinkServices
                                                    }
                                                    disabled={
                                                      this.state.disabled
                                                    }
                                                  >
                                                    <em className="icon ni ni-note-add"></em>
                                                    {"  "} &nbsp;  Save
                                                  </button>
                                                ) : null}
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="tab-pane" id="tab-33">
                                      <div className="row">
                                        <h3
                                          style={{
                                            color: "#526484",
                                            fontSize: "26px",
                                            fontWeight: "500",
                                            marginBottom: "20px",
                                          }}
                                        >
                                          Update Bundles
                                        </h3>
                                        <div
                                          className="col-lg-12 details"
                                          style={{ paddingLeft: "0px" }}
                                        >
                                          {this.state.getBundleErrorMessage !==
                                            "" ? (
                                            <div
                                              className="example-alert"
                                              style={{
                                                marginBottom: "15px",
                                                color: "#526484",
                                              }}
                                            >
                                              <div className="alert alert-pro alert-danger">
                                                <div className="alert-text">
                                                  <h4
                                                    style={{
                                                      color: "#364a63",
                                                    }}
                                                  >
                                                    Error
                                                  </h4>
                                                  <p
                                                    style={{
                                                      color: "#364a63",
                                                    }}
                                                  >
                                                    {
                                                      this.state
                                                        .getBundleErrorMessage
                                                    }
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                          ) : null}
                                          {this.state.tableLoaderBlockBundle ===
                                            true ? (
                                            tableLoaderBlockImage()
                                          ) : (
                                            <>
                                              {this.state.bundlesData &&
                                                this.state.bundlesData.length >
                                                0 ? (
                                                <>
                                                  <div className="card card-bordered">
                                                    <div className="card-inner">
                                                      {/** NEW SERVICE BLOCK **/}
                                                      <div className="nk-block">
                                                        {this.state.bundlesData.map(
                                                          (bundles, sid) => (
                                                            <div
                                                              className={this.setBundleClassMainNew(
                                                                bundles.id,
                                                              )}
                                                              key={`servKey${sid}`}
                                                            >
                                                              <div className="row no-gutters">
                                                                <div className="col-md-8">
                                                                  <div className="sp-plan-info card-inner">
                                                                    <div className="row gx-0 gy-3">
                                                                      <div className="col-xl-9 col-sm-8">
                                                                        <div className="sp-plan-name">
                                                                          <h6 className="title">
                                                                            <a
                                                                              style={{
                                                                                cursor:
                                                                                  "pointer",
                                                                                color:
                                                                                  "#6576ff",
                                                                              }}
                                                                            >
                                                                              {
                                                                                bundles.bundle_title
                                                                              }{" "}
                                                                              <span className="badge badge-outline-primary"></span>
                                                                            </a>
                                                                          </h6>
                                                                          <p>
                                                                            Assigned
                                                                            Services:{" "}
                                                                            <span className="text-base">
                                                                              <span className="badge badge-outline-primary">
                                                                                VIEW
                                                                              </span>
                                                                            </span>
                                                                          </p>
                                                                        </div>
                                                                      </div>
                                                                      <div className="col-xl-3 col-sm-4"></div>
                                                                    </div>
                                                                  </div>
                                                                  <div className="sp-plan-desc card-inner">
                                                                    <ul className="row gx-1">
                                                                      <li className="col-6 col-lg-4">
                                                                        <p>
                                                                          <span className="text-soft">
                                                                            Per
                                                                            Month
                                                                            Rate
                                                                            (Charge
                                                                            Monthly){" "}
                                                                            <Tooltip
                                                                              title="Per Month Rate (Charge Monthly)"
                                                                              placement="top"
                                                                            >
                                                                              <em
                                                                                className="icon ni ni-info"
                                                                                style={{
                                                                                  color:
                                                                                    "#6576ff",
                                                                                }}
                                                                              ></em>
                                                                            </Tooltip>
                                                                          </span>{" "}
                                                                          $
                                                                          {bundles.per_month_rate.toFixed(
                                                                            4,
                                                                          )}
                                                                        </p>
                                                                      </li>
                                                                      <li className="col-6 col-lg-4">
                                                                        <p>
                                                                          <span className="text-soft">
                                                                            Per
                                                                            Month
                                                                            Rate
                                                                            (Charge
                                                                            Yearly)
                                                                            <Tooltip
                                                                              title="Per Month Rate (Charge Yearly)"
                                                                              placement="top"
                                                                            >
                                                                              <em
                                                                                className="icon ni ni-info"
                                                                                style={{
                                                                                  color:
                                                                                    "#6576ff",
                                                                                }}
                                                                              ></em>
                                                                            </Tooltip>
                                                                          </span>{" "}
                                                                          $
                                                                          {bundles.per_year_rate.toFixed(
                                                                            4,
                                                                          )}
                                                                        </p>
                                                                      </li>

                                                                      <li className="col-6 col-lg-4">
                                                                        <p>
                                                                          <span className="text-soft">
                                                                            Date
                                                                            Added
                                                                            <Tooltip
                                                                              title="Date Added"
                                                                              placement="top"
                                                                            >
                                                                              <em
                                                                                className="icon ni ni-info"
                                                                                style={{
                                                                                  color:
                                                                                    "#6576ff",
                                                                                }}
                                                                              ></em>
                                                                            </Tooltip>
                                                                          </span>{" "}
                                                                          {bundles.date_added !==
                                                                            ""
                                                                            ? this.format_date(
                                                                              bundles.date_added,
                                                                            )
                                                                            : null}
                                                                        </p>
                                                                      </li>
                                                                    </ul>
                                                                  </div>
                                                                </div>
                                                                <div className="col-md-4">
                                                                  <div className="sp-plan-action card-inner">
                                                                    <div className="sp-plan-btn">
                                                                      <a
                                                                        onClick={() =>
                                                                          this.setBundles(
                                                                            bundles.id,
                                                                          )
                                                                        }
                                                                        style={{
                                                                          cursor:
                                                                            "pointer",
                                                                        }}
                                                                        className={this.setBundleClassNew(
                                                                          bundles.id,
                                                                        )}
                                                                      >
                                                                        <span>
                                                                          {this.state.selected_bundle.includes(
                                                                            bundles.id,
                                                                          ) ? (
                                                                            <em className="icon ni ni-done"></em>
                                                                          ) : null}
                                                                          {"  "}
                                                                          CHOOSE
                                                                          BUNDLE
                                                                        </span>
                                                                      </a>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          ),
                                                        )}
                                                      </div>
                                                      {/** NEW SERVICE BLOCK **/}
                                                    </div>
                                                  </div>
                                                  <div
                                                    className="form-group col-md-12 col-lg-12"
                                                    style={{
                                                      marginTop: "20px",
                                                      paddingLeft: "0px",
                                                      textAlign: "right",
                                                    }}
                                                  >
                                                    {this.state.bundlesData &&
                                                      this.state.bundlesData
                                                        .length > 0 ? (
                                                      <button
                                                        type="button"
                                                        className="btn btn-lg btn-primary"
                                                        onClick={
                                                          this
                                                            .saveSharelinkBundles
                                                        }
                                                        disabled={
                                                          this.state.disabled
                                                        }
                                                      >
                                                        <em className="icon ni ni-note-add"></em>
                                                        {"  "} &nbsp;  Save 
                                                      </button>
                                                    ) : null}
                                                  </div>
                                                </>
                                              ) : null}
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="tab-pane" id="tab-4">
                                      <div className="row">
                                        <div
                                          className="col-lg-12 col-md-12 col-xl-12 details"
                                          style={{
                                            marginLeft: "0px",
                                          }}
                                        >
                                          <h3>About Me Details</h3>
                                          {this.state.tableLoaderBlockAbout ===
                                            true ? (
                                            tableLoaderSimple()
                                          ) : (
                                            <>
                                              {this.state
                                                .getAboutErrorMessage !== "" ? (
                                                <div
                                                  className="example-alert"
                                                  style={{
                                                    marginBottom: "15px",
                                                    color: "#526484",
                                                  }}
                                                >
                                                  <div className="alert alert-pro alert-danger">
                                                    <div className="alert-text">
                                                      <h4
                                                        style={{
                                                          color: "#364a63",
                                                        }}
                                                      >
                                                        Error
                                                      </h4>
                                                      <p
                                                        style={{
                                                          color: "#364a63",
                                                        }}
                                                      >
                                                        {
                                                          this.state
                                                            .getAboutErrorMessage
                                                        }
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                              ) : null}
                                              {this.state
                                                .getAboutErrorMessage === "" ? (
                                                <div className="card card-bordered">
                                                  <div className="card-inner">
                                                    <FormControlLabel
                                                      style={{
                                                        marginBottom: "0px",
                                                        color: "#526484",
                                                      }}
                                                      control={
                                                        <Checkbox
                                                          checked={
                                                            this.state
                                                              .about_me_settings
                                                          }
                                                          onChange={
                                                            this.handleChange
                                                          }
                                                          name="about_me_settings"
                                                          id="about_me_settings"
                                                          color="primary"
                                                        />
                                                      }
                                                      label="About Me Selection"
                                                    />
                                                    {this.state
                                                      .about_me_settings ? (
                                                      <div
                                                        className="row g-4"
                                                        style={{
                                                          padding: "30px",
                                                        }}
                                                      >
                                                        <div className="col-lg-12">
                                                          <h6
                                                            style={{
                                                              color: "#526484",
                                                            }}
                                                          >
                                                            Banner Description
                                                          </h6>
                                                        </div>
                                                        <div className="col-lg-12">
                                                          {/*<TextareaAutosize
                                                            maxrows={4}
                                                            name="about_me_short"
                                                            id="about_me_short"
                                                            aria-label=""
                                                            placeholder=""
                                                            defaultValue={
                                                              this.state
                                                                .about_me_short
                                                            }
                                                            onChange={
                                                              this.handleChange
                                                            }
                                                            style={{
                                                              width: "100%",
                                                              height: "100px",
                                                              borderColor:
                                                                "rgba(0, 0, 0, 0.125)",
                                                              borderRadius:
                                                                "4px",
                                                              padding: "5px",
                                                            }}
                                                            maxLength={50}
                                                            variant="outlined"
                                                          />*/}
                                                          {this.state
                                                            .isEditorReady ? (
                                                            <>
                                                              <RichTextEditorComponent
                                                                agreementContent={
                                                                  this.state
                                                                    .about_me_short
                                                                }
                                                                onContentChange={
                                                                  this
                                                                    .handleEditorChangeShort
                                                                }
                                                              />
                                                            </>
                                                          ) : null}
                                                        </div>
                                                        <div className="col-lg-12">
                                                          <h6
                                                            style={{
                                                              color: "#526484",
                                                            }}
                                                          >
                                                            About Me
                                                          </h6>
                                                        </div>

                                                        <div className="col-lg-12">
                                                          <div className="form-group">
                                                            {this.state
                                                              .isEditorReady ? (
                                                              <>
                                                                <RichTextEditorComponent
                                                                  agreementContent={
                                                                    this.state
                                                                      .about_me
                                                                  }
                                                                  onContentChange={
                                                                    this
                                                                      .handleEditorChange
                                                                  }
                                                                />
                                                              </>
                                                            ) : null}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    ) : null}
                                                    <div
                                                      className="form-group col-12 d-flex flex-column flex-lg-row justify-content-between mt-3"
                                                    >
                                                      <a
                                                        href={this.state.complete_link}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="btn btn-outline-primary p-2 mb-2 mb-lg-0"
                                                      >
                                                        Preview {localization.sharelinkPage.label_single}
                                                      </a>

                                                      <button
                                                        type="button"
                                                        className="btn btn-lg btn-primary"
                                                        onClick={this.saveSharelinkAbout}
                                                        disabled={this.state.disabled}
                                                      >
                                                        <em className="icon ni ni-note-add"></em>{" "}
                                                     &nbsp;    Save 
                                                      </button>
                                                    </div>
                                                  </div>
                                                </div>
                                              ) : null}
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="tab-pane" id="tab-5">
                                      <div className="row">
                                        <div
                                          className="col-lg-12 col-md-12 col-xl-12 details"
                                          style={{
                                            marginLeft: "0px",
                                          }}
                                        >
                                          <h3>Social Media Links</h3>
                                          {this.state.tableLoaderBlockSocial ===
                                            true ? (
                                            tableLoaderSimple()
                                          ) : (
                                            <>
                                              {this.state
                                                .getSocialErrorMessage !==
                                                "" ? (
                                                <div
                                                  className="example-alert"
                                                  style={{
                                                    marginBottom: "15px",
                                                    color: "#526484",
                                                  }}
                                                >
                                                  <div className="alert alert-pro alert-danger">
                                                    <div className="alert-text">
                                                      <h4
                                                        style={{
                                                          color: "#364a63",
                                                        }}
                                                      >
                                                        Error
                                                      </h4>
                                                      <p
                                                        style={{
                                                          color: "#364a63",
                                                        }}
                                                      >
                                                        {
                                                          this.state
                                                            .getSocialErrorMessage
                                                        }
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                              ) : null}
                                              {this.state
                                                .getSocialErrorMessage ===
                                                "" ? (
                                                <>
                                                  <div className="card card-bordered">
                                                    <div className="card-inner">
                                                      <FormControlLabel
                                                        style={{
                                                          marginBottom: "0px",
                                                          color: "#526484",
                                                        }}
                                                        control={
                                                          <Checkbox
                                                            checked={
                                                              this.state
                                                                .social_settings
                                                            }
                                                            onChange={
                                                              this.handleChange
                                                            }
                                                            name="social_settings"
                                                            id="social_settings"
                                                            color="primary"
                                                          />
                                                        }
                                                        label="Social Media Links"
                                                      />
                                                      {this.state
                                                        .social_settings ? (
                                                        <div className="row g-4">
                                                          <div className="col-lg-12 d-flex justify-content-end">
                                                            <button
                                                              type="button"
                                                              className="btn btn-outline-secondary btn-sm"
                                                              onClick={this.clearSocialMediaLinks}
                                                            >
                                                              Clear All
                                                            </button>
                                                          </div>
                                                          <div className="col-lg-12">
                                                            <FormControl
                                                              fullWidth
                                                              variant="outlined"
                                                            >
                                                              <InputLabel htmlFor="instagram_link">
                                                                Instagram Link
                                                              </InputLabel>
                                                              <OutlinedInput
                                                                id="instagram_link"
                                                                name="instagram_link"
                                                                value={
                                                                  this.state
                                                                    .instagram_link
                                                                }
                                                                onChange={
                                                                  this
                                                                    .handleChange
                                                                }
                                                                startAdornment={
                                                                  <InputAdornment position="start">
                                                                    <em className="icon ni ni-instagram"></em>
                                                                  </InputAdornment>
                                                                }
                                                                labelWidth={110}
                                                              />
                                                              {this.state
                                                                .instagramError && (
                                                                  <span
                                                                    style={{
                                                                      color:
                                                                        "#e85347",
                                                                    }}
                                                                  >
                                                                    {
                                                                      this.state
                                                                        .instagramError
                                                                    }
                                                                  </span>
                                                                )}
                                                            </FormControl>
                                                          </div>

                                                          <div className="col-lg-12">
                                                            <FormControl
                                                              fullWidth
                                                              variant="outlined"
                                                            >
                                                              <InputLabel htmlFor="facebook_link">
                                                                Facebook Link
                                                              </InputLabel>
                                                              <OutlinedInput
                                                                id="facebook_link"
                                                                name="facebook_link"
                                                                value={
                                                                  this.state
                                                                    .facebook_link
                                                                }
                                                                onChange={
                                                                  this
                                                                    .handleChange
                                                                }
                                                                startAdornment={
                                                                  <InputAdornment position="start">
                                                                    <em className="icon ni ni-facebook-fill"></em>
                                                                  </InputAdornment>
                                                                }
                                                                labelWidth={110}
                                                              />
                                                              {this.state
                                                                .facebookError && (
                                                                  <span
                                                                    style={{
                                                                      color:
                                                                        "#e85347",
                                                                    }}
                                                                  >
                                                                    {
                                                                      this.state
                                                                        .facebookError
                                                                    }
                                                                  </span>
                                                                )}
                                                            </FormControl>
                                                          </div>

                                                          <div className="col-lg-12">
                                                            <FormControl
                                                              fullWidth
                                                              variant="outlined"
                                                            >
                                                              <InputLabel htmlFor="twitter_link">
                                                                X Link
                                                              </InputLabel>
                                                              <OutlinedInput
                                                                id="twitter_link"
                                                                name="twitter_link"
                                                                value={
                                                                  this.state
                                                                    .twitter_link
                                                                }
                                                                onChange={
                                                                  this
                                                                    .handleChange
                                                                }
                                                                startAdornment={
                                                                  <InputAdornment position="start">
                                                                    <svg
                                                                      aria-hidden="true"
                                                                      focusable="false"
                                                                      viewBox="0 0 24 24"
                                                                      width="16"
                                                                      height="16"
                                                                      fill="currentColor"
                                                                    >
                                                                      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.657l-5.214-6.817-5.966 6.817H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231Zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77Z" />
                                                                    </svg>
                                                                  </InputAdornment>
                                                                }
                                                                labelWidth={90}
                                                              />
                                                              {this.state
                                                                .twitterError && (
                                                                  <span
                                                                    style={{
                                                                      color:
                                                                        "#e85347",
                                                                    }}
                                                                  >
                                                                    {
                                                                      this.state
                                                                        .twitterError
                                                                    }
                                                                  </span>
                                                                )}
                                                            </FormControl>
                                                          </div>

                                                          <div className="col-lg-12">
                                                            <FormControl
                                                              fullWidth
                                                              variant="outlined"
                                                            >
                                                              <InputLabel htmlFor="linkedin_link">
                                                                Linkedin Link
                                                              </InputLabel>
                                                              <OutlinedInput
                                                                id="linkedin_link"
                                                                name="linkedin_link"
                                                                value={
                                                                  this.state
                                                                    .linkedin_link
                                                                }
                                                                onChange={
                                                                  this
                                                                    .handleChange
                                                                }
                                                                startAdornment={
                                                                  <InputAdornment position="start">
                                                                    <em className="icon ni ni-linkedin-round"></em>
                                                                  </InputAdornment>
                                                                }
                                                                labelWidth={100}
                                                              />
                                                              {this.state
                                                                .linkedinError && (
                                                                  <span
                                                                    style={{
                                                                      color:
                                                                        "#e85347",
                                                                    }}
                                                                  >
                                                                    {
                                                                      this.state
                                                                        .linkedinError
                                                                    }
                                                                  </span>
                                                                )}
                                                            </FormControl>
                                                          </div>

                                                          <div className="col-lg-12">
                                                            <FormControl
                                                              fullWidth
                                                              variant="outlined"
                                                            >
                                                              <InputLabel htmlFor="youtube_link">
                                                                Youtube Link
                                                              </InputLabel>
                                                              <OutlinedInput
                                                                id="youtube_link"
                                                                name="youtube_link"
                                                                value={
                                                                  this.state
                                                                    .youtube_link
                                                                }
                                                                onChange={
                                                                  this
                                                                    .handleChange
                                                                }
                                                                startAdornment={
                                                                  <InputAdornment position="start">
                                                                    <em className="icon ni ni-youtube"></em>
                                                                  </InputAdornment>
                                                                }
                                                                labelWidth={110}
                                                              />
                                                              {this.state
                                                                .youtubeError && (
                                                                  <span
                                                                    style={{
                                                                      color:
                                                                        "#e85347",
                                                                    }}
                                                                  >
                                                                    {
                                                                      this.state
                                                                        .youtubeError
                                                                    }
                                                                  </span>
                                                                )}
                                                            </FormControl>
                                                          </div>
                                                        </div>
                                                      ) : null}
                                                    </div>
                                                  </div>
                                                  <div
                                                    className="form-group col-md-12 col-lg-12"
                                                    style={{
                                                      marginTop: "20px",
                                                      paddingLeft: "0px",
                                                      textAlign: "right",
                                                    }}
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-lg btn-primary"
                                                      onClick={
                                                        this.saveSharelinkSocial
                                                      }
                                                      disabled={
                                                        this.state.disabled
                                                      }
                                                    >
                                                      <em className="icon ni ni-note-add"></em>
                                                      {"  "} &nbsp;  Save 
                                                      Links
                                                    </button>
                                                  </div>
                                                </>
                                              ) : null}
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="tab-pane" id="tab-6">
                                      <div className="row">
                                        <div
                                          className="col-lg-12 col-md-12 col-xl-12 details"
                                          style={{
                                            marginLeft: "0px",
                                          }}
                                        >
                                          <h3>Contact Details</h3>
                                          {this.state
                                            .tableLoaderBlockContact ===
                                            true ? (
                                            tableLoaderSimple()
                                          ) : (
                                            <>
                                              {this.state
                                                .getContactErrorMessage !==
                                                "" ? (
                                                <div
                                                  className="example-alert"
                                                  style={{
                                                    marginBottom: "15px",
                                                    color: "#526484",
                                                  }}
                                                >
                                                  <div className="alert alert-pro alert-danger">
                                                    <div className="alert-text">
                                                      <h4
                                                        style={{
                                                          color: "#364a63",
                                                        }}
                                                      >
                                                        Error
                                                      </h4>
                                                      <p
                                                        style={{
                                                          color: "#364a63",
                                                        }}
                                                      >
                                                        {
                                                          this.state
                                                            .getContactErrorMessage
                                                        }
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                              ) : null}
                                              {this.state
                                                .getContactErrorMessage ===
                                                "" ? (
                                                <>
                                                  <div className="card card-bordered">
                                                    <div className="card-inner">
                                                      <FormControlLabel
                                                        style={{
                                                          marginBottom: "0px",
                                                          color: "#526484",
                                                        }}
                                                        control={
                                                          <Checkbox
                                                            checked={
                                                              this.state
                                                                .contact_settings
                                                            }
                                                            onChange={
                                                              this.handleChange
                                                            }
                                                            name="contact_settings"
                                                            id="contact_settings"
                                                            color="primary"
                                                          />
                                                        }
                                                        label="Contact Settings"
                                                      />
                                                      {this.state
                                                        .contact_settings ? (
                                                        <div className="row g-4">
                                                          <div className="col-lg-12">
                                                            <FormControl
                                                              fullWidth
                                                              variant="outlined"
                                                            >
                                                              <InputLabel htmlFor="contact_email">
                                                                Email Address
                                                              </InputLabel>
                                                              <OutlinedInput
                                                                id="contact_email"
                                                                name="contact_email"
                                                                value={
                                                                  this.state
                                                                    .contact_email
                                                                }
                                                                onChange={
                                                                  this
                                                                    .handleChange
                                                                }
                                                                startAdornment={
                                                                  <InputAdornment position="start">
                                                                    <em className="icon ni ni-emails"></em>
                                                                  </InputAdornment>
                                                                }
                                                                labelWidth={110}
                                                              />
                                                              {this.state
                                                                .emailError && (
                                                                  <span
                                                                    style={{
                                                                      color:
                                                                        "#e85347",
                                                                    }}
                                                                  >
                                                                    {
                                                                      this.state
                                                                        .emailError
                                                                    }
                                                                  </span>
                                                                )}
                                                            </FormControl>
                                                          </div>

                                                          <div className="col-lg-12">
                                                            <ReactPhoneInput
                                                              country={"us"}
                                                              value={this.state.contact_phone}
                                                              specialLabel="Phone"
                                                              onChange={(value) =>
                                                                this.handleChange({
                                                                  target: {
                                                                    name: "contact_phone",
                                                                    value,
                                                                  },
                                                                })
                                                              }
                                                              containerClass="customStyle-phone_input-add_sharelink"
                                                              inputClass={
                                                                this.state.phoneError ? "error-border" : "default-border"
                                                              }
                                                              inputProps={{
                                                                name: "contact_phone",
                                                                id: "contact_phone",
                                                                maxLength: 20,
                                                                required: true,
                                                              }}
                                                              inputStyle={{
                                                                width: "100%", height: "53px"
                                                              }}
                                                              onFocus={this.handleFocus}
                                                              ref={this.phoneInputRef}
                                                            />
                                                          </div>

                                                          <div className="col-lg-12">
                                                            <FormControl
                                                              fullWidth
                                                              variant="outlined"
                                                            >
                                                              <InputLabel htmlFor="contact_address">
                                                                Address
                                                              </InputLabel>
                                                              <OutlinedInput
                                                                id="contact_address"
                                                                name="contact_address"
                                                                value={
                                                                  this.state
                                                                    .contact_address ||
                                                                  ""
                                                                }
                                                                onChange={
                                                                  this
                                                                    .handleChange
                                                                }
                                                                startAdornment={
                                                                  <InputAdornment position="start">
                                                                    <em className="icon ni ni-home"></em>
                                                                  </InputAdornment>
                                                                }
                                                                labelWidth={70}
                                                              />
                                                              {this.state
                                                                .addressError && (
                                                                  <span
                                                                    style={{
                                                                      color:
                                                                        "#e85347",
                                                                    }}
                                                                  >
                                                                    {
                                                                      this.state
                                                                        .addressError
                                                                    }
                                                                  </span>
                                                                )}
                                                            </FormControl>
                                                          </div>
                                                        </div>
                                                      ) : null}
                                                    </div>
                                                  </div>
                                                  <div
                                                    className="form-group col-md-12 col-lg-12"
                                                    style={{
                                                      marginTop: "20px",
                                                      paddingLeft: "0px",
                                                      textAlign: "right",
                                                    }}
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-lg btn-primary"
                                                      onClick={
                                                        this
                                                          .saveSharelinkContact
                                                      }
                                                      disabled={
                                                        this.state.disabled
                                                      }
                                                    >
                                                      <em className="icon ni ni-note-add"></em>
                                                      {"  "} &nbsp; Save 
                                                    </button>
                                                  </div>
                                                </>
                                              ) : null}
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    </div>

                                    <div className="tab-pane" id="tab-11">
                                      <div className="row">
                                        <div
                                          className="col-lg-12 col-md-12 col-xl-12 details"
                                          style={{
                                            marginLeft: "0px",
                                          }}
                                        >
                                          <h3>Lead Form Settings</h3>
                                          {this.state.tableLoaderBlockLeadForm ===
                                          true ? (
                                            tableLoaderSimple()
                                          ) : (
                                            <>
                                              {this.state.getContactErrorMessage !==
                                              "" ? (
                                                <div
                                                  className="example-alert"
                                                  style={{
                                                    marginBottom: "15px",
                                                    color: "#526484",
                                                  }}
                                                >
                                                  <div className="alert alert-pro alert-danger">
                                                    <div className="alert-text">
                                                      <h4
                                                        style={{
                                                          color: "#364a63",
                                                        }}
                                                      >
                                                        Error
                                                      </h4>
                                                      <p
                                                        style={{
                                                          color: "#364a63",
                                                        }}
                                                      >
                                                        {
                                                          this.state
                                                            .getContactErrorMessage
                                                        }
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                              ) : null}
                                              {this.state.getContactErrorMessage ===
                                              "" ? (
                                                <>
                                                  <div className="card card-bordered">
                                                    <div className="card-inner">
                                                      <FormControlLabel
                                                        style={{
                                                          marginBottom: "0px",
                                                          color: "#526484",
                                                        }}
                                                        control={
                                                          <Switch
                                                            checked={
                                                              this.getNormalizedLeadFormSettings()
                                                                .enabled
                                                            }
                                                            onChange={this.handleLeadFormRootToggle(
                                                              "enabled",
                                                            )}
                                                            color="primary"
                                                          />
                                                        }
                                                        label="Enable Lead Form"
                                                      />
                                                      {this.getNormalizedLeadFormSettings()
                                                        .enabled ? (
                                                        <div className="row g-4" style={{ paddingTop: "10px" }}>
                                                          <div className="col-lg-6">
                                                            <MutextField
                                                              id="submitButtonText"
                                                              name="submitButtonText"
                                                              type="text"
                                                              label="Submit Button Text"
                                                              inputProps={{ maxLength: 40 }}
                                                              value={
                                                                this.getNormalizedLeadFormSettings()
                                                                  .submitButtonText
                                                              }
                                                              onChange={this.handleLeadFormTextChange}
                                                              variant="outlined"
                                                              fullWidth
                                                            />
                                                          </div>
                                                          <div className="col-lg-6">
                                                            <MutextField
                                                              id="successMessage"
                                                              name="successMessage"
                                                              type="text"
                                                              label="Success Message"
                                                              inputProps={{ maxLength: 200 }}
                                                              value={
                                                                this.getNormalizedLeadFormSettings()
                                                                  .successMessage
                                                              }
                                                              onChange={this.handleLeadFormTextChange}
                                                              variant="outlined"
                                                              fullWidth
                                                            />
                                                          </div>
                                                          <div className="col-lg-6">
                                                            <FormControlLabel
                                                              style={{ marginBottom: "0px", color: "#526484" }}
                                                              control={
                                                                <Switch
                                                                  checked={
                                                                    this.getNormalizedLeadFormSettings()
                                                                      .showOnBanner
                                                                  }
                                                                  onChange={this.handleLeadFormRootToggle(
                                                                    "showOnBanner",
                                                                  )}
                                                                  color="primary"
                                                                />
                                                              }
                                                              label="Show On Banner"
                                                            />
                                                          </div>
                                                          <div className="col-lg-6">
                                                            <FormControlLabel
                                                              style={{ marginBottom: "0px", color: "#526484" }}
                                                              control={
                                                                <Switch
                                                                  checked={
                                                                    this.getNormalizedLeadFormSettings()
                                                                      .showOnContactPage
                                                                  }
                                                                  onChange={this.handleLeadFormRootToggle(
                                                                    "showOnContactPage",
                                                                  )}
                                                                  color="primary"
                                                                />
                                                              }
                                                              label="Show On Contact Page"
                                                            />
                                                          </div>
                                                          <div className="col-lg-6">
                                                            <FormControlLabel
                                                              style={{ marginBottom: "0px", color: "#526484" }}
                                                              control={
                                                                <Switch
                                                                  checked={
                                                                    this.getNormalizedLeadFormSettings()
                                                                      .collapsed
                                                                  }
                                                                  onChange={this.handleLeadFormRootToggle(
                                                                    "collapsed",
                                                                  )}
                                                                  color="primary"
                                                                />
                                                              }
                                                              label="Collapse By Default"
                                                            />
                                                          </div>

                                                          <div className="col-lg-12">
                                                            <h6 style={{ marginBottom: "12px", color: "#526484" }}>
                                                              Lead Fields
                                                            </h6>
                                                            {LEAD_FORM_SECTIONS.map((section) => (
                                                              <div key={section.title} style={{ marginBottom: "18px" }}>
                                                                <div
                                                                  style={{
                                                                    fontWeight: 700,
                                                                    color: "#364a63",
                                                                    marginBottom: "10px",
                                                                    fontSize: "14px",
                                                                    textTransform: "uppercase",
                                                                    letterSpacing: "0.04em",
                                                                  }}
                                                                >
                                                                  {section.title}
                                                                </div>
                                                                {section.fields.map((fieldKey) => {
                                                                  const fieldSettings =
                                                                    this.getNormalizedLeadFormSettings()
                                                                      .fields[fieldKey];
                                                                  const fieldLabel =
                                                                    LEAD_FORM_FIELD_LABELS[fieldKey] || fieldKey;

                                                                  return (
                                                                    <div
                                                                      key={fieldKey}
                                                                      className="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center"
                                                                      style={{
                                                                        border: "1px solid #dbdfea",
                                                                        borderRadius: "6px",
                                                                        padding: "10px 12px",
                                                                        marginBottom: "10px",
                                                                        background: "#fff",
                                                                      }}
                                                                    >
                                                                      <strong
                                                                        style={{
                                                                          color: "#364a63",
                                                                          minWidth: "160px",
                                                                        }}
                                                                      >
                                                                        {fieldLabel}
                                                                      </strong>
                                                                      <div className="d-flex flex-column flex-md-row">
                                                                        <FormControlLabel
                                                                          style={{
                                                                            marginBottom: "0px",
                                                                            marginRight: "8px",
                                                                            color: "#526484",
                                                                          }}
                                                                          control={
                                                                            <Switch
                                                                              checked={fieldSettings.enabled}
                                                                              onChange={this.handleLeadFormFieldToggle(
                                                                                fieldKey,
                                                                                "enabled",
                                                                              )}
                                                                              color="primary"
                                                                            />
                                                                          }
                                                                          label="Enabled"
                                                                        />
                                                                        <FormControlLabel
                                                                          style={{ marginBottom: "0px", color: "#526484" }}
                                                                          control={
                                                                            <Switch
                                                                              checked={fieldSettings.required}
                                                                              onChange={this.handleLeadFormFieldToggle(
                                                                                fieldKey,
                                                                                "required",
                                                                              )}
                                                                              color="primary"
                                                                              disabled={!fieldSettings.enabled}
                                                                            />
                                                                          }
                                                                          label="Required"
                                                                        />
                                                                      </div>
                                                                    </div>
                                                                  );
                                                                })}
                                                              </div>
                                                            ))}
                                                          </div>
                                                        </div>
                                                      ) : null}
                                                    </div>
                                                  </div>
                                                  <div
                                                    className="form-group col-md-12 col-lg-12"
                                                    style={{
                                                      marginTop: "20px",
                                                      paddingLeft: "0px",
                                                      textAlign: "right",
                                                    }}
                                                  >
                                                    <button
                                                      type="button"
                                                      className="btn btn-lg btn-primary"
                                                      onClick={
                                                        this.saveSharelinkLeadForm
                                                      }
                                                      disabled={
                                                        this.state.disabled
                                                      }
                                                    >
                                                      <em className="icon ni ni-note-add"></em>
                                                      {"  "} &nbsp;  Save 
                                                    </button>
                                                  </div>
                                                </>
                                              ) : null}
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    </div>

                                    <div className="tab-pane" id="tab-7">
                                      <div className="row">
                                        <div
                                          className="col-lg-12 col-md-12 col-xl-12 details"
                                          style={{
                                            marginLeft: "0px",
                                          }}
                                        >
                                          <h3>SEO Details</h3>
                                          {this.state.tableLoaderBlockSEO ===
                                            true ? (
                                            tableLoaderSimple()
                                          ) : (
                                            <>
                                              {this.state.getSeoErrorMessage !==
                                                "" ? (
                                                <div
                                                  className="example-alert"
                                                  style={{
                                                    marginBottom: "15px",
                                                    color: "#526484",
                                                  }}
                                                >
                                                  <div className="alert alert-pro alert-danger">
                                                    <div className="alert-text">
                                                      <h4
                                                        style={{
                                                          color: "#364a63",
                                                        }}
                                                      >
                                                        Error
                                                      </h4>
                                                      <p
                                                        style={{
                                                          color: "#364a63",
                                                        }}
                                                      >
                                                        {
                                                          this.state
                                                            .getSeoErrorMessage
                                                        }
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                              ) : null}
                                              {this.state.getSeoErrorMessage ===
                                                "" ? (
                                                <div className="card card-bordered">
                                                  <div className="card-inner">
                                                    <div
                                                      className="row g-4"
                                                      style={{
                                                        padding: "30px",
                                                      }}
                                                    >
                                                      <div className="form-group col-md-12 col-lg-12 col-xxl-12">
                                                        <MutextField
                                                          id="selectedSeoPage"
                                                          name="selectedSeoPage"
                                                          select
                                                          label="SEO Page"
                                                          value={this.state.selectedSeoPage}
                                                          onChange={this.handleChange}
                                                          SelectProps={{
                                                            native: true,
                                                          }}
                                                          helperText="Select page-specific SEO settings."
                                                          variant="outlined"
                                                          fullWidth
                                                        >
                                                          <option value="home">Home</option>
                                                          <option value="about">About</option>
                                                          <option value="services">Services</option>
                                                          <option value="contact">Contact</option>
                                                          <option value="process">Process</option>
                                                        </MutextField>
                                                      </div>
                                                      <div className="form-group col-md-12 col-lg-12 col-xxl-12">
                                                        <MutextField
                                                          required
                                                          id="meta_title"
                                                          name="meta_title"
                                                          type="text"
                                                          label={`${localization.sharelinkPage.label_single} SEO Title`}
                                                          inputProps={{
                                                            maxLength: 100,
                                                          }}
                                                          value={currentSeoPageData.meta_title || ""}
                                                          onChange={
                                                            this.handleChange
                                                          }
                                                          helperText="Enter the SEO title here."
                                                          variant="outlined"
                                                          fullWidth
                                                        />
                                                      </div>
                                                      <div className="col-lg-12">
                                                        <h6
                                                          style={{
                                                            color: "#526484",
                                                          }}
                                                        >
                                                          Meta Description
                                                        </h6>
                                                      </div>
                                                      <div className="col-lg-12">
                                                        <TextareaAutosize
                                                          maxrows={4}
                                                          name="meta_description"
                                                          id="meta_description"
                                                          aria-label=""
                                                          placeholder=""
                                                          value={currentSeoPageData.meta_description || ""}
                                                          onChange={
                                                            this.handleChange
                                                          }
                                                          style={{
                                                            width: "100%",
                                                            height: "100px",
                                                            borderColor:
                                                              "rgba(0, 0, 0, 0.125)",
                                                            borderRadius: "4px",
                                                            padding: "15px",
                                                          }}
                                                          variant="outlined"
                                                        />
                                                      </div>
                                                      <div className="form-group col-md-12 col-lg-6 col-xxl-6">
                                                        <MutextField
                                                          id="slug"
                                                          name="slug"
                                                          type="text"
                                                          label="SEO Slug"
                                                          value={this.state.slug}
                                                          onChange={this.handleChange}
                                                          helperText="Enter the SEO-friendly slug here."
                                                          variant="outlined"
                                                          fullWidth
                                                        />
                                                      </div>
                                                      <div className="form-group col-md-12 col-lg-6 col-xxl-6">
                                                        <MutextField
                                                          id="ogImage"
                                                          name="ogImage"
                                                          type="url"
                                                          label="Open Graph Image URL"
                                                          value={currentSeoPageData.meta_og_image || ""}
                                                          onChange={this.handleChange}
                                                          helperText="Enter the Open Graph image URL here."
                                                          variant="outlined"
                                                          fullWidth
                                                        />
                                                      </div>
                                                      <div className="form-group col-md-12 col-lg-12 col-xxl-12">
                                                        <MutextField
                                                          id="canonicalUrl"
                                                          name="canonicalUrl"
                                                          type="url"
                                                          label="Canonical URL"
                                                          value={currentSeoPageData.canonical_url || ""}
                                                          onChange={this.handleChange}
                                                          helperText="Enter the canonical URL here."
                                                          variant="outlined"
                                                          fullWidth
                                                        />
                                                      </div>
                                                      <div className="col-lg-12">
                                                        <h6
                                                          style={{
                                                            color: "#526484",
                                                          }}
                                                        >
                                                          Schema JSON
                                                        </h6>
                                                      </div>
                                                      <div className="col-lg-12">
                                                        <TextareaAutosize
                                                          maxRows={12}
                                                          name="schema_json"
                                                          id="schema_json"
                                                          aria-label="Schema JSON"
                                                          value={currentSeoPageData.schema_json || ""}
                                                          onChange={this.handleChange}
                                                          style={{
                                                            width: "100%",
                                                            minHeight: "200px",
                                                            borderColor:
                                                              this.state.schemaJsonError !== ""
                                                                ? "#e85347"
                                                                : "rgba(0, 0, 0, 0.125)",
                                                            borderRadius: "4px",
                                                            padding: "15px",
                                                            fontFamily: "monospace",
                                                            whiteSpace: "pre-wrap",
                                                          }}
                                                        />
                                                        {this.state.schemaJsonError && (
                                                          <div style={{ color: "#e85347", marginTop: "6px" }}>
                                                            {this.state.schemaJsonError}
                                                          </div>
                                                        )}
                                                      </div>
                                                      <div className="form-group col-md-12 col-lg-6 col-xxl-6">
                                                        <MutextField
                                                          id="og_title"
                                                          name="og_title"
                                                          type="text"
                                                          label="OG Title"
                                                          value={currentSeoPageData.og_title || ""}
                                                          onChange={this.handleChange}
                                                          variant="outlined"
                                                          fullWidth
                                                        />
                                                      </div>
                                                      <div className="form-group col-md-12 col-lg-6 col-xxl-6">
                                                        <MutextField
                                                          id="og_description"
                                                          name="og_description"
                                                          type="text"
                                                          label="OG Description"
                                                          value={currentSeoPageData.og_description || ""}
                                                          onChange={this.handleChange}
                                                          variant="outlined"
                                                          fullWidth
                                                        />
                                                      </div>
                                                      <div className="form-group col-md-12 col-lg-6 col-xxl-6">
                                                        <MutextField
                                                          id="twitter_card"
                                                          name="twitter_card"
                                                          select
                                                          label="Twitter Card"
                                                          value={currentSeoPageData.twitter_card || "summary_large_image"}
                                                          onChange={this.handleChange}
                                                          SelectProps={{
                                                            native: true,
                                                          }}
                                                          variant="outlined"
                                                          fullWidth
                                                        >
                                                          <option value="summary_large_image">summary_large_image</option>
                                                          <option value="summary">summary</option>
                                                        </MutextField>
                                                      </div>
                                                      <div className="form-group col-md-12 col-lg-6 col-xxl-6">
                                                        <MutextField
                                                          id="schema_type"
                                                          name="schema_type"
                                                          type="text"
                                                          label="Schema Type"
                                                          value={currentSeoPageData.schema_type || ""}
                                                          onChange={this.handleChange}
                                                          helperText="Enter Schema.org type, e.g. Article, Product, RealEstateAgent"
                                                          inputProps={{ maxLength: 50 }}
                                                          variant="outlined"
                                                          fullWidth
                                                        />
                                                      </div>
                                                      <div className="form-group col-md-12 col-lg-12 col-xxl-12">
                                                        <MutextField
                                                          id="robots"
                                                          name="robots"
                                                          type="text"
                                                          label="Robots"
                                                          value={currentSeoPageData.robots || "index, follow"}
                                                          onChange={this.handleChange}
                                                          helperText="Example: index, follow"
                                                          variant="outlined"
                                                          fullWidth
                                                        />
                                                      </div>
                                                      <div className="form-group col-md-12 col-lg-12 col-xxl-12">
                                                        <MutextField
                                                          id="keywords_text"
                                                          name="keywords_text"
                                                          type="text"
                                                          label="Keywords (comma separated)"
                                                          value={seoKeywordsText}
                                                          onChange={this.handleChange}
                                                          variant="outlined"
                                                          fullWidth
                                                        />
                                                      </div>
                                                      <div className="col-lg-12">
                                                        <h6
                                                          style={{
                                                            color: "#526484",
                                                          }}
                                                        >
                                                          Content Summary
                                                        </h6>
                                                      </div>
                                                      <div className="col-lg-12">
                                                        <TextareaAutosize
                                                          maxrows={4}
                                                          name="content_summary"
                                                          id="content_summary"
                                                          aria-label=""
                                                          placeholder=""
                                                          value={currentSeoPageData.content_summary || ""}
                                                          onChange={this.handleChange}
                                                          style={{
                                                            width: "100%",
                                                            height: "100px",
                                                            borderColor:
                                                              "rgba(0, 0, 0, 0.125)",
                                                            borderRadius: "4px",
                                                            padding: "15px",
                                                          }}
                                                          variant="outlined"
                                                        />
                                                      </div>
                                                      <div className="form-group col-md-12 col-lg-12 col-xxl-12">
                                                        <FormControlLabel
                                                          style={{
                                                            marginBottom: "0px",
                                                            color: "#526484",
                                                          }}
                                                          control={
                                                            <Checkbox
                                                              checked={
                                                                this.state
                                                                  .robotsIndex
                                                              }
                                                              onChange={
                                                                this
                                                                  .handleChange
                                                              }
                                                              name="robotsIndex"
                                                              color="primary"
                                                            />
                                                          }
                                                          label="Allow search engines to index and follow this page"
                                                        />
                                                      </div>
                                                      <div
                                                        className="form-group col-md-12 col-lg-12"
                                                        style={{
                                                          marginTop: "20px",
                                                          paddingLeft: "0px",
                                                          textAlign: "right",
                                                        }}
                                                      >
                                                        <button
                                                          type="button"
                                                          className="btn btn-lg btn-primary"
                                                          onClick={
                                                            this
                                                              .saveSharelinkSEO
                                                          }
                                                          disabled={
                                                            this.state.disabled
                                                          }
                                                        >
                                                          <em className="icon ni ni-note-add"></em>
                                                          {"  "} &nbsp;  Save
                                                          Links
                                                        </button>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              ) : null}
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    </div>

                                    <div className="tab-pane" id="tab-8">
                                      <div className="row">
                                        <div
                                          className="col-lg-12 details"
                                          style={{ paddingLeft: "0px" }}
                                        >
                                          <div className="imagelibrary col-md-12 col-lg-12 col-xxl-12 col-sm-12 pl-0">
                                            <div className="row g-gs">
                                              <div className="col-md-6 col-lg-6 col-xxl-6 col-sm-12">
                                                <h3>Update Image Library</h3>
                                              </div>
                                              <div className="col-md-6 col-lg-6 col-xxl-6 col-sm-12">
                                                <a
                                                  onClick={() =>
                                                    this.getImageUpload()
                                                  }
                                                  class="btn btn-dim btn-outline-primary text-right"
                                                  style={{
                                                    cursor: "pointer",
                                                    float: "right",
                                                  }}
                                                >
                                                  <em className="icon ni ni-upload"></em>{" "}
                                                  Upload Logo / Avatar / Banner
                                                </a>
                                              </div>
                                            </div>
                                          </div>

                                          <div className="col-md-12 pl-0">
                                            {this.state.showImageLoader ===
                                              true ? (
                                              <div className="card card-bordered mb-4">
                                                <div className="card-inner">
                                                  {this.state.formLoader ===
                                                    true ? (
                                                    FormLoader()
                                                  ) : (
                                                    <div className="row g-4">
                                                      <div className="col-md-12 pl-0">
                                                        <h5
                                                          style={{
                                                            color: "#526484",
                                                          }}
                                                        >
                                                          Upload New Image
                                                        </h5>
                                                      </div>
                                                      <div className="col-md-6">
                                                        <div className="form-group">
                                                          <div className="form-control-group">
                                                            <MutextField
                                                              required
                                                              id="edit_image_title"
                                                              name="edit_image_title"
                                                              type="text"
                                                              label="Title"
                                                              value={
                                                                this.state
                                                                  .edit_image_title
                                                              }
                                                              inputProps={{
                                                                maxLength: 64,
                                                              }}
                                                              onInput={(e) => {
                                                                e.target.value =
                                                                  e.target.value.replace(
                                                                    /[^a-zA-Z0-9 -_]/gi,
                                                                    "",
                                                                  );
                                                              }}
                                                              helperText="Title of the image."
                                                              autoFocus
                                                              onChange={
                                                                this
                                                                  .handleChange
                                                              }
                                                              variant="outlined"
                                                              fullWidth
                                                            />
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="col-md-6">
                                                        <div className="form-group">
                                                          <div className="form-control-group">
                                                            <MutextField
                                                              id="edit_images_type"
                                                              name="edit_images_type"
                                                              select
                                                              label="Image Type"
                                                              defaultValue={
                                                                this.state
                                                                  .edit_images_type
                                                              }
                                                              onChange={
                                                                this
                                                                  .handleChange
                                                              }
                                                              SelectProps={{
                                                                native: true,
                                                              }}
                                                              helperText=""
                                                              variant="outlined"
                                                              fullWidth
                                                            >
                                                              <option
                                                                key="sets100"
                                                                value="logo"
                                                              >
                                                                Logo
                                                              </option>
                                                              <option
                                                                key="sets101"
                                                                value="image"
                                                              >
                                                                Avatar
                                                              </option>
                                                              <option
                                                                key="sets103"
                                                                value="image2"
                                                              >
                                                                Avatar 2
                                                              </option>
                                                              <option
                                                                key="sets102"
                                                                value="banner"
                                                              >
                                                                {" "}
                                                                Banner{" "}
                                                              </option>
                                                              <option
                                                                key="sets104"
                                                                value="background_image"
                                                              >
                                                                Banner
                                                                Background
                                                              </option>
                                                              <option
                                                                key="sets105"
                                                                value="background_image2"
                                                              >
                                                                Carousel
                                                                Background
                                                              </option>
                                                            </MutextField>
                                                          </div>
                                                        </div>
                                                      </div>

                                                      <div className="col-md-12">
                                                        <div className="form-group">
                                                          <div className="form-label-group">
                                                            <label className="form-label">
                                                              Upload File
                                                              <sup> *</sup>
                                                            </label>
                                                          </div>
                                                          <div
                                                            className="form-control-group"
                                                            id="fileContainer"
                                                          >
                                                            <input
                                                              type="file"
                                                              id="edit_picture"
                                                              className="file-block"
                                                              name="edit_picture"
                                                              defaultValue={
                                                                this.state
                                                                  .edit_picture
                                                              }
                                                              accept=".png, .jpg, .jpeg"
                                                              onChange={
                                                                this
                                                                  .handleFileChange
                                                              }
                                                              style={{
                                                                color:
                                                                  "#526484",
                                                              }}
                                                              required
                                                            />
                                                            {edit_picture && (
                                                              <div
                                                                style={{
                                                                  margin:
                                                                    "15px 0 0 0",
                                                                  width:
                                                                    this.state
                                                                      .theme ==
                                                                    "1"
                                                                      ? "calc(100% + 32px)"
                                                                      : "100%",
                                                                  marginLeft:
                                                                    this.state
                                                                      .theme ==
                                                                    "1"
                                                                      ? "-16px"
                                                                      : "0",
                                                                  marginRight:
                                                                    this.state
                                                                      .theme ==
                                                                    "1"
                                                                      ? "-16px"
                                                                      : "0",
                                                                }}
                                                              >
                                                                <Cropper
                                                                  src={
                                                                    this.state
                                                                      .edit_picture
                                                                  }
                                                                  style={{
                                                                    // THEME 1: larger crop preview so the full-width avatar is easier to edit
                                                                    height:
                                                                      this.state
                                                                        .theme ==
                                                                      "1"
                                                                        ? 600
                                                                        : 400,
                                                                    width:
                                                                      "100%",
                                                                    filter: `brightness(${this.state.brightness}%)`,
                                                                  }}
                                                                  aspectRatio={this.calculateAspectRatio()}
                                                                  guides={true}
                                                                  zoomable={
                                                                    true
                                                                  }
                                                                  crop={
                                                                    this.onCrop
                                                                  }
                                                                  ref={
                                                                    this
                                                                      .cropperRef
                                                                  }
                                                                  rotatable={
                                                                    true
                                                                  }
                                                                  ready={
                                                                    this
                                                                      .handleReady
                                                                  }
                                                                />
                                                                <div
                                                                  style={{
                                                                    margin:
                                                                      "10px 0 10px 0",
                                                                  }}
                                                                >
                                                                  <p id="cropSize">
                                                                    No crop
                                                                    selected
                                                                  </p>
                                                                </div>
                                                                <div
                                                                  style={{
                                                                    display:
                                                                      "flex",
                                                                    alignItems:
                                                                      "center",
                                                                    gap: "5px",
                                                                  }}
                                                                >
                                                                  <Tooltip
                                                                    title="Zoom In"
                                                                    placement="top"
                                                                  >
                                                                    <a
                                                                      className="btn btn-icon btn-sm btn-primary"
                                                                      onClick={() =>
                                                                        this.handleZoomIn()
                                                                      }
                                                                    >
                                                                      <em
                                                                        className="icon ni ni-zoom-in"
                                                                        style={{
                                                                          color:
                                                                            "white",
                                                                        }}
                                                                      ></em>
                                                                    </a>
                                                                  </Tooltip>
                                                                  <Tooltip
                                                                    title="Zoom Out"
                                                                    placement="top"
                                                                  >
                                                                    <a
                                                                      className="btn btn-icon btn-sm btn-primary"
                                                                      onClick={() =>
                                                                        this.handleZoomOut()
                                                                      }
                                                                    >
                                                                      <em
                                                                        className="icon ni ni-zoom-out"
                                                                        style={{
                                                                          color:
                                                                            "white",
                                                                        }}
                                                                      ></em>
                                                                    </a>
                                                                  </Tooltip>
                                                                  <Tooltip
                                                                    title="Rotate Left"
                                                                    placement="top"
                                                                  >
                                                                    <a
                                                                      className="btn btn-icon btn-sm btn-primary"
                                                                      onClick={() =>
                                                                        this.rotateImage(
                                                                          -15,
                                                                        )
                                                                      }
                                                                    >
                                                                      <em
                                                                        className="icon ni ni-curve-up-left"
                                                                        style={{
                                                                          color:
                                                                            "white",
                                                                        }}
                                                                      ></em>
                                                                    </a>
                                                                  </Tooltip>
                                                                  <Tooltip
                                                                    title="Rotate Right"
                                                                    placement="top"
                                                                  >
                                                                    <a
                                                                      className="btn btn-icon btn-sm btn-primary"
                                                                      onClick={() =>
                                                                        this.rotateImage(
                                                                          15,
                                                                        )
                                                                      }
                                                                    >
                                                                      <em
                                                                        className="icon ni ni-curve-up-right"
                                                                        style={{
                                                                          color:
                                                                            "white",
                                                                        }}
                                                                      ></em>
                                                                    </a>
                                                                  </Tooltip>

                                                                  <Tooltip
                                                                    title="Flip Horizontal"
                                                                    placement="top"
                                                                  >
                                                                    <a
                                                                      className="btn btn-icon btn-sm btn-primary"
                                                                      onClick={() =>
                                                                        this.flipHorizontal()
                                                                      }
                                                                    >
                                                                      <em
                                                                        className="icon ni ni-swap"
                                                                        style={{
                                                                          color:
                                                                            "white",
                                                                        }}
                                                                      ></em>{" "}
                                                                    </a>
                                                                  </Tooltip>

                                                                  <Tooltip
                                                                    title="Flip Vertical"
                                                                    placement="top"
                                                                  >
                                                                    <a
                                                                      className="btn btn-icon btn-sm btn-primary"
                                                                      onClick={() =>
                                                                        this.flipVertical()
                                                                      }
                                                                    >
                                                                      <em
                                                                        className="icon ni ni-swap-v"
                                                                        style={{
                                                                          color:
                                                                            "white",
                                                                        }}
                                                                      ></em>{" "}
                                                                    </a>
                                                                  </Tooltip>
                                                                  <Tooltip
                                                                    title="Adjust Brightness"
                                                                    placement="top"
                                                                  >
                                                                    <a
                                                                      className="btn btn-icon btn-sm btn-primary"
                                                                      onClick={
                                                                        this
                                                                          .toggleBrightnessRange
                                                                      }
                                                                    >
                                                                      <em
                                                                        className="icon ni ni-sun-fill"
                                                                        style={{
                                                                          color:
                                                                            "white",
                                                                        }}
                                                                      ></em>
                                                                    </a>
                                                                  </Tooltip>
                                                                  {showBrightnessRange && (
                                                                    <input
                                                                      type="range"
                                                                      min="0"
                                                                      max="200"
                                                                      value={
                                                                        brightness
                                                                      }
                                                                      onChange={
                                                                        this
                                                                          .handleBrightnessChange
                                                                      }
                                                                      style={{
                                                                        width:
                                                                          "15%",
                                                                        cursor:
                                                                          "pointer",
                                                                      }}
                                                                    />
                                                                  )}
                                                                  <Tooltip
                                                                    title="Reset Crop"
                                                                    placement="top"
                                                                  >
                                                                    <a
                                                                      className="btn btn-icon btn-sm btn-danger"
                                                                      onClick={() =>
                                                                        this.handleResetCrop(
                                                                          15,
                                                                        )
                                                                      }
                                                                    >
                                                                      <em
                                                                        className="icon ni ni-reload-alt"
                                                                        style={{
                                                                          color:
                                                                            "white",
                                                                        }}
                                                                      ></em>
                                                                    </a>
                                                                  </Tooltip>
                                                                </div>
                                                                <div className="col-md-12 mt-3 p-0">
                                                                  <div className="example-alert">
                                                                    <div className="alert alert-light">
                                                                      <ul className="list">
                                                                        <li>
                                                                          Double-click
                                                                          on the
                                                                          image
                                                                          to
                                                                          drag
                                                                          it.
                                                                        </li>
                                                                        <li>
                                                                          Use
                                                                          the{" "}
                                                                          <b>
                                                                            <em className="icon ni ni-zoom-in"></em>
                                                                          </b>{" "}
                                                                          button
                                                                          to
                                                                          zoom
                                                                          in and
                                                                          the{" "}
                                                                          <b>
                                                                            <em className="icon ni ni-zoom-out"></em>
                                                                          </b>{" "}
                                                                          button
                                                                          to
                                                                          zoom
                                                                          out.
                                                                        </li>
                                                                        <li>
                                                                          Use
                                                                          the{" "}
                                                                          <b>
                                                                            <em className="icon ni ni-curve-up-left"></em>
                                                                          </b>{" "}
                                                                          icon
                                                                          to
                                                                          rotate
                                                                          left
                                                                          and
                                                                          the{" "}
                                                                          <b>
                                                                            <em className="icon ni ni-curve-up-right"></em>{" "}
                                                                          </b>
                                                                          icon
                                                                          to
                                                                          rotate
                                                                          right.
                                                                        </li>
                                                                        <li>
                                                                          Use
                                                                          the{" "}
                                                                          <b>
                                                                            <em className="icon ni ni-swap-v"></em>
                                                                          </b>{" "}
                                                                          icon
                                                                          to
                                                                          flip
                                                                          vertical
                                                                          and
                                                                          the{" "}
                                                                          <b>
                                                                            <em className="icon ni ni-swap"></em>{" "}
                                                                          </b>
                                                                          icon
                                                                          to
                                                                          flip
                                                                          horizontal.
                                                                        </li>
                                                                        <li>
                                                                          Use
                                                                          the{" "}
                                                                          <b>
                                                                            <em className="icon ni ni-reload-alt"></em>
                                                                          </b>{" "}
                                                                          button
                                                                          to
                                                                          reset
                                                                          the
                                                                          image
                                                                          and
                                                                          crop
                                                                          box.
                                                                        </li>
                                                                      </ul>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            )}
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="col-md-12 d-flex justify-content-end">
                                                        <button
                                                          type="button"
                                                          onClick={() =>
                                                            this.setState({
                                                              showImageLoader: false,
                                                            })
                                                          }
                                                          className="btn btn-light mr-2"
                                                        >
                                                          <em className="icon ni ni-cross-round"></em>
                                                          <span>
                                                            Cancel
                                                          </span>{" "}
                                                        </button>
                                                        <button
                                                          type="button"
                                                          onClick={() =>
                                                            this.saveNewImage()
                                                          }
                                                          className="btn btn-primary"
                                                          disabled={
                                                            this.state.disabled
                                                          }
                                                        >
                                                          <em className="icon ni ni-emails"></em>
                                                          <span>
                                                            Submit
                                                          </span>{" "}
                                                        </button>
                                                      </div>
                                                      <div className="col-md-12">
                                                        <div className="example-alert">
                                                          <div className="alert alert-light">
                                                            <ul className="list">
                                                              <li>
                                                                Accepted
                                                                Formats: PNG,
                                                                JPEG, JPG
                                                              </li>
                                                              <li>
                                                                Recommended
                                                                Size: 5MB
                                                              </li>
                                                               <li>
                                                                Recommended
                                                                Dimensions:
                                                                <b>
                                                                  {" "}
                                                                  Logo (W:200 x
                                                                  H:60) -
                                                                  Avatar (W:636
                                                                  x H:329) -
                                                                  Avatar2 (W:549
                                                                  x H:611) -
                                                                  Banner (W:1640
                                                                  x H:560) -
                                                                  Background
                                                                  Images (W:1920
                                                                  x H:1080)
                                                                </b>
                                                              </li>
                                                            </ul>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  )}
                                                </div>
                                              </div>
                                            ) : null}
                                          </div>

                                          <div
                                            className="col-md-12 col-lg-12"
                                            style={{ paddingLeft: "0px" }}
                                          >
                                            {this.state.getLogoErrorMessage !==
                                              "" ? (
                                              <div
                                                className="example-alert"
                                                style={{
                                                  marginBottom: "15px",
                                                  color: "#526484",
                                                }}
                                              >
                                                <div className="alert alert-pro alert-danger">
                                                  <div className="alert-text">
                                                    <h4
                                                      style={{
                                                        color: "#364a63",
                                                      }}
                                                    >
                                                      Error
                                                    </h4>
                                                    <p
                                                      style={{
                                                        color: "#364a63",
                                                      }}
                                                    >
                                                      {
                                                        this.state
                                                          .getLogoErrorMessage
                                                      }
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                            ) : null}
                                            {this.state.tableLoaderBlockLogo ===
                                              true ? (
                                              tableLoaderBlockImage()
                                            ) : (
                                              <>
                                                {this.state.logoData &&
                                                  this.state.logoData.length >
                                                  0 ? (
                                                  <div className="card card-bordered">
                                                    <div className="card-inner">
                                                      <div
                                                        className="row g-4"
                                                        style={{
                                                          padding: "0px",
                                                        }}
                                                      >
                                                        <div className="col-md-12 col-lg-12 col-xxl-12 col-sm-12">
                                                          <h5
                                                            style={{
                                                              marginBottom:
                                                                "10px",
                                                              color: "#526484",
                                                            }}
                                                          >
                                                            Select Logo
                                                          </h5>
                                                        </div>
                                                        {this.state.logoData
                                                          .slice(
                                                            (this.state
                                                              .currentPageLogo -
                                                              1) *
                                                            this.state
                                                              .avatarsPerPage,
                                                            this.state
                                                              .currentPageLogo *
                                                            this.state
                                                              .avatarsPerPage,
                                                          )
                                                          .map((image) => (
                                                            <div
                                                              className="col-lg-6 col-xl-4 col-12"
                                                              style={{
                                                                float: "left",
                                                              }}
                                                              key={`logo${image.id}`}
                                                            >
                                                              <div
                                                                className={this.setLogoClassMain(
                                                                  image.id,
                                                                )}
                                                              >
                                                                <div
                                                                  className="pricingTable-header"
                                                                  style={{
                                                                    padding:
                                                                      "15px",
                                                                    minHeight:
                                                                      "110px",
                                                                  }}
                                                                >
                                                                  <img
                                                                    style={{
                                                                      verticalAlign:
                                                                        "middle",
                                                                      display:
                                                                        "inline-block",
                                                                      height:
                                                                        "100%",
                                                                    }}
                                                                    src={`${APP_LIVE_URL}files_data/sharelinks/${image.picture}`}
                                                                    alt={`Logo ${image.id}`}
                                                                  />
                                                                </div>
                                                                <p className="text-dark">
                                                                  {
                                                                    image.image_title
                                                                  }
                                                                </p>
                                                                <a
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                    paddingLeft:
                                                                      "15px",
                                                                    paddingRight:
                                                                      "15px",
                                                                  }}
                                                                  className={this.setLogoClass(
                                                                    image.id,
                                                                  )}
                                                                  onClick={() =>
                                                                    this.setLogo(
                                                                      image.id,
                                                                    )
                                                                  }
                                                                >
                                                                  {this.state
                                                                    .selected_logo ===
                                                                    image.id ? (
                                                                    <em className="icon ni ni-done"></em>
                                                                  ) : null}{" "}
                                                                  Choose Logo
                                                                  <i className="fa fa-angle-right"></i>
                                                                </a>
                                                              </div>
                                                            </div>
                                                          ))}
                                                        {this.state.logoData
                                                          .length >
                                                          this.state
                                                            .avatarsPerPage ? (
                                                          <div
                                                            className="col-md-12 text-center mt-4"
                                                            style={{
                                                              color: "black",
                                                            }}
                                                          >
                                                            <span
                                                              style={{
                                                                cursor:
                                                                  this.state
                                                                    .currentPageLogo ===
                                                                    1
                                                                    ? "not-allowed"
                                                                    : "pointer",
                                                              }}
                                                              onClick={() =>
                                                                this.handlePageChange(
                                                                  "logo",
                                                                  "prev",
                                                                )
                                                              }
                                                              disabled={
                                                                this.state
                                                                  .currentPageLogo ===
                                                                1
                                                              }
                                                            >
                                                              <em
                                                                className="icon ni ni-back-ios"
                                                                style={{
                                                                  fontSize:
                                                                    "24px",
                                                                  marginRight:
                                                                    "20px",
                                                                }}
                                                              ></em>
                                                            </span>
                                                            <span
                                                              style={{
                                                                cursor:
                                                                  this.state
                                                                    .currentPageLogo ===
                                                                    Math.ceil(
                                                                      this.state
                                                                        .logoData
                                                                        .length /
                                                                      this.state
                                                                        .avatarsPerPage,
                                                                    )
                                                                    ? "not-allowed"
                                                                    : "pointer",
                                                              }}
                                                              onClick={() =>
                                                                this.handlePageChange(
                                                                  "logo",
                                                                  "next",
                                                                )
                                                              }
                                                              disabled={
                                                                this.state
                                                                  .currentPageLogo ===
                                                                Math.ceil(
                                                                  this.state
                                                                    .logoData
                                                                    .length /
                                                                  this.state
                                                                    .avatarsPerPage,
                                                                )
                                                              }
                                                            >
                                                              <em
                                                                className="icon ni ni-forward-ios"
                                                                style={{
                                                                  fontSize:
                                                                    "24px",
                                                                  marginLeft:
                                                                    "20px",
                                                                }}
                                                              ></em>
                                                            </span>
                                                          </div>
                                                        ) : null}
                                                      </div>
                                                    </div>
                                                  </div>
                                                ) : null}

                                                {this.state.avatarData &&
                                                  this.state.avatarData.length >
                                                  0 ? (
                                                  <div className="card card-bordered">
                                                    <div className="card-inner">
                                                      <div
                                                        className="row g-4"
                                                        style={{
                                                          padding: "0px",
                                                        }}
                                                      >
                                                        <div className="col-md-12 col-lg-12 col-xxl-12 col-sm-12">
                                                          <h5
                                                            style={{
                                                              marginBottom:
                                                                "10px",
                                                              color: "#526484",
                                                            }}
                                                          >
                                                            Select Avatar
                                                          </h5>
                                                        </div>
                                                        {this.state.avatarData
                                                          .slice(
                                                            (this.state
                                                              .currentPageAvatar -
                                                              1) *
                                                            this.state
                                                              .avatarsPerPage,
                                                            this.state
                                                              .currentPageAvatar *
                                                            this.state
                                                              .avatarsPerPage,
                                                          )
                                                          .map((avatar) => (
                                                            <div
                                                              className={
                                                                this.state
                                                                  .theme == "1"
                                                                  ? "col-12"
                                                                  : "col-lg-6 col-xl-4 col-12"
                                                              }
                                                              style={{
                                                                float: "left",
                                                              }}
                                                              key={`avatar${avatar.id}`}
                                                            >
                                                              <div
                                                                className={this.setAvatarClassMain(
                                                                  avatar.id,
                                                                )}
                                                              >
                                                                <div
                                                                  className="pricingTable-header"
                                                                  style={{
                                                                    minHeight:
                                                                      "150px",
                                                                    padding:
                                                                      "15px",
                                                                  }}
                                                                >
                                                                  <img
                                                                    style={{
                                                                      height:
                                                                        "150px",
                                                                    }}
                                                                    src={`${APP_LIVE_URL}files_data/sharelinks/${avatar.picture}`}
                                                                    alt={`Avatar ${avatar.id}`}
                                                                  />
                                                                </div>
                                                                <p className="text-dark">
                                                                  {
                                                                    avatar.image_title
                                                                  }
                                                                </p>
                                                                <a
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                    paddingLeft:
                                                                      "15px",
                                                                    paddingRight:
                                                                      "15px",
                                                                  }}
                                                                  className={this.setAvatarClass(
                                                                    avatar.id,
                                                                  )}
                                                                  onClick={() =>
                                                                    this.setAvatar(
                                                                      avatar.id,
                                                                    )
                                                                  }
                                                                >
                                                                  {this.state
                                                                    .selected_avatar ===
                                                                    avatar.id ? (
                                                                    <em className="icon ni ni-done"></em>
                                                                  ) : null}
                                                                  Choose Avatar{" "}
                                                                  <i className="fa fa-angle-right"></i>
                                                                </a>
                                                              </div>
                                                            </div>
                                                          ))}
                                                        {this.state.avatarData
                                                          .length >
                                                          this.state
                                                            .avatarsPerPage ? (
                                                          <div
                                                            className="col-md-12 text-center mt-4"
                                                            style={{
                                                              color: "black",
                                                            }}
                                                          >
                                                            <span
                                                              style={{
                                                                cursor:
                                                                  this.state
                                                                    .currentPageAvatar ===
                                                                    1
                                                                    ? "not-allowed"
                                                                    : "pointer",
                                                              }}
                                                              onClick={() =>
                                                                this.handlePageChange(
                                                                  "avatar",
                                                                  "prev",
                                                                )
                                                              }
                                                              disabled={
                                                                this.state
                                                                  .currentPageAvatar ===
                                                                1
                                                              }
                                                            >
                                                              <em
                                                                className="icon ni ni-back-ios"
                                                                style={{
                                                                  fontSize:
                                                                    "24px",
                                                                  marginRight:
                                                                    "20px",
                                                                }}
                                                              ></em>
                                                            </span>
                                                            <span
                                                              style={{
                                                                cursor:
                                                                  this.state
                                                                    .currentPageAvatar ===
                                                                    Math.ceil(
                                                                      this.state
                                                                        .avatarData
                                                                        .length /
                                                                      this.state
                                                                        .avatarsPerPage,
                                                                    )
                                                                    ? "not-allowed"
                                                                    : "pointer",
                                                              }}
                                                              onClick={() =>
                                                                this.handlePageChange(
                                                                  "avatar",
                                                                  "next",
                                                                )
                                                              }
                                                              disabled={
                                                                this.state
                                                                  .currentPageAvatar ===
                                                                Math.ceil(
                                                                  this.state
                                                                    .avatarData
                                                                    .length /
                                                                  this.state
                                                                    .avatarsPerPage,
                                                                )
                                                              }
                                                            >
                                                              <em
                                                                className="icon ni ni-forward-ios"
                                                                style={{
                                                                  fontSize:
                                                                    "24px",
                                                                  marginLeft:
                                                                    "20px",
                                                                }}
                                                              ></em>
                                                            </span>
                                                          </div>
                                                        ) : null}
                                                      </div>
                                                    </div>
                                                  </div>
                                                ) : null}

                                                {this.state.avatarData2 &&
                                                  this.state.avatarData2.length >
                                                  0 ? (
                                                  <div className="card card-bordered">
                                                    <div className="card-inner">
                                                      <div
                                                        className="row g-4"
                                                        style={{
                                                          padding: "0px",
                                                        }}
                                                      >
                                                        <div className="col-md-12 col-lg-12 col-xxl-12 col-sm-12">
                                                          <h5
                                                            style={{
                                                              marginBottom:
                                                                "10px",
                                                              color: "#526484",
                                                            }}
                                                          >
                                                            Select Avatar 2
                                                          </h5>
                                                        </div>
                                                        {this.state.avatarData2
                                                          .slice(
                                                            (this.state
                                                              .currentPageAvatar2 -
                                                              1) *
                                                            this.state
                                                              .avatarsPerPage,
                                                            this.state
                                                              .currentPageAvatar2 *
                                                            this.state
                                                              .avatarsPerPage,
                                                          )
                                                          .map((avatar) => (
                                                            <div
                                                              className="col-lg-6 col-xl-4 col-12"
                                                              style={{
                                                                float: "left",
                                                              }}
                                                              key={`avatar2${avatar.id}`}
                                                            >
                                                              <div
                                                                className={this.setAvatar2ClassMain(
                                                                  avatar.id,
                                                                )}
                                                              >
                                                                <div
                                                                  className="pricingTable-header"
                                                                  style={{
                                                                    minHeight:
                                                                      "150px",
                                                                    padding:
                                                                      "15px",
                                                                  }}
                                                                >
                                                                  <img
                                                                    style={{
                                                                      height:
                                                                        "150px",
                                                                    }}
                                                                    src={`${APP_LIVE_URL}files_data/sharelinks/${avatar.picture}`}
                                                                    alt={`Avatar 2 ${avatar.id}`}
                                                                  />
                                                                </div>
                                                                <p className="text-dark">
                                                                  {
                                                                    avatar.image_title
                                                                  }
                                                                </p>
                                                                <a
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                    paddingLeft:
                                                                      "15px",
                                                                    paddingRight:
                                                                      "15px",
                                                                  }}
                                                                  className={this.setAvatar2Class(
                                                                    avatar.id,
                                                                  )}
                                                                  onClick={() =>
                                                                    this.setAvatar2(
                                                                      avatar.id,
                                                                    )
                                                                  }
                                                                >
                                                                  {this.state
                                                                    .selected_avatar2 ===
                                                                    avatar.id ? (
                                                                    <em className="icon ni ni-done"></em>
                                                                  ) : null}
                                                                  Choose Avatar
                                                                  <i className="fa fa-angle-right"></i>
                                                                </a>
                                                              </div>
                                                            </div>
                                                          ))}
                                                        {this.state.avatarData2
                                                          .length >
                                                          this.state
                                                            .avatarsPerPage ? (
                                                          <div
                                                            className="col-md-12 text-center mt-4"
                                                            style={{
                                                              color: "black",
                                                            }}
                                                          >
                                                            <span
                                                              style={{
                                                                cursor:
                                                                  this.state
                                                                    .currentPageAvatar2 ===
                                                                    1
                                                                    ? "not-allowed"
                                                                    : "pointer",
                                                              }}
                                                              onClick={() =>
                                                                this.handlePageChange(
                                                                  "avatar2",
                                                                  "prev",
                                                                )
                                                              }
                                                              disabled={
                                                                this.state
                                                                  .currentPageAvatar2 ===
                                                                1
                                                              }
                                                            >
                                                              <em
                                                                className="icon ni ni-back-ios"
                                                                style={{
                                                                  fontSize:
                                                                    "24px",
                                                                  marginRight:
                                                                    "20px",
                                                                }}
                                                              ></em>
                                                            </span>
                                                            <span
                                                              style={{
                                                                cursor:
                                                                  this.state
                                                                    .currentPageAvatar2 ===
                                                                    Math.ceil(
                                                                      this.state
                                                                        .avatarData2
                                                                        .length /
                                                                      this.state
                                                                        .avatarsPerPage,
                                                                    )
                                                                    ? "not-allowed"
                                                                    : "pointer",
                                                              }}
                                                              onClick={() =>
                                                                this.handlePageChange(
                                                                  "avatar2",
                                                                  "next",
                                                                )
                                                              }
                                                              disabled={
                                                                this.state
                                                                  .currentPageAvatar2 ===
                                                                Math.ceil(
                                                                  this.state
                                                                    .avatarData2
                                                                    .length /
                                                                  this.state
                                                                    .avatarsPerPage,
                                                                )
                                                              }
                                                            >
                                                              <em
                                                                className="icon ni ni-forward-ios"
                                                                style={{
                                                                  fontSize:
                                                                    "24px",
                                                                  marginLeft:
                                                                    "20px",
                                                                }}
                                                              ></em>
                                                            </span>
                                                          </div>
                                                        ) : null}
                                                      </div>
                                                    </div>
                                                  </div>
                                                ) : null}

                                                {this.state.bannerData &&
                                                  this.state.bannerData.length >
                                                  0 ? (
                                                  <div className="card card-bordered">
                                                    <div className="card-inner">
                                                      <div
                                                        className="row g-4"
                                                        style={{
                                                          padding: "0px",
                                                        }}
                                                      >
                                                        <div className="col-md-12 col-lg-12 col-xxl-12 col-sm-12">
                                                          <h5
                                                            style={{
                                                              marginBottom:
                                                                "10px",
                                                              color: "#526484",
                                                            }}
                                                          >
                                                            Select Banner
                                                          </h5>
                                                        </div>
                                                        {this.state.bannerData
                                                          .slice(
                                                            (this.state
                                                              .currentPageBanner -
                                                              1) *
                                                            this.state
                                                              .avatarsPerPage,
                                                            this.state
                                                              .currentPageBanner *
                                                            this.state
                                                              .avatarsPerPage,
                                                          )
                                                          .map((banner) => (
                                                            <div
                                                              className="col-lg-6 col-xl-4 col-12"
                                                              style={{
                                                                float: "left",
                                                              }}
                                                              key={`banner${banner.id}`}
                                                            >
                                                              <div
                                                                className={this.setBannerClassMain(
                                                                  banner.id,
                                                                )}
                                                              >
                                                                <div
                                                                  className="pricingTable-header"
                                                                  style={{
                                                                    minHeight:
                                                                      "150px",
                                                                    padding:
                                                                      "15px",
                                                                  }}
                                                                >
                                                                  <img
                                                                    style={{
                                                                      height:
                                                                        "150px",
                                                                    }}
                                                                    src={`${APP_LIVE_URL}files_data/sharelinks/${banner.picture}`}
                                                                    alt={`Banner ${banner.id}`}
                                                                  />
                                                                </div>
                                                                <p className="text-dark">
                                                                  {
                                                                    banner.image_title
                                                                  }
                                                                </p>
                                                                <a
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                    paddingLeft:
                                                                      "15px",
                                                                    paddingRight:
                                                                      "15px",
                                                                  }}
                                                                  className={this.setBannerClass(
                                                                    banner.id,
                                                                  )}
                                                                  onClick={() =>
                                                                    this.setBanner(
                                                                      banner.id,
                                                                    )
                                                                  }
                                                                >
                                                                  {this.state
                                                                    .selected_banner ===
                                                                    banner.id ? (
                                                                    <>
                                                                      <em className="icon ni ni-done"></em>
                                                                      Selected — click to remove
                                                                    </>
                                                                  ) : (
                                                                    <>
                                                                      Choose Banner
                                                                      <i className="fa fa-angle-right"></i>
                                                                    </>
                                                                  )}
                                                                </a>
                                                              </div>
                                                            </div>
                                                          ))}
                                                        {this.state.bannerData
                                                          .length >
                                                          this.state
                                                            .avatarsPerPage ? (
                                                          <div
                                                            className="col-md-12 text-center mt-4"
                                                            style={{
                                                              color: "black",
                                                            }}
                                                          >
                                                            <span
                                                              style={{
                                                                cursor:
                                                                  this.state
                                                                    .currentPageBanner ===
                                                                    1
                                                                    ? "not-allowed"
                                                                    : "pointer",
                                                              }}
                                                              onClick={() =>
                                                                this.handlePageChange(
                                                                  "banner",
                                                                  "prev",
                                                                )
                                                              }
                                                              disabled={
                                                                this.state
                                                                  .currentPageBanner ===
                                                                1
                                                              }
                                                            >
                                                              <em
                                                                className="icon ni ni-back-ios"
                                                                style={{
                                                                  fontSize:
                                                                    "24px",
                                                                  marginRight:
                                                                    "20px",
                                                                }}
                                                              ></em>
                                                            </span>
                                                            <span
                                                              style={{
                                                                cursor:
                                                                  this.state
                                                                    .currentPageBanner ===
                                                                    Math.ceil(
                                                                      this.state
                                                                        .bannerData
                                                                        .length /
                                                                      this.state
                                                                        .avatarsPerPage,
                                                                    )
                                                                    ? "not-allowed"
                                                                    : "pointer",
                                                              }}
                                                              onClick={() =>
                                                                this.handlePageChange(
                                                                  "banner",
                                                                  "next",
                                                                )
                                                              }
                                                              disabled={
                                                                this.state
                                                                  .currentPageBanner ===
                                                                Math.ceil(
                                                                  this.state
                                                                    .bannerData
                                                                    .length /
                                                                  this.state
                                                                    .avatarsPerPage,
                                                                )
                                                              }
                                                            >
                                                              <em
                                                                className="icon ni ni-forward-ios"
                                                                style={{
                                                                  fontSize:
                                                                    "24px",
                                                                  marginLeft:
                                                                    "20px",
                                                                }}
                                                              ></em>
                                                            </span>
                                                          </div>
                                                        ) : null}
                                                      </div>
                                                    </div>
                                                  </div>
                                                ) : null}

                                                {this.state
                                                  .backgroundImageData &&
                                                  this.state.backgroundImageData
                                                    .length > 0 ? (
                                                  <div className="card card-bordered">
                                                    <div className="card-inner">
                                                      <div
                                                        className="row g-4"
                                                        style={{
                                                          padding: "0px",
                                                        }}
                                                      >
                                                        <div className="col-md-12 col-lg-12 col-xxl-12 col-sm-12">
                                                          <h5
                                                            style={{
                                                              marginBottom:
                                                                "10px",
                                                              color: "#526484",
                                                            }}
                                                          >
                                                            Select Background
                                                            Image
                                                          </h5>
                                                        </div>
                                                        {this.state.backgroundImageData
                                                          .slice(
                                                            (this.state
                                                              .currentPageBackgroundImage -
                                                              1) *
                                                            this.state
                                                              .avatarsPerPage,
                                                            this.state
                                                              .currentPageBackgroundImage *
                                                            this.state
                                                              .avatarsPerPage,
                                                          )
                                                          .map((bgImage) => (
                                                            <div
                                                              className="col-md-4 col-lg-4 col-xxl-4 col-sm-6"
                                                              style={{
                                                                float: "left",
                                                              }}
                                                              key={`bgImage${bgImage.id}`}
                                                            >
                                                              <div
                                                                className={this.setBackgroundImageClassMain(
                                                                  bgImage.id,
                                                                )}
                                                              >
                                                                <div
                                                                  className="pricingTable-header"
                                                                  style={{
                                                                    minHeight:
                                                                      "150px",
                                                                    padding:
                                                                      "15px",
                                                                  }}
                                                                >
                                                                  <img
                                                                    style={{
                                                                      height:
                                                                        "150px",
                                                                    }}
                                                                    src={`${APP_LIVE_URL}files_data/sharelinks/${bgImage.picture}`}
                                                                    alt={`Background Image ${bgImage.id}`}
                                                                  />
                                                                </div>
                                                                <p className="text-dark">
                                                                  {
                                                                    bgImage.image_title
                                                                  }
                                                                </p>
                                                                <a
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                    paddingLeft:
                                                                      "15px",
                                                                    paddingRight:
                                                                      "15px",
                                                                  }}
                                                                  className={this.setBackgroundImageClass(
                                                                    bgImage.id,
                                                                  )}
                                                                  onClick={() =>
                                                                    this.setBackgroundImage(
                                                                      bgImage.id,
                                                                    )
                                                                  }
                                                                >
                                                                  {this.state
                                                                    .selected_background_image ===
                                                                    bgImage.id ? (
                                                                    <em className="icon ni ni-done"></em>
                                                                  ) : null}
                                                                  Choose Image
                                                                  <i className="fa fa-angle-right"></i>
                                                                </a>
                                                              </div>
                                                            </div>
                                                          ))}
                                                        {this.state
                                                          .backgroundImageData
                                                          .length >
                                                          this.state
                                                            .avatarsPerPage ? (
                                                          <div
                                                            className="col-md-12 text-center mt-4"
                                                            style={{
                                                              color: "black",
                                                            }}
                                                          >
                                                            <span
                                                              style={{
                                                                cursor:
                                                                  this.state
                                                                    .currentPageBackgroundImage ===
                                                                    1
                                                                    ? "not-allowed"
                                                                    : "pointer",
                                                              }}
                                                              onClick={() =>
                                                                this.handlePageChange(
                                                                  "backgroundImage",
                                                                  "prev",
                                                                )
                                                              }
                                                              disabled={
                                                                this.state
                                                                  .currentPageBackgroundImage ===
                                                                1
                                                              }
                                                            >
                                                              <em
                                                                className="icon ni ni-back-ios"
                                                                style={{
                                                                  fontSize:
                                                                    "24px",
                                                                  marginRight:
                                                                    "20px",
                                                                }}
                                                              ></em>
                                                            </span>
                                                            <span
                                                              style={{
                                                                cursor:
                                                                  this.state
                                                                    .currentPageBackgroundImage ===
                                                                    Math.ceil(
                                                                      this.state
                                                                        .backgroundImageData
                                                                        .length /
                                                                      this.state
                                                                        .avatarsPerPage,
                                                                    )
                                                                    ? "not-allowed"
                                                                    : "pointer",
                                                              }}
                                                              onClick={() =>
                                                                this.handlePageChange(
                                                                  "backgroundImage",
                                                                  "next",
                                                                )
                                                              }
                                                              disabled={
                                                                this.state
                                                                  .currentPageBackgroundImage ===
                                                                Math.ceil(
                                                                  this.state
                                                                    .backgroundImageData
                                                                    .length /
                                                                  this.state
                                                                    .avatarsPerPage,
                                                                )
                                                              }
                                                            >
                                                              <em
                                                                className="icon ni ni-forward-ios"
                                                                style={{
                                                                  fontSize:
                                                                    "24px",
                                                                  marginLeft:
                                                                    "20px",
                                                                }}
                                                              ></em>
                                                            </span>
                                                          </div>
                                                        ) : null}
                                                      </div>
                                                    </div>
                                                  </div>
                                                ) : null}
                                                {this.state
                                                  .backgroundImage2Data &&
                                                  this.state.backgroundImage2Data
                                                    .length > 0 ? (
                                                  <div className="card card-bordered">
                                                    <div className="card-inner">
                                                      <div
                                                        className="row g-4"
                                                        style={{
                                                          padding: "0px",
                                                        }}
                                                      >
                                                        <div className="col-md-12 col-lg-12 col-xxl-12 col-sm-12">
                                                          <h5
                                                            style={{
                                                              marginBottom:
                                                                "10px",
                                                              color: "#526484",
                                                            }}
                                                          >
                                                            Select Background
                                                            Image 2
                                                          </h5>
                                                        </div>
                                                        {this.state.backgroundImage2Data
                                                          .slice(
                                                            (this.state
                                                              .currentPageBackgroundImage2 -
                                                              1) *
                                                            this.state
                                                              .avatarsPerPage,
                                                            this.state
                                                              .currentPageBackgroundImage2 *
                                                            this.state
                                                              .avatarsPerPage,
                                                          )
                                                          .map((bgImage2) => (
                                                            <div
                                                              className="col-md-4 col-lg-4 col-xxl-4 col-sm-6"
                                                              style={{
                                                                float: "left",
                                                              }}
                                                              key={`bgImage2${bgImage2.id}`}
                                                            >
                                                              <div
                                                                className={this.setBackgroundImage2ClassMain(
                                                                  bgImage2.id,
                                                                )}
                                                              >
                                                                <div
                                                                  className="pricingTable-header"
                                                                  style={{
                                                                    minHeight:
                                                                      "150px",
                                                                    padding:
                                                                      "15px",
                                                                  }}
                                                                >
                                                                  <img
                                                                    style={{
                                                                      height:
                                                                        "150px",
                                                                    }}
                                                                    src={`${APP_LIVE_URL}files_data/sharelinks/${bgImage2.picture}`}
                                                                    alt={`Background Image 2 ${bgImage2.id}`}
                                                                  />
                                                                </div>
                                                                <p className="text-dark">
                                                                  {
                                                                    bgImage2.image_title
                                                                  }
                                                                </p>
                                                                <a
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                    paddingLeft:
                                                                      "15px",
                                                                    paddingRight:
                                                                      "15px",
                                                                  }}
                                                                  className={this.setBackgroundImage2Class(
                                                                    bgImage2.id,
                                                                  )}
                                                                  onClick={() =>
                                                                    this.setBackgroundImage2(
                                                                      bgImage2.id,
                                                                    )
                                                                  }
                                                                >
                                                                  {this.state
                                                                    .selected_background_image2 ===
                                                                    bgImage2.id ? (
                                                                    <em className="icon ni ni-done"></em>
                                                                  ) : null}
                                                                  Choose Image
                                                                  <i className="fa fa-angle-right"></i>
                                                                </a>
                                                              </div>
                                                            </div>
                                                          ))}
                                                        {this.state
                                                          .backgroundImage2Data
                                                          .length >
                                                          this.state
                                                            .avatarsPerPage ? (
                                                          <div
                                                            className="col-md-12 text-center mt-4"
                                                            style={{
                                                              color: "black",
                                                            }}
                                                          >
                                                            <span
                                                              style={{
                                                                cursor:
                                                                  this.state
                                                                    .currentPageBackgroundImage2 ===
                                                                    1
                                                                    ? "not-allowed"
                                                                    : "pointer",
                                                              }}
                                                              onClick={() =>
                                                                this.handlePageChange(
                                                                  "backgroundImage2",
                                                                  "prev",
                                                                )
                                                              }
                                                              disabled={
                                                                this.state
                                                                  .currentPageBackgroundImage2 ===
                                                                1
                                                              }
                                                            >
                                                              <em
                                                                className="icon ni ni-back-ios"
                                                                style={{
                                                                  fontSize:
                                                                    "24px",
                                                                  marginRight:
                                                                    "20px",
                                                                }}
                                                              ></em>
                                                            </span>
                                                            <span
                                                              style={{
                                                                cursor:
                                                                  this.state
                                                                    .currentPageBackgroundImage2 ===
                                                                    Math.ceil(
                                                                      this.state
                                                                        .backgroundImage2Data
                                                                        .length /
                                                                      this.state
                                                                        .avatarsPerPage,
                                                                    )
                                                                    ? "not-allowed"
                                                                    : "pointer",
                                                              }}
                                                              onClick={() =>
                                                                this.handlePageChange(
                                                                  "backgroundImage2",
                                                                  "next",
                                                                )
                                                              }
                                                              disabled={
                                                                this.state
                                                                  .currentPageBackgroundImage2 ===
                                                                Math.ceil(
                                                                  this.state
                                                                    .backgroundImage2Data
                                                                    .length /
                                                                  this.state
                                                                    .avatarsPerPage,
                                                                )
                                                              }
                                                            >
                                                              <em
                                                                className="icon ni ni-forward-ios"
                                                                style={{
                                                                  fontSize:
                                                                    "24px",
                                                                  marginLeft:
                                                                    "20px",
                                                                }}
                                                              ></em>
                                                            </span>
                                                          </div>
                                                        ) : null}
                                                      </div>
                                                    </div>
                                                  </div>
                                                ) : null}
                                                <div
                                                  className="form-group col-12 d-flex flex-column flex-lg-row justify-content-between mt-3"
                                                >
                                                  <a
                                                    href={
                                                      this.state.complete_link
                                                    }
                                                    style={{ zIndex: "100" }}
                                                    target="_blank"
                                                    className="btn btn-outline-primary p-2 mb-2 mb-lg-0"
                                                  >
                                                    Preview{" "}
                                                    {
                                                      localization.sharelinkPage
                                                        .label_single
                                                    }
                                                  </a>
                                                  {this.state.logoData &&
                                                    this.state.logoData.length >
                                                    0 &&
                                                    this.state.avatarData &&
                                                    this.state.avatarData.length >
                                                    0 &&
                                                    this.state.bannerData &&
                                                    this.state.bannerData.length >
                                                    0 ? (
                                                    <button
                                                      type="button"
                                                      className="btn btn-lg btn-primary"
                                                      onClick={
                                                        this.saveSharelinkLogos
                                                      }
                                                      disabled={
                                                        this.state.disabled
                                                      }
                                                    >
                                                      <em className="icon ni ni-note-add"></em>
                                                      {"  "}Save
                                                    </button>
                                                  ) : null}
                                                </div>
                                              </>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="tab-pane" id="tab-9">
                                      <div className="row">
                                        <div
                                          className="col-lg-12 col-md-12 col-xl-12 details"
                                          style={{
                                            marginLeft: "0px",
                                          }}
                                        >
                                          <h3>Other Settings</h3>
                                          {this.state.tableLoaderBlockSEO ===
                                            true ? (
                                            tableLoaderSimple()
                                          ) : (
                                            <>
                                              {this.state.getSeoErrorMessage !==
                                                "" ? (
                                                <div
                                                  className="example-alert"
                                                  style={{
                                                    marginBottom: "15px",
                                                    color: "#526484",
                                                  }}
                                                >
                                                  <div className="alert alert-pro alert-danger">
                                                    <div className="alert-text">
                                                      <h4
                                                        style={{
                                                          color: "#364a63",
                                                        }}
                                                      >
                                                        Error
                                                      </h4>
                                                      <p
                                                        style={{
                                                          color: "#364a63",
                                                        }}
                                                      >
                                                        {
                                                          this.state
                                                            .getSeoErrorMessage
                                                        }
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                              ) : null}
                                              {this.state.getSeoErrorMessage ===
                                                "" ? (
                                                <div className="card card-bordered">
                                                  <div className="card-inner">
                                                    <div className="row g-4">
                                                      <div className="col-lg-12">
                                                        <div
                                                          style={{
                                                            background:
                                                              "#f5f5f5",
                                                            padding: "15px",
                                                            borderRadius: "4px",
                                                          }}
                                                        >
                                                          {/* Scrollable Fields Container */}
                                                          <div 
                                                            className="other-settings-fields-container"
                                                            style={{
                                                              maxHeight: "400px",
                                                              overflowY: "auto",
                                                              paddingRight: "10px",
                                                              marginBottom: "15px",
                                                            }}
                                                          >
                                                          {/* {Object.keys(
                                                            this.state
                                                              .other_settings,
                                                          ).map(
                                                            (
                                                              key,
                                                              index,
                                                              arr,
                                                            ) => {
                                                              const value =
                                                                this.state
                                                                  .other_settings[
                                                                key
                                                                ];

                                                              if (
                                                                typeof value ===
                                                                "object" &&
                                                                value !== null
                                                              ) {
                                                                return (
                                                                  <div
                                                                    key={key}
                                                                    style={{
                                                                      marginLeft:
                                                                        "20px",
                                                                    }}
                                                                  >
                                                                    <span
                                                                      style={{
                                                                        fontWeight:
                                                                          "bold",
                                                                        marginBottom:
                                                                          "10px",
                                                                        display:
                                                                          "block",
                                                                        color:
                                                                          "#000",
                                                                        fontSize:
                                                                          "16px",
                                                                      }}
                                                                    >
                                                                      {this.getReadableLabel(
                                                                        key,
                                                                      )}
                                                                    </span>
                                                                    {Object.keys(
                                                                      value,
                                                                    ).map(
                                                                      (
                                                                        subKey,
                                                                        subIndex,
                                                                        subArr,
                                                                      ) => {
                                                                        const isRedirectNavLink =
                                                                          subKey.startsWith(
                                                                            "redirect_nav_link",
                                                                          );
                                                                        return (
                                                                          <div
                                                                            key={`${key}.${subKey}`}
                                                                            style={{
                                                                              marginBottom:
                                                                                "10px",
                                                                              display:
                                                                                "flex",
                                                                              alignItems:
                                                                                "center",
                                                                              marginLeft:
                                                                                "20px",
                                                                            }}
                                                                          >
                                                                            <span
                                                                              style={{
                                                                                marginRight:
                                                                                  "10px",
                                                                                width:
                                                                                  "200px",
                                                                                fontWeight:
                                                                                  "bold",
                                                                                color:
                                                                                  "#526484",
                                                                              }}
                                                                            >
                                                                              {this.getReadableLabel(
                                                                                subKey,
                                                                                key,
                                                                              )}
                                                                              :
                                                                            </span>
                                                                            {isRedirectNavLink ? (
                                                                              <MutextField
                                                                                required
                                                                                name={`${key}.${subKey}`}
                                                                                id={`${key}.${subKey}`}
                                                                                select
                                                                                value={
                                                                                  this
                                                                                    .state
                                                                                    .other_settings[
                                                                                  key
                                                                                  ][
                                                                                  subKey
                                                                                  ]
                                                                                }
                                                                                onChange={(
                                                                                  e,
                                                                                ) =>
                                                                                  this.handleChangeOtherSettings(
                                                                                    e,
                                                                                    `${key}.${subKey}`,
                                                                                  )
                                                                                }
                                                                                style={{
                                                                                  flexGrow: 1,
                                                                                  minWidth:
                                                                                    "300px",
                                                                                }}
                                                                                variant="outlined"
                                                                                size="small"
                                                                                SelectProps={{
                                                                                  native: true,
                                                                                }}
                                                                              >
                                                                                {this.getRedirectNavLinkOptions(
                                                                                  key,
                                                                                ).map(
                                                                                  (
                                                                                    option,
                                                                                  ) => (
                                                                                    <option
                                                                                      key={
                                                                                        option
                                                                                      }
                                                                                      value={
                                                                                        option
                                                                                      }
                                                                                    >
                                                                                      {
                                                                                        option
                                                                                      }
                                                                                    </option>
                                                                                  ),
                                                                                )}
                                                                              </MutextField>
                                                                            ) : (
                                                                              <MutextField
                                                                                required
                                                                                name={`${key}.${subKey}`}
                                                                                id={`${key}.${subKey}`}
                                                                                type="text"
                                                                                inputProps={{
                                                                                  maxLength: 100,
                                                                                }}
                                                                                value={
                                                                                  this
                                                                                    .state
                                                                                    .other_settings[
                                                                                  key
                                                                                  ][
                                                                                  subKey
                                                                                  ]
                                                                                }
                                                                                onChange={(
                                                                                  e,
                                                                                ) =>
                                                                                  this.handleChangeOtherSettings(
                                                                                    e,
                                                                                    `${key}.${subKey}`,
                                                                                  )
                                                                                }
                                                                                style={{
                                                                                  flexGrow: 1,
                                                                                  minWidth:
                                                                                    "300px",
                                                                                }}
                                                                                variant="outlined"
                                                                                size="small"
                                                                              />
                                                                            )}
                                                                            <span
                                                                              style={{
                                                                                marginLeft:
                                                                                  "10px",
                                                                              }}
                                                                            >
                                                                              {subIndex <
                                                                                subArr.length -
                                                                                1
                                                                                ? ","
                                                                                : ""}
                                                                            </span>
                                                                          </div>
                                                                        );
                                                                      },
                                                                    )}
                                                                    {index <
                                                                      arr.length -
                                                                      1 && (
                                                                        <span
                                                                          style={{
                                                                            marginTop:
                                                                              "15px",
                                                                            display:
                                                                              "block",
                                                                          }}
                                                                        >
                                                                          ---
                                                                        </span>
                                                                      )}
                                                                  </div>
                                                                );
                                                              } else {
                                                                return (
                                                                  <div
                                                                    key={key}
                                                                    style={{
                                                                      marginBottom:
                                                                        "10px",
                                                                      display:
                                                                        "flex",
                                                                      alignItems:
                                                                        "center",
                                                                      marginLeft:
                                                                        "20px",
                                                                    }}
                                                                  >
                                                                    <span
                                                                      style={{
                                                                        marginRight:
                                                                          "10px",
                                                                        minWidth:
                                                                          "200px",
                                                                        width:
                                                                          "200px",
                                                                        fontWeight:
                                                                          "bold",
                                                                        color:
                                                                          "#526484",
                                                                      }}
                                                                    >
                                                                      {this.getReadableLabel(
                                                                        key,
                                                                      )}
                                                                      :
                                                                    </span>
                                                                    <MutextField
                                                                      required
                                                                      name={key}
                                                                      id={key}
                                                                      type="text"
                                                                      inputProps={{
                                                                        maxLength: 100,
                                                                      }}
                                                                      value={
                                                                        value
                                                                      }
                                                                      onChange={(
                                                                        e,
                                                                      ) =>
                                                                        this.handleChangeOtherSettings(
                                                                          e,
                                                                          key,
                                                                        )
                                                                      }
                                                                      style={{
                                                                        flexGrow: 1,
                                                                      }}
                                                                      variant="outlined"
                                                                      size="small"
                                                                    />
                                                                  </div>
                                                                );
                                                              }
                                                            },
                                                          )} */}
                                                          <div className="col-12">
                                                            <div className="p-3 rounded" style={{ background: "#f5f5f5" }}>
                                                              {Object.keys(this.state.other_settings).map((key, index, arr) => {
                                                                const value = this.state.other_settings[key];

                                                                if (typeof value === "object" && value !== null) {
                                                                  return (
                                                                    <div key={key} className="ms-3 mb-3">
                                                                      <span className="d-block fw-bold mb-2" style={{ color: "#000", fontSize: "16px" }}>
                                                                        {this.getReadableLabel(key)}
                                                                      </span>

                                                                      {Object.keys(value).map((subKey, subIndex, subArr) => (
                                                                        <div key={`${key}.${subKey}`} className="mb-3">
                                                                          {/* Label */}
                                                                          <label
                                                                            htmlFor={`${key}.${subKey}`}
                                                                            className="form-label fw-bold text-secondary d-block mb-1"
                                                                          >
                                                                            {this.getReadableLabel(subKey, key)}:
                                                                          </label>

                                                                          {/* Input */}
                                                                          <MutextField
                                                                            required
                                                                            name={`${key}.${subKey}`}
                                                                            id={`${key}.${subKey}`}
                                                                            type="text"
                                                                            inputProps={{ maxLength: 100 }}
                                                                            value={this.state.other_settings[key][subKey]}
                                                                            onChange={(e) =>
                                                                              this.handleChangeOtherSettings(e, `${key}.${subKey}`)
                                                                            }
                                                                            className="form-control w-100 w-md-auto"
                                                                            style={{ minWidth: "100%", maxWidth: "500px" }}
                                                                            variant="outlined"
                                                                            size="small"
                                                                          />
                                                                        </div>
                                                                      ))}

                                                                      {index < arr.length - 1 && <hr className="my-3" />}
                                                                    </div>
                                                                  );
                                                                } else {
                                                                  return (
                                                                    <div key={key} className="mb-3">
                                                                      {/* Label */}
                                                                      <label
                                                                        htmlFor={key}
                                                                        className="form-label fw-bold text-secondary d-block mb-1"
                                                                      >
                                                                        {this.getReadableLabel(key)}:
                                                                      </label>

                                                                      {/* Input */}
                                                                      <MutextField
                                                                        required
                                                                        name={key}
                                                                        id={key}
                                                                        type="text"
                                                                        inputProps={{ maxLength: 100 }}
                                                                        value={value}
                                                                        onChange={(e) => this.handleChangeOtherSettings(e, key)}
                                                                        className="form-control w-100 w-md-auto"
                                                                        style={{ minWidth: "100%", maxWidth: "500px" }}
                                                                        variant="outlined"
                                                                        size="small"
                                                                      />
                                                                    </div>
                                                                  );
                                                                }
                                                              })}
                                                            </div>
                                                          </div>
                                                          {/* End Scrollable Fields Container */}
                                                          </div>

                                                          {/* Save Actions - Always Visible */}
                                                          <div className="form-group col-12 d-flex flex-column flex-lg-row justify-content-between mt-3"
                                                            style={{
                                                              borderTop: "1px solid #e5e9f2",
                                                              paddingTop: "15px",
                                                              background: "#fff",
                                                            }}
                                                          >
                                                            {/* Preview Button */}
                                                            <a
                                                              href={this.state.complete_link}
                                                              target="_blank"
                                                              rel="noopener noreferrer"
                                                              className="btn btn-outline-primary p-2 mb-2 mb-lg-0"
                                                              style={{ zIndex: 100 }}
                                                            >
                                                              Preview {localization.sharelinkPage.label_single}
                                                            </a>

                                                            {/* Save Button */}
                                                            <button
                                                              type="button"
                                                              className="btn btn-lg btn-primary"
                                                              onClick={this.saveSharelinkOtherSettings}
                                                              disabled={this.state.disabled}
                                                            >
                                                              <em className="icon ni ni-note-add"></em>{" "}
                                                              Save
                                                            </button>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              ) : null}
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="tab-pane" id="tab-10">
                                      <div className="row">
                                        <div
                                          className="col-lg-12 col-md-12 col-xl-12 details"
                                          style={{
                                            marginLeft: "0px",
                                          }}
                                        >
                                          <h3>Testimonials</h3>
                                          {this.state.tableLoaderBlockSEO ===
                                            true ? (
                                            tableLoaderSimple()
                                          ) : (
                                            <>
                                              {this.state.getSeoErrorMessage !==
                                                "" ? (
                                                <div
                                                  className="example-alert"
                                                  style={{
                                                    marginBottom: "15px",
                                                    color: "#526484",
                                                  }}
                                                >
                                                  <div className="alert alert-pro alert-danger">
                                                    <div className="alert-text">
                                                      <h4
                                                        style={{
                                                          color: "#364a63",
                                                        }}
                                                      >
                                                        Error
                                                      </h4>
                                                      <p
                                                        style={{
                                                          color: "#364a63",
                                                        }}
                                                      >
                                                        {
                                                          this.state
                                                            .getSeoErrorMessage
                                                        }
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                              ) : null}
                                              {this.state.getSeoErrorMessage ===
                                                "" ? (
                                                <div className="card card-bordered">
                                                  <div className="card-inner">
                                                    <div className="row g-4">
                                                      <div className="col-lg-12">
                                                        {!this.state
                                                          .isAddingTestimonial && (
                                                            <div className="col-lg-12 text-right">
                                                              <button
                                                                type="button"
                                                                className="btn btn-primary"
                                                                onClick={
                                                                  this
                                                                    .addTestimonial
                                                                }
                                                              >
                                                                Add Testimonial
                                                              </button>
                                                            </div>
                                                          )}
                                                        {this.state
                                                          .isAddingTestimonial && (
                                                            <div className="testimonial-form">
                                                              <div className="form-group col-md-12 col-lg-12 col-xxl-12">
                                                                <MutextField
                                                                  id="testimonial_name"
                                                                  name="testimonial_name"
                                                                  type="text"
                                                                  label="Name"
                                                                  inputProps={{
                                                                    maxLength: 100,
                                                                  }}
                                                                  value={
                                                                    this.state
                                                                      .testimonial_name
                                                                  }
                                                                  onChange={(e) =>
                                                                    this.setState(
                                                                      {
                                                                        testimonial_name:
                                                                          e.target
                                                                            .value,
                                                                      },
                                                                    )
                                                                  }
                                                                  helperText="Enter the name here"
                                                                  variant="outlined"
                                                                  fullWidth
                                                                  maxLength={100}
                                                                  error={
                                                                    !!this.state
                                                                      .testimonialErrors
                                                                      .nameError
                                                                  }
                                                                />
                                                              </div>
                                                              <div className="form-group col-md-12 col-lg-12 col-xxl-12">
                                                                <MutextField
                                                                  id="testimonial_title"
                                                                  name="testimonial_title"
                                                                  type="text"
                                                                  label="Title"
                                                                  inputProps={{
                                                                    maxLength: 100,
                                                                  }}
                                                                  value={
                                                                    this.state
                                                                      .testimonial_title
                                                                  }
                                                                  onChange={(e) =>
                                                                    this.setState(
                                                                      {
                                                                        testimonial_title:
                                                                          e.target
                                                                            .value,
                                                                      },
                                                                    )
                                                                  }
                                                                  helperText="Enter the title here"
                                                                  variant="outlined"
                                                                  fullWidth
                                                                  maxLength={50}
                                                                  error={
                                                                    !!this.state
                                                                      .testimonialErrors
                                                                      .titleError
                                                                  }
                                                                />
                                                              </div>
                                                              <div className="col-lg-12">
                                                                <h6
                                                                  style={{
                                                                    color:
                                                                      "black",
                                                                  }}
                                                                >
                                                                  Comment
                                                                </h6>
                                                              </div>
                                                              <div className="col-lg-12">
                                                                <TextareaAutosize
                                                                  maxRows={4}
                                                                  name="testimonial_comment"
                                                                  id="testimonial_comment"
                                                                  value={
                                                                    this.state
                                                                      .testimonial_comment
                                                                  }
                                                                  onChange={(e) =>
                                                                    this.setState(
                                                                      {
                                                                        testimonial_comment:
                                                                          e.target
                                                                            .value,
                                                                      },
                                                                    )
                                                                  }
                                                                  style={{
                                                                    width: "100%",
                                                                    height:
                                                                      "100px",
                                                                    borderColor:
                                                                      "rgba(0, 0, 0, 0.125)",
                                                                    borderRadius:
                                                                      "4px",
                                                                    padding:
                                                                      "15px",
                                                                  }}
                                                                  error={
                                                                    !!this.state
                                                                      .testimonialErrors
                                                                      .commentError
                                                                  }
                                                                  maxLength={200}
                                                                />
                                                                {this.state
                                                                  .testimonialErrors
                                                                  .commentError && (
                                                                    <div
                                                                      style={{
                                                                        color:
                                                                          "red",
                                                                      }}
                                                                    >
                                                                      {
                                                                        this.state
                                                                          .testimonialErrors
                                                                          .commentError
                                                                      }
                                                                    </div>
                                                                  )}
                                                              </div>
                                                              <div className="form-group col-md-12 col-lg-12 col-xxl-12 d-flex justify-content-end mt-1 mb-2">
                                                                <input
                                                                  id="testimonial_image"
                                                                  type="file"
                                                                  accept="image/*"
                                                                  onChange={
                                                                    this
                                                                      .handleTestimonialImageChange
                                                                  }
                                                                  style={{
                                                                    display:
                                                                      "none",
                                                                  }}
                                                                />
                                                                {this.state.selectedImageName && (
                                                                  <span
                                                                    className="mr-2"
                                                                    style={{
                                                                      alignContent:
                                                                        "center",
                                                                      color:
                                                                        "black",
                                                                    }}
                                                                  >
                                                                    <strong>
                                                                      Selected
                                                                      File:
                                                                    </strong>{" "}
                                                                    {
                                                                      this.state.selectedImageName
                                                                    }
                                                                  </span>
                                                                )}
                                                                <button
                                                                  type="button"
                                                                  onClick={() => document.querySelector(
                                                                    'input[id="testimonial_image"]',
                                                                  ).click()
                                                                  }
                                                                  className="btn btn-dim btn-outline-primary customStyle_add_sharelink_testimonial_btns"
                                                                  style={{
                                                                    minWidth: "",
                                                                  }}
                                                                >
                                                                  <em className="icon ni ni-upload"></em>{" "}
                                                                  Upload Image
                                                                </button>
                                                              </div>
                                                              <div className="col-lg-12 d-flex justify-content-end">
                                                                <button
                                                                  type="button"
                                                                  className="btn btn-success customStyle_add_sharelink_testimonial_btns"
                                                                  onClick={
                                                                    this.saveTestimonial
                                                                  }
                                                                  disabled={
                                                                    this.state.save_testimonial_btn_disable
                                                                  }
                                                                >
                                                                  Save 
                                                                </button>
                                                              </div>
                                                            </div>
                                                          )}

                                                        {this.state.testimonials.length > 0 && (
                                                          <div
                                                            className="col-lg-12"
                                                            style={{
                                                              marginTop: "20px",
                                                            }}
                                                          >
                                                            <DataTable
                                                              columns={
                                                                this.state
                                                                  .columnTestimonials
                                                              }
                                                              tableData={this.getTableData()}
                                                              title="Testimonials"
                                                            />
                                                          </div>
                                                        )}
                                                      </div>

                                                      <div
                                                        className="form-group col-md-12 col-lg-12"
                                                        style={{
                                                          marginTop: "20px",
                                                          paddingLeft: "0px",
                                                          textAlign: "right",
                                                        }}
                                                      >
                                                        {this.state.testimonials
                                                          .length > 0 && (
                                                            <button
                                                              type="button"
                                                              className="btn btn-lg btn-primary"
                                                              onClick={
                                                                this
                                                                  .saveSharelinkTestimonials
                                                              }
                                                              disabled={
                                                                this.state
                                                                  .disabled
                                                              }
                                                            >
                                                              <em className="icon ni ni-note-add"></em>
                                                              {"  "}Save
                                                              Testimonial Settings
                                                            </button>
                                                          )}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              ) : null}
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
                {/* DETAIL MODAL End */}

              {/* Contact Logs MODAL Start */}
              <div className="modal fade" tabIndex="-1" id="modalContactLogs">
                <div
                  className="modal-dialog  modal-xl modal-dialog-top new_modal_width"
                  role="document"
                >
                  <div className="modal-content">
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-header">
                      <h5 className="modal-title">Contact Logs</h5>
                    </div>
                    <div className="modal-body">
                      <DataTableSmall
                        columns={this.state.columnContactLogs}
                        tableData={this.state.tableDataContactLogs}
                        title={`${localization.sharelinkPage.label_single} Contact Logs`}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Contact Logs MODAL End */}

              {/* Lead Logs MODAL Start */}
              <div className="modal fade" tabIndex="-1" id="modalLeadLogs">
                <div
                  className="modal-dialog  modal-xl modal-dialog-top new_modal_width"
                  role="document"
                >
                  <div className="modal-content">
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-header">
                      <h5 className="modal-title">Lead Logs</h5>
                    </div>
                    <div className="modal-body">
                      <DataTableSmall
                        columns={this.state.columnLeadLogs}
                        tableData={this.state.tableDataLeadLogs}
                        title={`${localization.sharelinkPage.label_single} Lead Logs`}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* Lead Logs MODAL End */}

              <div className="modal fade" tabIndex="-1" id="modalConfirm">
                <div
                  className="modal-dialog modal-dialog-top  modal-lg"
                  role="document"
                >
                  <div className="modal-content">
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-header">
                      <h5 className="modal-title">Connect Domain</h5>
                    </div>
                    <div className="modal-body">
                      <div className="form-group">
                        {this.state.available_domains.length > 0 ? (
                          <MutextField
                            id="domain_id"
                            name="domain_id"
                            select
                            label="Select Domain"
                            value={this.state.domain_id}
                            onChange={this.handleChange}
                            SelectProps={{
                              native: true,
                            }}
                            helperText={`Please select the domain to connect the ${localization.sharelinkPage.text_single}.`}
                            variant="outlined"
                            fullWidth
                          >
                            <option key="" value=""></option>
                            {this.state.available_domains.map((domains) => (
                              <option value={domains[0]}>{domains[2]}</option>
                            ))}
                          </MutextField>
                        ) : null}
                      </div>
                    </div>
                    <div
                      className="modal-footer bg-light"
                      style={{
                        float: "right",
                        textAlign: "right",
                        justifyContent: "flex-end",
                      }}
                    >
                      <a
                        href="#"
                        className="btn btn-danger"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        Cancel
                      </a>
                      {this.state.confirm_status !==
                        "This domain is already connected." ? (
                        <>
                          {this.state.btn_loader === true ? (
                            <button
                              className="btn btn-dim btn-primary"
                              disabled
                            >
                              <em className="icon ni ni-swap"></em> Connect
                              <div
                                className="spinner-grow spinner-grow-sm"
                                role="status"
                              >
                                <span className="sr-only">Loading...</span>
                              </div>
                            </button>
                          ) : (
                            <a
                              onClick={() => {
                                this.connectDomainSubmit();
                              }}
                              className="btn btn-primary"
                              style={{ color: "#fff" }}
                            >
                              Connect
                            </a>
                          )}
                        </>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Menu Component for Testimonials Actions */}
          <Menu
            id="testimonials-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl) && menuType === "testimonials"}
            onClose={this.handleMenuClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            getContentAnchorEl={null}
            disableAutoFocusItem
            disableEnforceFocus
            disableScrollLock
            PaperProps={{
              style: {
                minWidth: 150,
                width: "auto",
                fontSize: "12px",
                fontWeight: "500",
                color: "#526484",
                lineHeight: "1.3rem",
              },
            }}
          >
            <MenuItem
              onClick={() => {
                this.editTestimonial(selectedRowId);
                this.handleMenuClose();
              }}
            >
              <em className="icon ni ni-edit"></em>
              <span style={{ marginLeft: "8px" }}>Edit Testimonial</span>
            </MenuItem>
            <MenuItem
              onClick={() => {
                this.deleteTestimonial(selectedRowId);
                this.handleMenuClose();
              }}
            >
              <em className="icon ni ni-trash-empty"></em>
              <span style={{ marginLeft: "8px" }}>Delete Testimonial</span>
            </MenuItem>
          </Menu>

          {/* Menu Component for Sharelinks Actions */}
          <Menu
            id="sharelinks-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl) && menuType === "sharelinks"}
            onClose={this.handleMenuClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            getContentAnchorEl={null}
            disableAutoFocusItem
            disableEnforceFocus
            disableScrollLock
            PaperProps={{
              style: {
                minWidth: 150,
                width: "auto",
                fontSize: "12px",
                fontWeight: "500",
                color: "#526484",
                lineHeight: "1.3rem",
              },
            }}
          >
            {!this.isProtectedSharelink(selectedRowId) && (
              <MenuItem
                onClick={() => {
                  const value = selectedRowId;
                  const tableMeta = { rowData: this.state.selectedRowData };
                  this.showDetails(value, tableMeta);
                  this.handleMenuClose();
                }}
              >
                <em className="icon ni ni-edit"></em>
                <span style={{ marginLeft: "8px" }}>Edit</span>
              </MenuItem>
            )}
            <MenuItem
              onClick={() => {
                const value = selectedRowId;
                const tableMeta = { rowData: this.state.selectedRowData };
                this.connectDomain(value, tableMeta);
                this.handleMenuClose();
              }}
            >
              <em className="icon ni ni-link"></em>
              <span style={{ marginLeft: "8px" }}>
                {localization.sharelinkPage.label_single} Domain
              </span>
            </MenuItem>
            {this.state.selectedRowStatus !== "No" && (
              <MenuItem
                onClick={() => {
                  const value = selectedRowId;
                  const tableMeta = { rowData: this.state.selectedRowData };
                  this.contactLogs(value, tableMeta);
                  this.handleMenuClose();
                }}
              >
                <em className="icon ni ni-contact"></em>
                <span style={{ marginLeft: "8px" }}>Contact Logs</span>
              </MenuItem>
            )}
            {this.state.selectedRowStatus !== "No" && (
              <MenuItem
                onClick={() => {
                  const value = selectedRowId;
                  const tableMeta = { rowData: this.state.selectedRowData };
                  this.leadLogs(value, tableMeta);
                  this.handleMenuClose();
                }}
              >
                <em className="icon ni ni-growth"></em>
                <span style={{ marginLeft: "8px" }}>Lead Logs</span>
              </MenuItem>
            )}
            <MenuItem
              onClick={() => {
                const value = selectedRowId;
                const tableMeta = { rowData: this.state.selectedRowData };
                this.listSharelinkComment(value, tableMeta);
                this.handleMenuClose();
              }}
            >
              <em className="icon ni ni-edit"></em>
              <span style={{ marginLeft: "8px" }}>Email Logs</span>
            </MenuItem>
            {!this.isProtectedSharelink(selectedRowId) && (
              <MenuItem
                onClick={() => {
                  const value = selectedRowId;
                  this.handleMenuClose();
                  this.deleteSharelinkModal(value);
                }}
              >
                <em className="icon ni ni-trash"></em>
                <span style={{ marginLeft: "8px" }}>Delete</span>
              </MenuItem>
            )}
          </Menu>

          {/* Menu Component for Comments Actions */}
          <Menu
            id="comments-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl) && menuType === "comments"}
            onClose={this.handleMenuClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            getContentAnchorEl={null}
            disableAutoFocusItem
            disableEnforceFocus
            disableScrollLock
            PaperProps={{
              style: {
                minWidth: 150,
                width: "auto",
                fontSize: "12px",
                fontWeight: "500",
                color: "#526484",
                lineHeight: "1.3rem",
              },
            }}
          >
            <MenuItem
              onClick={() => {
                this.deleteCommentModal(selectedRowId);
                this.handleMenuClose();
              }}
            >
              <em className="icon ni ni-trash"></em>
              <span style={{ marginLeft: "8px" }}>Delete Comment</span>
            </MenuItem>
          </Menu>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Sharelink);
